var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1600",
    width: 705,
    height: 850,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1e3v1600h-1e3z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,885)",
    d: "m0 0 1 2h81l-1 6-5 11-1 3 16-1-7-14-1-5h85l-8 16-4 10-4 4-8 17-4 6-11 23-4 8-3-1-16-34v-3h-2l-10-21v-2l-19 1-3 3h-2l-2 6 7 2 7 5-5 9-10 15-10-5-3 4-10 21 2 6 3 6v2l12-2 6-4h2l9 11 7 8-1 4-11 7-9 3 3 10 1 5h2l11 22v5l2 1-13 29-4 9-9 18-3 8-2 3 62-1h122v479h-1e3v-478l30-1h21l65 1-10-21-8-16-14-29 2-8 13-26 8-15-1-4-7-6-6-9-4-10-1-5v-16l4-13 6-9 5-5-2-6-17-35v-2h81l-3 9-5 11h17l-8-16v-4h84l-2 6-7 13-3 7-2 3h-2l-3 9-11 21-8 16-5 9h-2l-8-16-3-7-8-16-9-19v-3h-20l-1 3-4 4v3l12 6-1 4-11 17-4 4-6-4h-4l-11 23 1 6 4 8h8l8-4h4l12 14 4 5-1 3-9 6-11 4h-2l4 9 12 23 4 10-2 7-7 14-4 9-6 14-4 9-4 8-2 5 82 1h69v7h-2l-3 13-4 10h-2l-2 9-2 5h-2l-3 9-4 10-4 7h-2l-1 5-7 8-8 7-7 8-5 4-7 8-8 7-5 5-3 2h-23l-31-3-7-2-10-1-1-1-7-1h-14l-9 4-11 7-9 4-5 1v2h-52l-10 2-3 3-4 10-5 2-1 2 13 2 11 2 24 2 34 3 17 1 5 1 45 2 24 3 38 2 30 1 13 1 75 2 51 1 30 2 75 2 87 1 22 1h50l87-2 32-1 59-1 37-4 1-1 48-4 10-2v-2l6-4-2-4v-3l-13-2h-13l-1 1-16 1-1-5-10-3v-2l-22-1-26-2-53-1v-2l-4-2-5-6-1-4-2-1-2-7-3-1-6-12-3-7-5-16-5-10-6-16-7-19-11-33v-3l3-1h20l65 1-13-28-10-21-8-16v-6l17-34 6-11v-2l-8-7-6-8-5-12-1-6v-11l3-12 5-10 7-8-1-5-17-35v-2h-2l-2 6-39 78h-3l-20-40-10-19-12-24v-3z",
    fill: "#FDFDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,129)",
    d: "m0 0h9l2 1v10l3 5 6 3-4 10-3 3-3 9h18l8-1 2 4-15 4-1 14v32l-6 2h-7l1 10v14l-3 13 1 15 1 7 4 5 12 5 20 10 7 7v2l5 2 4 4h3l1 10 3 1 4 6 2 7v10l-3 14-4 9-1 2h-2v6l-3 3-3-1-2 7-1 20-2 7-3-2-3 5-3 2v8l-2 7-2 6-3 2 3 2-8 1-2 4-6 2-3 12 1 6 3 5 4 11 7 10 6 4 2 4 5 2 4-2 1-16v-17l2 1v3h2l4 21 3 15v3h2l3 19 1 14 1 3 3 30 6 51 5 62 1 9v8l3 27 1 20 1 5 3 45 1 9 2 10 2 28 4 46 1 7 5 45 2 13 3 26 2 15 1 9 1 10 2 8 2 15v7l2 1 2 21 2 9 5 28 4 19 1 1-1-9-7-39-2-18-3-21-1-2-5-43-4-33-6-55-1-16-2-19-3-43-3-26-3-44-2-13-1-22-1-2-1-17-3-25v-11h-2l-7-66-5-42-2-16-2-15-1-21-5-29-2-10h2l3 6h2l5 11 2 5 5 8v3h2l2 6 2 1 5 10 6 18 6 25 5 23 7 37 3 16 2 8 2 14 2 9 2 17 1 3v-30l2 2 1 11 1 36 3 22 3 23 4 20 2 5h2l3 15v8h27l1 159 1-159h326v307l-36 1h-148l2-5 4-9 5-12 4-9 8-16 5-11 2-5-5-12-7-13v-3h-2l-5-13 1-3 11-4 9-6-1-4-9-10-5-6v-2l-8 5-3 1h-9l-6-12 2-6 10-21 2-1 8 4h2l14-21-3-3-10-5 2-6 5-4h19l10 21v2h2l9 20 8 17 2 1 2-6 8-17 7-13 8-16 4-6 2-1 3-9 8-15h-83l4 10 4 9h-17l1-6 5-10 1-4h-81l-1-1h-86l11 23 11 22 10 19 10 20v2h3l3-9 12-23 26-52h2l11 22 8 17-1 4-8 10-5 13-1 6v11l3 12 6 11 8 8 3 2-2 6-15 29-6 12v6l20 41 10 21v3h-88l7 21 7 20 6 17 9 22 3 8 3 9 4 9 5 10 4 4v4l3 1 2 5 5 6 2 1v2h53l44 3 4 1v2l5 1 5 2 1 5 16-2 1-1h13l11 2 2 1 3 5-1 3-4 3h-2v2l-10 3-48 4-1 1-37 4-59 1-69 2-50 1h-50l-22-1-87-1-75-2-30-2-91-2-35-1-13-1-48-2-20-1-24-3-45-2-5-1-42-3-17-2-16-1-22-4-2-1 1-3 5-1 3-10 4-4 10-2h42l10 1v-2l13-5 10-7 8-4 3-1h14l7 1 1 1 13 2 16 2 19 2h23l5-3 7-8 8-8h2l2-4 9-8 4-5 7-6 6-7 1-4h2l2-5 4-8 4-11 1-2h2l1-5 3-9h2l2-9 3-9 2-5h2v-4h2l2-12h2l2-10 4-16h2l1-10h2l2-15 1-4h2l2-14 4-17 2-5 8-36 6-29 8-46 7-40 9-64 3-21 6-57 2-21 1-1 5-58 2-26 3-32 3-15 1-12h2l1-15 3-10 1-7h2l2-12h2v-6l2-3 3-9 2-5h2l2-9 1-2h2l2-9 5-10 4-13v-39l-2-19-2-7-5-22-5-21-4-8-3-5-9-8-7-6-2-9-1-20-1-3-1-15v-25l5-6 15-6 39-13 12-5 8-5 4-5 3-7h2l1-12 3-13 3-3 15-2h6l-1-9-5-10-1-8 3-8 5-4z",
    fill: "#BA527F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(381,241)",
    d: "m0 0h2l11 14 6 7v2l3 1v3h2l3 5 9 12 10 13 6 9 4 11 2 10 2 4 2-1 1 7-2 2h3l2 5h-3l1 5h3l2 6 5 5 2 6 5 5 8 15 3 9 2 7-2 5 1 4 2 4-1 12-4 6-4 10-1 2 11 2v1l-14 2-4 9-4 1-1 6-2 10-1 2 2 5-3 5-1 12 1 16 2 50 1 69 1 8v36l1 14v15l1 9v16l1 16v15l2 26 2 48 1 26 1 4v13l2 13 1 23 1 26 3 23-1 15 1 6 2 34 3 24v11l1 10 1 21 2 18v11l1 9v8l2 18 1 3 3 45 2 9 2 30-1 6-5 1-4-1v-2l-8-1-4-3-8-1-2-4-6-4-5-5-2-3-1-8-2-5-2-7 1-2-3-15-1-28-3-9-3-30-3-9-2-1-2 5-2 7-3 14-2 19-3 12-1 10-2 9-4 24-3 12-4 20-4 15-2 10-5 10-3 1-1-11-2-5-6 1-5 9h-2l1 3-3 1-1-6h2l-1-5-8-4-4 1-4 2-5 1-5 3-12 6-5 2-7 2-26 3h-51l-10-3-10-6 1 7-7-1-9-3-3-2-9-2-9-3-4-1v-2l5-1v-2h-8-4l-4 1-8-2-9-1v2h7l14 3 19 6 7 5-2 1h-3l10 3 17 2 27 2 41 1 13 2 4 1v-1h28l1 2 12 1 30 1 23 2 2-7 2-1v4l9 1 3 3-2 6-4 1h-27l-91-2-35-1-13-1-48-2-20-1-24-3-45-2-5-1-42-3-17-2-16-1-22-4-2-1 1-3 5-1 3-10 4-4 10-2h42l10 1v-2l13-5 10-7 8-4 3-1h14l7 1 1 1 13 2 16 2 19 2h23l5-3 7-8 8-8h2l2-4 9-8 4-5 7-6 6-7 1-4h2l2-5 4-8 4-11 1-2h2l1-5 3-9h2l2-9 3-9 2-5h2v-4h2l2-12h2l2-10 4-16h2l1-10h2l2-15 1-4h2l2-14 4-17 2-5 8-36 6-29 8-46 7-40 9-64 3-21 6-57 2-21 1-1 5-58 2-26 3-32 3-15 1-12h2l1-15 3-10 1-7h2l2-12h2v-6l2-3 3-9 2-5h2l2-9 1-2h2l2-9 5-10 4-13v-39l-2-19-2-7-5-22-5-21-4-8-3-5-9-8-7-6-2-9-1-20-1-3-1-15v-25z",
    fill: "#9D244F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,482)",
    d: "m0 0h2l3 6h2l5 11 2 5 5 8v3h2l2 6 2 1 5 10 6 18 6 25 5 23 7 37 3 16 2 8 2 14 2 9 2 17 1 3v-30l2 2 1 11 1 36 3 22 3 23 4 20 2 5h2l3 15v8h27l1 159 1-159h326v307l-36 1h-148l2-5 4-9 5-12 4-9 8-16 5-11 2-5-5-12-7-13v-3h-2l-5-13 1-3 11-4 9-6-1-4-9-10-5-6v-2l-8 5-3 1h-9l-6-12 2-6 10-21 2-1 8 4h2l14-21-3-3-10-5 2-6 5-4h19l10 21v2h2l9 20 8 17 2 1 2-6 8-17 7-13 8-16 4-6 2-1 3-9 8-15h-83l4 10 4 9h-17l1-6 5-10 1-4h-81l-1-1h-86l11 23 11 22 10 19 10 20v2h3l3-9 12-23 26-52h2l11 22 8 17-1 4-8 10-5 13-1 6v11l3 12 6 11 8 8 3 2-2 6-15 29-6 12v6l20 41 10 21v3h-88l7 21 7 20 6 17 9 22 3 8 3 9 4 9 5 10 4 4-1 4-6-5-11-22-9-17-2-5-3-4-4-14-3-6-3-7-5-17-3-3-3-10-4-15-5-12-1-2h2l-3-8-3-7-2-11-2-1h2l-8-20v-7l-1-6h-3l-4-21-2-9-2-6-1-11-2-2-2-13-3-10-2-9-1-5-3-14-1-14-2-4-2-19-3-7-2-18-1-2-1-14-3-13-2-17-2-7-1-15-2-1-2-8v-8l-1-1-2-16-1-2-1-15-2-4-1-9-2-8-1-15-2-4-1-14-2-3-2-21-1-2-2-21-3-18-2-5-1-13-7-28-5-2-3 5-2 8-1 11 1 12-1 14v24l-1 8h-2l-7-66-5-42-2-16-2-15-1-21-5-29z",
    fill: "#E799BE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,814)",
    d: "m0 0h354l-1 13-7 50-6 33-8 46-7 34-7 31-4 13-4 20-1 3h-2l-2 16-1 3h-2l-1 10h-2l-2 13-4 13h-2l-2 12h-2v-3l-4 1h-65l-83-1 4-10 5-12 5-10 5-11 6-12 4-10-2-7-10-21-5-8-2-8 13-5 9-6-2-4-9-11-5-6-4 2-7 3h-8l-3-5-3-6 1-6 11-23 8 3 3 2 14-21 1-3-5-2-9-4 3-6 4-4h20l10 22 15 30 3 9 3-3 10-21 10-18 6-13h2l2-4 5-12 7-13h-84l4 10 4 8v2h-17l1-5 5-10 1-4-80-1 20 41-1 3h-2l-2 4-6 9-4 13v16l4 13 5 8 5 6 5 4-1 5-15 29-6 12-1 6 19 39 11 23 1 4h-116z",
    fill: "#EEC3C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(555,495)",
    d: "m0 0 2 3 4 18v3h2l3 19 1 14 1 3 3 30 6 51 5 62 1 9v8l3 27 1 20 1 5 3 45 1 9 2 10 2 28 4 46 1 7 5 45 2 13 3 26 2 15 1 9 1 10 2 8 2 15v7l2 1 2 21 2 9 5 28 4 19 1 1-1-9-7-39-2-18-3-21-1-2-5-43-4-33-6-55-1-16-2-19-3-43-3-26-3-44-2-13-1-22-1-2-1-17-3-25v-50l1-10-1-9v-6l1-5 3-9 3-5 6 2 4 17 3 12 1 14 2 4 3 18 2 21 2 10 1 13 2 3 1 14 2 4 1 16 3 12 1 7 1 1 1 15 2 9 1 9 1 2v7l3 9 3 19 2 11 2 12 2 10 1 14 2 8v8l3 10 1 3 2 19 2 2 1 16 3 12 1 5 4 17 2 5 1 10 2 2 2 16 2 3 4 25v3h3l2 9v6l5 10 2 5 1 6 3 13 4 7-1 5 3 5 5 14 2 9 3 10 3 3 5 17 3 7 5 12 3 9 2 3 2 5 9 17 5 10 7 13 4 3 4 2 2 5 5 6 2 1v2h53l44 3 4 1v2l5 1 3 1 1 5-35-1-26-1-27-3-10-3h-4l2 3 7 3 1 2-17-1-21-4-1-1h-7l8 3 7 3 16 5-4 2-25 5h-31l-14-4h-17l-14 2h-20l-12-5-11-9-10-10-10-13-12-20-6-12-3-5-3-9-6-16-9-33-10-48-6-38-6-39-3-23-1-1-5-40-4-43-2-19-3-39-3-46v-69l-1-37v-28l-1-26 1-14v-27l-1-13v-15l-1-8v-3-6l-1-6v-12l-3-11 3-1v2l2 1 1 5h2l3 11 3 4 2 7 2 6h2l1 2h2l6-6 1-7 2-7 3-30v-30z",
    fill: "#BA527F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(381,241)",
    d: "m0 0h2l11 14 6 7v2l3 1v3h2l3 5 9 12 10 13 6 9 4 11 3 19-1 6-5 5-4 2-3 12v16h2l5 5 3 9 8 8v2l5 2 3 2v9l1 5 3 1-1 9 1 8-1 10 3 1-6 2-7 7-4 8-4 1-3 10-3 5-1 10-3 6v5h-2l-2 9-2 6-6 35-3 14-1 8-1 1-5 41-4 41-4 51-1 19-2 10-2 16-3 26-3 31-3 38-2 32-1 7-2-4-1-4h-4l-1 4-1 3 2 2-1 6v5l5-4 2-4v8l-1 4v8l-3 14v7l-2 5v10l-1 6v8l-2 13-2 11v8l-2 4v13l-6 42-2 9-1 11-2 5-2 10-2 18-2 10-2 12h-2l1 6-2 6-2 9h-1l-2 13-2 1-3 15-4 10-3 13-4 9-2 7h-2v7l-6 14-9 18-4 2-23 1-5-1-15-9-4 1-13 6-7 1-5 2-19 1-38-1 2 2-6-1-15-2v2h7l14 3 19 6 7 5-2 1h-3l10 3 17 2 27 2 41 1 13 2 4 1v-1h28l1 2 12 1 30 1 23 2 2-7 2-1v4l9 1 3 3-2 6-4 1h-27l-91-2-35-1-13-1-48-2-20-1-24-3-45-2-5-1-42-3-17-2-16-1-22-4-2-1 1-3 5-1 3-10 4-4 10-2h42l10 1v-2l13-5 10-7 8-4 3-1h14l7 1 1 1 13 2 16 2 19 2h23l5-3 7-8 8-8h2l2-4 9-8 4-5 7-6 6-7 1-4h2l2-5 4-8 4-11 1-2h2l1-5 3-9h2l2-9 3-9 2-5h2v-4h2l2-12h2l2-10 4-16h2l1-10h2l2-15 1-4h2l2-14 4-17 2-5 8-36 6-29 8-46 7-40 9-64 3-21 6-57 2-21 1-1 5-58 2-26 3-32 3-15 1-12h2l1-15 3-10 1-7h2l2-12h2v-6l2-3 3-9 2-5h2l2-9 1-2h2l2-9 5-10 4-13v-39l-2-19-2-7-5-22-5-21-4-8-3-5-9-8-7-6-2-9-1-20-1-3-1-15v-25z",
    fill: "#7B193E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,814)",
    d: "m0 0h32v307l-36 1h-148l2-5 4-9 5-12 4-9 8-16 5-11 2-5-5-12-7-13v-3h-2l-5-13 1-3 11-4 9-6-1-4-9-10-5-6v-2l-8 5-3 1h-9l-6-12 2-6 10-21 2-1 8 4h2l14-21-3-3-10-5 2-6 5-4h19l10 21v2h2l9 20 8 17 2 1 2-6 8-17 7-13 8-16 4-6 2-1 3-9 8-15h-83l4 10 4 9h-17l1-6 5-10 1-4h-79v-1h166l2-5 11-23 11-22 10-18z",
    fill: "#E5EBDF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,174)",
    d: "m0 0 4 1-6 2-1 14v32l-6 2h-7l1 10v14l-3 13 1 15 1 7 4 5 12 5 20 10 7 7v2l5 2 4 4h3l1 10 3 1 4 6 2 7v10l-3 14-4 9-1 2h-2v6l-3 3-3-1-2 7-1 20-2 7-3-2-3 5-3 2v8l-2 7-2 6-3 2 3 2-8 1-2 4-6 2-3 12 1 6 3 5 4 11 7 10 6 4 2 4 5 2 4-2 1-16v-17l2 1v3h2l2 11-1 5h-2v32l-3 30-3 14-5 4-2 3-3-1v-2h-2l-4-7-2-8-3-5-1-8-3 1-2-9-2 1 3 11v16l1 7 1 2-1 6 1 8v16l1 12v26l-1 18 1 26v25l1 45v57l5 75 1 11 6 61 5 40 1 1 7 50 8 50 10 48 9 33 5 13 6 16 10 18 9 15 13 16 9 9 10 7 10 4h20l14-2h17l14 4h31l25-5 1-1-19-6-5-3-5-2v-1h8l6 2 16 3 16 1-8-4-2-4 8 1 7 2 27 3 52 2 9 1-1-4h2l1 5 16-2 1-1h13l11 2 2 1 3 5-1 3-4 3h-2v2l-10 3-48 4-1 1-37 4h-34v-1l30-1 31-3 13-3h9v-2l-8-1-3-5-7 1-4 5-9 2h-22v-6h2v-2l-6 1-17-3 2 3v5h-2l-2-4-3-1-1 3v-3l-11 3-1 1-19 3-14 1-11 1-29 1-18-1h-16v-2l-34 1h-51l-16-1-2 5h-6l1-8-9-1-14-2-45 1-11 1-3 1-22 2-12 3h-9l-11-2-14-4-11-3-1-4 2-2h13l15 6 15 4 8-1v-3l2-10 2-4 7-4h13l4 3 6 2 17 9 3 1h25l-3-9-2-24-4-16-3-15-2-7-2-10-4-23-2-11 5-1v2l2 1 6 12v4h2l7 17 3 5 3 9 7 15 5 10 2 5 2 4 4 4 3 5v2h2l2 6h5l3 1 4 1 1 8 1-2-1-3v-4l-1-14-2-7-1-1-2-12-8-20-4-17-8-28-2-5-3-15-3-11-1-9-3-9-2-9-1-1-2-14-2-6-9-54-7-50-1-16-1-2-2-23-2-18-4-45-2-20-5-70-5-104-3-66-2-79v-27l1-27-1-37 3-4h4l-7-2 4-3 3-6 2-12 2-6 2-10h2l1-14 1-3 6-4 9-3 15-3h3l2-4 3-2h3l3-21 1-17-4 1-4-8-4-10-9-7-10-1-6 1-6 4-5 2-1 5-2 2-2 8h-3l-2 10-4 7-1 4h-3l-1 2h-8l-10-5-4-4v-2h-2l-3-5-4-4-2-5-1-3-5-5-4-7-6-9-4-20v-12l-3-3-1-8h-3l-3-1-2-5-1-3h3l-2-5 1-3h7l9 2 3-1h8l2-4 10-3 5-3 7-3 5-4h3l2-6h2v-2l3-1h11l-1-3 3-12 1-16 1-10 1-4 9-4z",
    fill: "#D983AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(556,624)",
    d: "m0 0h1l1 17 3 5 1 16 2 12 1 18 2 9 1 6 1 9v14l1 8v12l1 2 1 11 1 3 1 14 2 15 2 18 1 2 1 18 3 17v5l1 3 2 17 1 18 2 13 1 11 1 5 3 34 2 20 1 5 2 12 1 1 1 14 2 3 1 12 3 20 3 18 3 14 3 21 8 35 2 11 6 20 3 12 11 33 9 17 10 13 20 20 11 7 3 2v2h7l4 1h7l13-2h11l10 4 7 3 16 5-4 2-25 5h-31l-14-4h-17l-14 2h-20l-12-5-11-9-10-10-10-13-12-20-6-12-3-5-3-9-6-16-9-33-10-48-6-38-6-39-4-33-3-39-3-36-1-19-1-5-1-38 1-7-2-13v-5l-1-5 1-8 1-3-1-19v-15l-1-20v-42l1-7v-27l1-4v-14l3-16h-2l1-4 6-1 3 2 1 5h2l1-2h2l1-9 3-4 1-10z",
    fill: "#9C244F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(250,888)",
    d: "m0 0 3 3 28 56 10 19 2 6-20 39-10 19-11 21-1 3h57l-2 12-2 10h-2l-1 10h-2l-2 13-4 13h-2l-2 12h-2v-3l-4 1h-65l-83-1 4-10 5-12 5-10 5-11 6-12 4-10-2-7-10-21-5-8-2-8 13-5 9-6-2-4-9-11-5-6-4 2-7 3h-8l-3-5-3-6 1-6 11-23 8 3 3 2 14-21 1-3-5-2-9-4 3-6 4-4h20l10 22 15 30 3 9 3-3 10-21 10-18 6-13h2l2-4 5-12z",
    fill: "#E5EBDF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,493)",
    d: "m0 0h1v56l1 42 3 80 2 39 4 82 4 59 2 24 1 9 4 43 2 18 2 23 1 5 1 14 7 49 6 36 4 22 2 8 1 8 2 6 4 16 3 15 2 5 3 16 3 9 7 25 4 14 4 12 3 6 2 12 2 3 2 17 1 6-1 5-2 1-1-9h-5l-6-2-2-3v-3h-2l-5-9-3-3-3-4-4-11-11-22-3-9-6-12-1-6h-2l-3-7-2-4v-4l-2-1-1-3-4 1v8l2 1 3 21 3 11 1 6 3 12 2 13 2 4 2 17 1 13 2 9h-17l-1-4-3-1-5-16-3-9-2-5 1-7h-2v-32h2l-1-5v-12-3-4l1-20 1-6-2-3v-17l-3-6-1-9-2-14-4-36-1-16-1-10-1-14-1-7-3-38-1-8-2-33-3-44-2-46-1-7-1-32-3-80-1-29-1-77v-33l-1-8 1-10-1-19-1-8-1-15-2-2 1-7 2-2h4l1 2 8-7 3-8 3-16h3z",
    fill: "#9D244F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(522,175)",
    d: "m0 0 6 2 2 2 1 14 3 6 2 9 9 4v3l4 2 9 6 12 2 14 4 2 1v2h8l7 3 8 3v2h2l3 6 1 3h2l-1 17-1 7v23l-2 6 1 13h-2l2 2 3-7 1-5h1l-1 10-7 8-8 6-4 5-3 6-1-3 3-6-4 2-3 3-2 8-3 8h2l-2 10-2 3 1 8-4 10-3 23-1 6-1 21-2 14-1 5 1 9 5 12 4 11 4 4 3 7 7 12 3 8 3 5 3 9 6 24 5 26 5 36 2 13-6-48-2-13-12-52-7-19-7-16 1-3 10 22 6 18 7 29 6 28 7 54 2 18 3 39 1 25 4 38 7 39v4l-3 1-3-9-4-26-3-19-2-17-1-36-1-11v28l-2 2-4-29-2-10-2-12-3-12-4-23-12-56-7-25-5-11-1-4-3-1-1-6h-2l-5-10-2-2-3-8-3-5-2-2-2-6h-2l4 15 4 26 1 19 2 17 5 39 8 72v11h2l3 31 1 5 1 17 1 2 1 22 2 13 4 56 2 14 3 43 2 19 3 36 5 46 3 22 5 43 2 9 2 14 2 18 7 39 1 10-3-2-4-19-5-28-2-11-2-19-1-1-4-28-1-2-1-16-2-10-3-22-2-20-3-23-3-27-1-7-3-37-2-22-1-17-2-10-1-7-3-45-1-5-1-20-2-19-1-16-2-21-4-50-8-68-1-13-1-3-2-20-1-13h-2l-5-21-2-11v-7h-2l-1-3v21l-1 11-5 3-6-3-1-4-4-2-5-4-7-12-4-11-2-4 2-12 4-4 4-2 2-4h5l-2-3 5-1-1-3h2l1-9 1-4v-5l5-5 2-3 2 2 2-6 1-20 3-8 1 2 4-1 1-8h2l3-10 3-9 1-6v-10l-3-9-2-4-4-1-1-10-3 1v-3l-5-2-5-5-8-7-16-7-5-3-8-3-5-6-2-15v-7l3-13v-19l-1-2 1-3 13-2-1-7v-25l1-11 1-2-2-1z",
    fill: "#F8CCDC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(381,241)",
    d: "m0 0h2l11 14 6 7v2l3 1v3h2l3 5 9 12 10 13 6 9 4 11 3 19-1 6-5 5-4 2-3 12v16h2l5 5 3 9 8 8v2l5 2 3 2v9l1 5 3 1-1 9 1 8-1 10 3 1-6 2-7 7-4 8-4 1-3 10-3 5-1 10-3 6v5h-2l-2 9-2 6-4 25-2-4-2 2-10-1-2 4-1 15-1 5-6 1-1 8-3 5v11l-2 8v9l-3 9-2 10v17l-2 5v13l-3 5v9l-2 9v11l-3 22-2 5 1 4v8l-2 3-1 26-1 8h-2l2 1-1 5-2 4v7l1 7-2 6h-2l1 6-2 5v5h-2l-1 9-2 19-2 6-3 21-1 9-1 7-3 13-2 12-1 9-2 8-2 9-1 5-2 15-4 18-2 11-2 5-1 8-4 18-4 17-1 9-2 3-3 12-2 9-5 18-2 9-2 2-3 11-1 2-2 10h-2l-1 7-6 16h-2l-1 6-5 14-2 2-2 9h-2l-3 9-7 10-3 7-5 5-11 9-3 2-1 4-5 1-2 2h-3l-1 5-5 4-2 5-6 5-6 3v3l-4 2-19 1-67-1h-12l34 4 7 1 23 2v2l2 2-6-1-15-2v2h7l14 3 19 6 7 5-2 1h-3l10 3 17 2 27 2 41 1 13 2 4 1v-1h28l1 2 12 1 30 1 23 2 2-7 2-1v4l9 1 3 3-2 6-4 1h-27l-91-2-35-1-13-1-48-2-20-1-24-3-45-2-5-1-42-3-17-2-16-1-22-4-2-1 1-3 5-1 3-10 4-4 10-2h42l10 1v-2l13-5 10-7 8-4 3-1h14l7 1 1 1 13 2 16 2 19 2h23l5-3 7-8 8-8h2l2-4 9-8 4-5 7-6 6-7 1-4h2l2-5 4-8 4-11 1-2h2l1-5 3-9h2l2-9 3-9 2-5h2v-4h2l2-12h2l2-10 4-16h2l1-10h2l2-15 1-4h2l2-14 4-17 2-5 8-36 6-29 8-46 7-40 9-64 3-21 6-57 2-21 1-1 5-58 2-26 3-32 3-15 1-12h2l1-15 3-10 1-7h2l2-12h2v-6l2-3 3-9 2-5h2l2-9 1-2h2l2-9 5-10 4-13v-39l-2-19-2-7-5-22-5-21-4-8-3-5-9-8-7-6-2-9-1-20-1-3-1-15v-25z",
    fill: "#732447"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,885)",
    d: "m0 0 1 2h81l-1 6-5 11-1 3 16-1-7-14-1-5h85l-8 16-4 10-4 4-8 17-4 6-11 23-4 8-3-1-16-34v-3h-2l-10-21v-2l-19 1-3 3h-2l-2 6 7 2 7 5-5 9-10 15-10-5-3 4-10 21 2 6 3 6v2l12-2 6-4h2l9 11 7 8-1 4-11 7-9 3 3 10 1 5h2l11 22v5l2 1-13 29-4 9-9 18-3 8-2 2h-17l-2 1-13-28-10-21-8-16v-6l17-34 6-11v-2l-8-7-6-8-5-12-1-6v-11l3-12 5-10 7-8-1-5-17-35v-2h-2l-2 6-39 78h-3l-20-40-10-19-12-24v-3z",
    fill: "#E6EADE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(84,887)",
    d: "m0 0h81l-3 9-5 11h17l-8-16v-4h84l-2 6-7 13-3 7-2 3h-2l-3 9-11 21-8 16-5 9h-2l-8-16-3-7-8-16-9-19v-3h-20l-1 3-4 4v3l12 6-1 4-11 17-4 4-6-4h-4l-11 23 1 6 4 8h8l8-4h4l12 14 4 5-1 3-9 6-11 4h-2l4 9 12 23 4 10-2 7-7 14-4 9-6 14-4 9-7 14h-18l-3-3-8-17-8-16-14-29 2-8 13-26 8-15-1-4-7-6-6-9-4-10-1-5v-16l4-13 6-9 5-5-2-6-17-35z",
    fill: "#E6EBDF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,814)",
    d: "m0 0 4 1 3 2v2l3 1 2 7 3 2 1 11 2 7 3 9 1 12v20l2 2 3 15 1 1v9l1 3-1 2 2 1 1 9 1 1 1 7 2 5 2 11 2 16 1 5-2 3h3v2h2l2 20 1 2 2 14 4 8 3 24h2l2 14h2l2 14 1 5v3l3 1 2 12 1 3-1 2 4 2 1 5 2 3 2 5 2 11 3 5 2 5 1 1v8h2l1 4 4 4 1 9 5 7 3 12 5 1v8h3v7l4 2 4 8 3 4 3 6 3 5v2h2l5 9v2h2l3 7 3 2v3h2l7 10 5 4 5 2v2l5 2 4 3h-16l-15-3-6-2-5-1h-20v-3l-4-1v-2l-5-2-6-10-6-8-4-7-5-5-4-8-4-5v-5h-2v-3h-2l-2-7-3-3-8-21-4-9-4-14-5-16-3-9-2-11-2-7-6-29-2-7-3-19-1-2-3-22-3-15-2-15-2-19-3-11-2-23-2-15-1-2-4-31-1-7v-18l-1-7v-23l-2-1 1-2 2-17v-10z",
    fill: "#9D244F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(427,519)",
    d: "m0 0 2 2-2 14-3 24v23l1 3 1 24v21l-2 39-1 3 1 12-2 11v18l-2 23-2 52-2 18-1 24-1 16-1 11-1 17-1 14-1 20-2 21-1 14-2 19-2 21-1 17-2 12-2 24-3 9-2 20v8l-3 15-2 9-4 15-2 4-2 8-3 13-3 5-5 16-5 10h-2l-1 5-4 7-3 8-3 3-3 8-3 3-4 9-5 7-5 10-4 2-1 4-6 8-3 1v3h-2l2-9 8-16 2-6 4-9 5-13 4-14 4-12 4-15 3-16 3-9 6-36 5-34 2-15 4-28 1-6 1-9 1-6 1-11 2-12 5-43 2-23 2-22 2-24 2-28 1-5 3-38 2-21 2-39 4-48v-12l2-21 4-43 4-36 5-24 1-8h2l1-7 4-8z",
    fill: "#BA5280"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,814)",
    d: "m0 0h239l-1 6-7 12-8 16-12 25-7 13-168 1-8-15-8-17-10-19-10-20z",
    fill: "#ED857C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(48,814)",
    d: "m0 0h239l-1 4-9 17-8 16-9 19-8 15-1 1h-168l-9-17-8-17-10-19-8-16z",
    fill: "#ED857C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,598)",
    d: "m0 0 6 2 4 17 3 12 1 14 2 4 3 18 2 21 2 10 1 13 2 3 1 14 2 4 1 16 3 12 1 7 1 1 1 15 2 9 1 9 1 2v7l3 9 3 19 2 11 2 12 2 10 1 14 2 8v8l3 10 1 3 2 19 2 2 1 16 3 12 1 5 4 17 2 5 1 10 2 2 2 16 2 3 4 25v3h3l2 9v6l5 10 2 5 1 6 3 13 4 7-1 5 3 5 5 14 2 9 3 10 3 3 5 17 3 7 5 12 3 9 2 3 2 5 9 17 5 10 7 13 4 3 4 2 2 5 5 6 2 1v2h53l44 3 4 1v2l5 1 3 1 1 5-35-1-26-1-27-3-10-3h-4l2 3 7 3 1 2-17-1v-1l8-1-7-4v-2l-6-2-6-5-5-7v-2h-2l-1-3-4-3-1-6h-2l-5-9v-2h-2l-6-10-3-6-6-10-2-1v-7h-3l-1-4v-4l-4-1-3-7-2-6-4-6-1-9-1-2-3-2v-4h-2l-1-8-3-4-1-4-3-7-1-7-3-7h-1l-2-7-2-1-1-5-2-12-2-1-4-20 1-2h-2l-2-6v-8h-2l-3-14-1-11-4-7-2-14-2-9v-13h-2v-2h-3l1-7-2-6-2-18-1-5-2-4v-7l-2-1-1-9-2-6v-9l-2-5-2-11-2-4v-23l-1-7-3-9-2-7v-11l-4-2-2-7-2-1v-2l-4-2-4 1v9l-2 20 1 7v16l1 14v11l4 28 1 10 2 10 2 18 1 12 3 11 2 21 4 25 3 15 1 10 2 10 3 17 2 6 6 29 2 6 2 9 6 21 4 11 4 13 5 11 4 11v2l3 1 1 7h2v3h2l2 6 3 3 2 5 4 6v2l3 1 5 8 8 11 3 6 4 2 1 2 3 1v3l11-1h9l5 1-4 2h-11l-13 2h-5l-5-5-8-7-6-6v-2h-2l-3-5-5-5-4-6v-2l-3-1-5-10-4-5-8-14-1-6 2-2h3l1 5h4l-5-15-2-1-2-9v-4h-2l-4-15-5-17-5-15-1-10-2-4-1-7-3-12-3-19-2-11v-6h-3l-1-19-2-12-3-3-2-16-6-45-6-63-2-10-1-2 1-6-1 5h-1l-2-10-2-32-3-26-3-44-2-13-1-22-1-2-1-17-3-25v-50l1-10-1-9v-6l1-5 3-9z",
    fill: "#BA5380"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,494)",
    d: "m0 0h1l1 14 1 58 5 114 2 41 1 18 2 42 4 53 4 43 4 46 2 20 2 15 3 27 1 3 2 19 2 10 3 22 1 1 1 13 4 15 1 12 5 25 6 21 2 12 2 1v8l2 6 4 15 3 6 2 12 3 4 4 9 1-1-2-8v-5l2 2 4 11 6 16 10 18 9 15 13 16 9 9 10 7 10 4h20l14-2h17l14 4h31l25-5 1-1-19-6-5-3-5-2v-1h8l6 2 16 3 16 1-8-4-2-4 8 1 7 2 27 3 52 2 9 1-1-4h2l1 5 16-2 1-1h13l11 2 2 1 3 5-1 3-4 3h-2v2l-10 3-48 4-1 1-37 4h-34v-1l30-1 31-3 13-3h9v-2l-8-1-3-5-7 1-4 5-9 2h-22v-6h2v-2l-6 1-17-3 2 3v5h-2l-2-4-3-1-1 3v-3l-11 3-1 1-19 3-14 1-11 1-29 1-18-1h-16v-2l-34 1h-51l-16-1-2 5h-6l1-8-9-1-14-2-45 1-11 1-3 1-22 2-12 3h-9l-11-2-14-4-11-3-1-4 2-2h13l15 6 15 4 8-1v-3l2-10 2-4 7-4h13l4 3 6 2 17 9 3 1h25l-3-9-2-24-4-16-3-15-2-7-2-10-4-23-2-11 5-1v2l2 1 6 12v4h2l7 17 3 5 3 9 7 15 5 10 2 5 2 4 4 4 3 5v2h2l2 6h5l3 1 4 1 1 8 1-2-1-3v-4l-1-14-2-7-1-1-2-12-8-20-4-17-8-28-2-5-3-15-3-11-1-9-3-9-2-9-1-1-2-14-2-6-9-54-7-50-1-16-1-2-2-23-2-18-4-45-2-20-5-70-5-104-3-66-2-79v-27z",
    fill: "#BA5380"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,732)",
    d: "m0 0 2 1v11l-4 63-3 67-3 51-2 27-4 37-6 43-5 26-3 19-2 5-2 14-3 9-6 19-2 9-2 5-2 9-2 2-4 13-5 10-4 11-4 8-8 14-5 7-2 4-5 4-1 3-3 3h-2l-1 4h-3v2h-2v3l-7 6h-2v2l-7 4-4 4-11 5-7 1-5 2-19 1-29-1-17-2-19-1-17-3-13-1-9-1 2-2h22l57 1 19-1 4-1v-2l-2-1 8-4h2l2-4h2l2-6 5-4 1-4 7-4 3-1 1-3 9-7h2l1-3 5-2 2-5 4-8 5-7 4-9h2l1-10 3-1 1-6 4-10 1-4h2l2-9 4-10 1-4h2l1-12h2v-5l3-7 2-4 5-21 2-5 3-14 2-7 1-1 2-15 5-18 3-16 1-5 2-6 4-23 2-11 1-10 2-4 2-13 3-15 1-8 3-13 1-7 3-23 1-9 2-4 2-19v-5l3-5 1-7 1-4-1-4 3-3 1-8-1-5 1-7 2-2 1-4-3-1 3-8 1-26z",
    fill: "#680523"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565 1e3)",
    d: "m0 0 5 2 3 10 4 7 4 2 1 7v5l2 1v2l4 10 2 7 2 10-1 2h2l5 17 2 10 2 2 1 10 2 2 1 6 2 5v6l4 1 1 8 3 5-1 6-1 2h2l4 6-1 9 1 5 3 1v6h2l2 7 1 5v4l4 10 7 14 3 7 1 3 2 1 3 7 3 6 5 3 2 4 3 3v3l5 5h3l2 1v2l2 1v3l3 1v2h5l2 3 3 1v2l3-1 7 5 6 3 1 3 9 1 6 1v2h-12l-6-2h-17l-14 2h-20l-12-5-11-9-10-10-10-13-12-20-6-12-3-5-3-9-6-16-9-33-5-23v-8l2-1 1-6h-2l-1-9-2-5v-3l1-3-2-19-2-8v-9l3-1-2-4-1-8-2-10 2-5v-25l2-3v2l3-3z",
    fill: "#820D32"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(83,887)",
    d: "m0 0 3 4 18 37-1 3h-2l-2 4-6 9-4 13v16l4 13 5 8 5 6 5 4-1 5-15 29-6 12-1 6 19 39 11 23 1 4h-116v-68h83l-13-25-12-22-13-25-4-7v-5l10-19z",
    fill: "#E4EADE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,814)",
    d: "m0 0h32v240h-67l1-6 19-37 20-38-1-6-10-20-10-19-20-40h-84l4 10 4 9h-17l1-6 5-10 1-4h-79v-1h166l2-5 11-23 11-22 10-18z",
    fill: "#EFC3C3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,888)",
    d: "m0 0h2l11 22 8 17-1 4-8 10-5 13-1 6v11l3 12 6 11 8 8 3 2-2 6-15 29-6 12v6l20 41 10 21v3h-88l1-2-6-13-6-20-8-32v-1h75l-13-24-30-56-1-2h2l3-9 12-23z",
    fill: "#E4EADE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(250,888)",
    d: "m0 0 3 3 28 56 10 19 2 6-20 39-10 19-12 23-5 1-17-35-15-30-8-18 8-16 15-28 5-11h2l2-4 5-12z",
    fill: "#A1D0C4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(933,888)",
    d: "m0 0h2l27 54 10 19 4 8-1 6-18 35-10 19-13 25h-4l-32-64-7-15-1-4 8-17 10-19 8-16 4-6 2-1 3-9z",
    fill: "#A1D0C4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,979)",
    d: "m0 0h2l9 11 7 8-1 4-11 7-9 3 3 10 1 5h2l11 22v5l2 1-13 29-4 9-9 18-3 8-2 2h-17l-2 1-13-28-10-21-8-16v-6l17-34 12-22 8-15 9 4h10l6-3z",
    fill: "#FDF6E7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(149,979)",
    d: "m0 0 4 2 11 13 4 5-1 3-9 6-11 4h-2l4 9 12 23 4 10-2 7-7 14-4 9-6 14-4 9-7 14h-18l-3-3-8-17-8-16-14-29 2-8 13-26 12-22 10-20 6 3 5 1h8l8-4z",
    fill: "#FDF6E7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,519)",
    d: "m0 0h1l3 19 1 14 1 3 3 30 6 51 5 62 1 9v8l3 27 1 20 1 5 3 45 1 9 2 10 2 28 4 46 1 7 5 45 2 13 3 26 2 15 1 9 1 10 2 8 2 15v7l2 1 2 21 2 9 5 28 4 19 1 1-1-9-7-39-2-18-3-21-1-2-5-43-4-33-6-55-1-16-2-19v-9l3-1 1 5-1 6h1l2 12 3 31 4 40 2 11 3 25 2 16 3 3 2 15v16h3l5 28 3 17 2 7 4 20 7 22 5 18v4h2l3 10 1 4 4 9 1 1v5h-4l-1-5-4 2-1 2 2 1 1 5 9 15 6 9 1 3 5 5 4 7 5 5v2h2l7 8 7 6 4 3 5 1-4 2-8-2-11-7-1-3-4-2-6-6-5-3-12-12-8-11-8-14-7-20-5-17-5-22-3-13-2-7-2-12-3-16-3-12-2-12-1-3-1-7-5-38-2-12-4-29-3-24-3-19-2-22-1-3-1-16-2-19-1-16-2-20-1-17-1-2-2-16-1-14-2-8-1-25-1-6v-13l-2-16-2-36v-9l-1-6-1-20-1-3-2-29-4-44-1-19-1-15-3-27z",
    fill: "#D881AB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(519,176)",
    d: "m0 0 4 1 1 6-1 3-1 13 2 12 2 9 1 7 3 5 1 5h2l1 5h2l6 8 4 10 4 9 1 5 3 7v9h-2v2h2l4 17 4 4v2h3l3 5v2h2l4 10 2 7 2 6v17l-1 9-1 4-2 5-2 8-2 4-2 10-4 10-2 7h-2l1 6-2 13-3 6h2v2h-2v3l-4 1v-2h-2v11l3 17-1 4-1-3v21l-1 11-5 3-6-3-1-4-4-2-5-4-7-12-4-11-2-4 2-12 4-4 4-2 2-4h5l-2-3 5-1-1-3h2l1-9 1-4v-5l5-5 2-3 2 2 2-6 1-20 3-8 1 2 4-1 1-8h2l3-10 3-9 1-6v-10l-3-9-2-4-4-1-1-10-3 1v-3l-5-2-5-5-8-7-16-7-5-3-8-3-5-6-2-15v-7l3-13v-19l-1-2 1-3 13-2-1-7v-25l1-11 1-2-2-1z",
    fill: "#EFA4C7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,1243)",
    d: "m0 0 3 1 5 12 2 7 3 3 5 9 3 3 9 3 33 2h27l-16-3-2-2 2-1-4-4 13 3 1 1h9l5 3 8 3h20l14-2h17l14 4h31l25-5 1-1-19-6-5-3-5-2v-1h8l6 2 16 3 16 1-8-4-2-4 8 1 7 2 27 3 52 2 9 1-1-4h2l1 5 16-2 1-1h13l11 2 2 1 3 5-1 3-4 3h-2v2l-10 3-48 4-1 1-37 4h-34v-1l30-1 31-3 13-3h9v-2l-8-1-3-5-7 1-4 5-9 2h-22v-6h2v-2l-6 1-17-3 2 3v5h-2l-2-4-3-1-1 3v-3l-11 3-1 1-19 3-14 1-11 1-29 1-18-1h-16v-2l-34 1h-51l-16-1-2 5h-6l1-8-9-1-14-2-45 1-11 1-3 1-22 2-12 3h-9l-11-2-14-4-11-3-1-4 2-2h13l15 6 15 4 8-1v-3l2-10 2-4 7-4h13l4 3 6 2 17 9 3 1h17l14-1-1-2z",
    fill: "#E28BAA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,896)",
    d: "m0 0 3 4 16 32 10 19 10 20v2h2l12 23 12 22 12 23 6 11v2h-83z",
    fill: "#ED867C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,794)",
    d: "m0 0h1v17l-2 20h-2l-1 5v7l-2 1v9l-2 11-2 7-2 12-1 16-3 7-2 6-1 11-1 4-2 12-1 3v14l-2 5-1 15-2 12-1 3h-2l-2 9-2 5v11l-1 3h-2v6l-3 4-1 16-2 3h-2v8l-1 4v6l-4 5h-2l4 10-2 10-3 7-1 13-3 6-2 6-2 4v7l-8 12-2 9-3 10-1 7-7 6-3 12-4 6v7l-5 8-2 2-5 2-1 2 3 1 1 3h2l8-10 4-3 3-1 2-4 2-10 7-4 3-7 4-5 5-11 4-2 3-16 6-3-1-7 2-3h2l3-14 3-1 1-6 2-10 3-3 3-18 4-19 5-19 1 4-2 9-3 19-2 5-2 14-3 9-6 19-2 9-2 5-2 9-2 2-4 13-5 10-4 11-4 8-8 14-5 7-2 4-5 4-1 3-3 3h-2l-1 4h-3v2h-2v3l-7 6h-2v2l-7 4-4 4-11 5-7 1-5 2-19 1-29-1-17-2-19-1-17-3-13-1-9-1 2-2h22l57 1 19-1 4-1v-2l-2-1 8-4h2l2-4h2l2-6 5-4 1-4 7-4 3-1 1-3 9-7h2l1-3 5-2 2-5 4-8 5-7 4-9h2l1-10 3-1 1-6 4-10 1-4h2l2-9 4-10 1-4h2l1-12h2v-5l3-7 2-4 5-21 2-5 3-14 2-7 1-1 2-15 5-18 3-16 1-5 2-6 4-23 2-11 1-10 2-4 2-13 3-15 1-8 3-13 1-7 3-23 1-9 2-4 2-19v-5l3-5 1-7 1-4-1-4 3-3z",
    fill: "#680929"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,647)",
    d: "m0 0h2l2 3 3 1 4 9 5 31 2 18 2 13 2 14 1 6v6h2l2 18 2 13 2 5 1 12 1 4 2 10v9l2 7 1 6 2 7 1 9 1 10 1 1v5l2 7v9l2 5 2 9 3 26 2 12 1 7 2 4 2 12 2 14 2 12 2 6 10 44 2 7v6l4 10 2 8 3 9-1 5 2 1 3 13 4 10 2 9v5l3 1 4 11 2 7 8 20v5l3 1 2 7h1l2 8 2 2v5l1 2h-6l-3-7-2-6-4-6-1-9-1-2-3-2v-4h-2l-1-8-3-4-1-4-3-7-1-7-3-7h-1l-2-7-2-1-1-5-2-12-2-1-4-20 1-2h-2l-2-6v-8h-2l-3-14-1-11-4-7-2-14-2-9v-13h-2v-2h-3l1-7-2-6-2-18-1-5-2-4v-7l-2-1-1-9-2-6v-9l-2-5-2-11-2-4v-23l-1-7-3-9-2-7v-11l-4-2-2-7-2-1v-2l-4-2-4 1v9l-2 20 1 7v16l1 14-1 11h-1l-4-37-5-47v-10l-3-25-2-26-2-36v-9-4-9l2-8v-5h-3l1-6 1-3h-2v-10l2-2v-6z",
    fill: "#C24577"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(887,814)",
    d: "m0 0h83l-1 6-7 12-8 16-12 25-7 13h-86l3-9 11-22 11-23 8-17z",
    fill: "#F2B36C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(205,814)",
    d: "m0 0h82l-1 4-9 17-8 16-9 19-8 15-1 1h-85l1-5 11-23 12-25 8-17z",
    fill: "#F2B36C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,185)",
    d: "m0 0 2 4 1 5 2 5 2 9 9 4v3l4 2 9 6 12 2 14 4 2 1v2h8l7 3 8 3v2h2l3 6 1 3h2l-1 17-1 7v23l-2 6 1 13h-2l2 2 3-7 1-5h1l-1 10-7 8-8 6-4 5-3 6-1-3 3-6-4 2-3 3-2 8-3 8h2l-2 10-2 3 1 8-4 10-3 23-1 6-1 21-2 14-1 5 1 9 5 12 4 11 4 4 3 7 7 12 3 8 3 5 3 9 2 8 1 6-2-2-3-6-3-7-1-3-1 2v8l3 12v6l-3 3-3-7-2-10-2-4-3-14-6-16-6-10-7-14-2-2-2-9-3-6-1-10 2-5h2l1-8 1-12 3-10 1-7h2v-8l3-14 3-20 2-7 2-17h-2l-2-10-4-7-7-12v-2l-4-2v-3h-2l-1-4 1-9 4-8 5-9 6-7 3-7 4-1v-5l6-5 2-12v-2l-5-1-4-2-9-1-11-4-9-3-11-6-8-4v-2h-2l-3-5-3-9v-5l-1-1v-7h2l-1-5z",
    fill: "#F8D7E1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,1102)",
    d: "m0 0 5 1 3 6 6 9 4 9 4 5 6 15 4 11 10 28v2h2l4 10 7 14 3 7 1 3 2 1 3 7 3 6 5 3 2 4 3 3v3l5 5h3l2 1v2l2 1v3l3 1v2h5l2 3 3 1v2l3-1 7 5 6 3 1 3 9 1 6 1v2h-12l-6-2h-29l-9-3-4-3v-2l-4-1-1-3-4-2-18-18-8-9-7-8-2-3v-3l-3-1-3-7-3-2-2-5-3-3v-6h-2l-4-9-3-5-1-7h-2v-4h-2l-3-7-3-9-2-7-4-32 2-5-1-3v-8l2-3z",
    fill: "#5F0520"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,888)",
    d: "m0 0 3 3 20 40 10 19 11 22 5 8 14 26 18 34 7 12v2l-74 1 6 24 7 25 5 12 2 5-4 2-3-11-4-12-9-35-5-22 2-9 15-29 10-19 6-12-44-1v-81z",
    fill: "#ED867C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(421,550)",
    d: "m0 0h1v13l-1 8-1 54v18l-1 13-1 11v12l-1 6v7l-1 4-1 37-1 24v11l-5 82-3 35-1 21-7 56v14l-1 3-2 17-2 8-1 10-2 7-1 1-2 10-2 5-3 1-1-4v-19l1-3v-18l2-26 1-2v-15l2-17 1-13 3-40 2-28 3-29 2-41 2-28 2-31 1-16 2-15v-15l2-22 2-27 1-13 4-39 3-16 3-9z",
    fill: "#CF6E9A"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(336,888)",
    d: "m0 0 3 4 1 2 2-1-1 10-6 36-6 33-7 32-5 21-3 9-4 20-2 3v-3h-57l1-5 16-31 10-19 13-25 4-1 36-72 3-10z",
    fill: "#F2B36C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,174)",
    d: "m0 0 4 1-6 2-1 14v32l-6 2h-7l1 10v14l-3 13 1 15 1 7 4 5 12 5 20 10 7 7v2l5 2 4 4h3l1 10 3 1 4 6 2 7v10l-3 14-4 9-1 2h-2v6l-3 3-4-1 2-12 3 1 2-10 2-4 1-10-2-3-2-2-1-18-2 2-4-10-3-3-5-3-7-5-4-1v-2l-4 1-8-1-8 2-2-1-2 4-3 1v2l-3 2-2 4-2 2-2 6-3 5-2 1-2 4-10 5-5-1-7-4-5-6-5-5-2-4-5-5-1-3h-2l-2-5 1-13 4-8 6-8 3-1 5-6 3-2h3l1-3 6-4h2l1-4 5-6 5-8 2-5 2-3 2-6 1-5 1-3 4-1 2-12 2-13 1-18 4-4z",
    fill: "#D883AD"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(83,887)",
    d: "m0 0 3 4 18 37-1 3h-2l-2 4-6 9-4 13v16l4 13 5 8 5 6 5 4-1 5-15 29-8 15-3-3-18-34-17-32-5-9v-5l10-19z",
    fill: "#A1D0C4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,888)",
    d: "m0 0h2l11 22 8 17-1 4-8 10-5 13-1 6v11l3 12 6 11 8 8 3 2-2 6-15 29-7 14-4-4-18-34-15-28-8-15h2l3-9 12-23z",
    fill: "#A1D0C4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(493,224)",
    d: "m0 0h10l-4 1v7l-2 2-2 7-2 2-3 7-4 7-5 5-1 3-4 3-4 2-1 2-3 1-5 5h-2l-1 3-5 3-5 8v3h-2v8l-1 7 1 5h2l4 6 4 4 3 5 7 6v2l4 2 5 2 5-1 4-1 1-2 3-1 2-4h2l2-5 2-6 3-3 3-5h2v-2l5-5 11-2 11 1v2l5 1 6 4 8 6 3 5 1 5 3-3 1 20 3 2 1 4-1 10-2 1-1 10-3 3v-2h-2l-2 15-2 8h-5l-3 2-5 1-2 5-5 1-2 8-2 3-1 13-2 4h-2l1 7-1 3-9 2 5 1v2l-5 2-5 4-4-1-1 5-1-2-3 1-1 31h-1l-1-37 3-4h4l-7-2 4-3 3-6 2-12 2-6 2-10h2l1-14 1-3 6-4 9-3 15-3h3l2-4 3-2h3l3-21 1-17-4 1-4-8-4-10-9-7-10-1-6 1-6 4-5 2-1 5-2 2-2 8h-3l-2 10-4 7-1 4h-3l-1 2h-8l-10-5-4-4v-2h-2l-3-5-4-4-2-5-1-3-5-5-4-7-6-9-4-20v-12l-3-3-1-8h-3l-3-1-2-5-1-3h3l-2-5 1-3h7l9 2 3-1h8l2-4 10-3 5-3 7-3 5-4h3l2-6h2v-2z",
    fill: "#CE6D99"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(718,814)",
    d: "m0 0h13l20 40 8 15 7 15v2l-87 1-2-2v-70z",
    fill: "#F2B36C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(157,910)",
    d: "m0 0h20l10 22 15 30 4 10-7 15-8 15-3 7-8 14-23-1-3-3h-6l-3-5v-2l13-5 9-6-2-4-9-11-5-6-4 2-7 3h-8l-3-5-3-6 1-6 11-23 8 3 3 2 14-21 1-3-5-2-9-4 3-6z",
    fill: "#ED867C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(841,910)",
    d: "m0 0h19l10 21v2h2l9 20 8 17 1 2-8 16-9 19-9 15h-23l-3-3h-7l-2-7 12-5 9-6-1-4-9-10-5-6v-2l-8 5-3 1h-9l-6-12 2-6 10-21 2-1 8 4h2l14-21-3-3-10-5 2-6z",
    fill: "#ED867C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(13,1261)",
    d: "m0 0 11 2 6 2 14 2v-2l15 1 7 2 1 2 4 1v-2l-6-2 4-2h30l4-1 11 2-1 2 8 2v-2h-5l-1-2 13 1 6 3-2 1v2l5-1 1 1h6l1-1 10 1 3 2 17 3 9-1 6 2 7 1 2 1 15 2 21 1h36l16 1 13 2 78 2 23 2 2-7 2-1v4l9 1 3 3-2 6-4 1h-27l-91-2-35-1-13-1-48-2-20-1-24-3-45-2-5-1-42-3-17-2-16-1-22-4-2-1 1-3 5-1z",
    fill: "#7F2D50"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,1282)",
    d: "m0 0 13 1 10 1v2h-2v6l22-1 9-2 4-5 7-1 3 5 8 2v2l-20 3-2 1-31 3-87 3-87 2h-50l-22-1-87-1-34-1-30-2v-2l-2-1h3l-1-3 11 1 8 2 8-1 5-1v-2l7-2 22-2 3-1 11-1 45-1 19 3 4 1-1 8 6-1 2-5 16 1h85v2l17-1 22 1 30-1 5-1 21-2 12-2 9-3h7l2 5h2z",
    fill: "#7F274C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,814)",
    d: "m0 0h48l11 23 8 15 9 19 7 14v1h-83z",
    fill: "#F2B46C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,490)",
    d: "m0 0 3 4h6l2 5v2l5 1 2 8 5 3 3 8 4 8 6 6 5-2 4-3h2l2-12 1-19h1v29l-3 30-3 14-5 4-2 3-3-1v-2h-2l-4-7-2-8-3-5-1-8-3 1-2-9-2 1 3 11v16l1 7 1 2-1 6 1 8v16l1 12v26l-1 18 1 26v25l1 45v57l2 31v15h-1l-1-7-3-43-6-87-3-48-1-28-1-9v-26l-1-10v-12l-2-14-1-20-1-15-4-30z",
    fill: "#CF6E9A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 928)",
    d: "m0 0h1v126h-67l1-6 19-37 20-38 4-1z",
    fill: "#F2B36C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,567)",
    d: "m0 0h1l1 69 1 8v36l1 14v15l1 9v16l1 16v15l2 26 2 48 1 26 1 4v13l2 13 1 23 1 26 3 23-1 15 1 6 2 34 3 24v11l1 10 1 21 2 18v11l1 9v8l2 18 1 3 3 45 2 9 2 30-1 6-5 1-4-1v-2l-8-1-4-3-8-1-2-4-6-4-5-5-2-3-1-8-2-5-2-7 1-2-3-15-1-28-3-9-3-30-3-9-2-1-2 5-2 7-3 14-2 19-3 12-1 10-2 9-4 24h-1v-9l3-21 1-2 1-11 2-12 3-20 2-8 1-11v-7l2-6 1-12 3-11 2-1v-8l4-2 2 2 2 15 3 11 1 14 3 10 1 19 2 4-1 9 1 1 3 35 2 3v6l5 12 1 9 5 9 8 7v3h5v2l10 3v-2h2l-1-4v-19l-3-18v-9l-1-9-2-7v-22l-1-9-2-9-1-11-1-4 1-6-1-7-2-18v-23l-1-11-1-18-1-8-2-19-1-20-1-17-1-10v-10l-3-18v-21l-2-17v-21l-1-4-1-29-1-9v-15l-2-20-2-43-1-16-1-58-1-3v-73l1-35z",
    fill: "#A63B67"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,535)",
    d: "m0 0h1l3 51 3 58 2 29 1 13 2 42 1 13 2 38 2 10 1 21 1 8 1 19 2 23 1 4 2 16 2 1 1-19h1l2 29 1 11 6 61 5 40 1 1 7 50 8 50 10 48 8 30 3 17h-3l-4-9-3-4-3-15-4-9-3-14-1-3 1-6-3-1-3-16-5-17-3-15-3-16-1-11-3-10-1-13-1-4-4-26-2-9-1-13-2-13-3-22-1-10-5-52-4-47-3-34-2-29-2-49-1-11-5-106-2-49z",
    fill: "#CD6C98"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(586,551)",
    d: "m0 0 4 1 3 7 3 3 1 7h2l2 14 2 7 4 27 4 18 4 29 3 15 2 16 2 10 2 7 4 25 2 14 3 17 2 14 2 10 3 14 2 13 1 10 4 18 1 9 2 8 2 16 1 5 4 21 2 8 1 17 3 1 1 15 1 1v7l2 1 1 8 2 11 1 1 1 9 1 2 1 11 2 1v7l1 3h2v7l2 2 1 7 3 9v5l-2 4 2 5v7l5 13 1 5 4 12 4 14 4 16 2 6-1 4-4-8-3-8-1-2h2l-3-8-3-7-2-11-2-1h2l-8-20v-7l-1-6h-3l-4-21-2-9-2-6-1-11-2-2-2-13-3-10-2-9-1-5-3-14-1-14-2-4-2-19-3-7-2-18-1-2-1-14-3-13-2-17-2-7-1-15-2-1-2-8v-8l-1-1-2-16-1-2-1-15-2-4-1-9-2-8-1-15-2-4-1-14-2-3-2-21-1-2-2-21-3-18-2-5-1-13-7-28-5-2-3 5-2 8-1 11 1 12-1 14v24l-1 8h-1l-6-64 1-8-2-3 1-8v-24l1-2h2v-13z",
    fill: "#CF6E9A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(343,1067)",
    d: "m0 0h1v11l-3 10-1 5-3 14-1 5-2 7 2 4-1 7h-3l-1 3 4-1 2 4 2 1v-2l3-1-2 13-3 15-2 16-4 10-3 13-4 9-2 7h-2v7l-6 14-9 18-4 2-23 1-5-1-15-9-3-2 6-4h2v-2l7-6h2v-3h2v-2h3l1-4h2l1-3h2l1-4 5-4 5-9 6-9 9-18 5-14 4-8 3-9 2-3 2-11 2-4 2-9 6-19 3-11 2-12z",
    fill: "#6F1136"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,887)",
    d: "m0 0h86l-1 5-40 80h-3l-20-40-10-19-12-24z",
    fill: "#FDF5E7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,887)",
    d: "m0 0h83l-2 6-40 80h-2l-20-40-10-19-9-18z",
    fill: "#FDF5E7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(166,887)",
    d: "m0 0h84l-2 6-7 13-3 7-2 3h-2l-3 9-11 21-8 16-5 9h-2l-8-16-3-7-8-16-10-22-10-19z",
    fill: "#FDF6E7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(849,887)",
    d: "m0 0h85l-8 16-4 10-4 4-8 17-4 6-11 23-4 8-3-1-16-34v-3h-2l-12-26-8-15z",
    fill: "#FDF6E7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(935,1054)",
    d: "m0 0h67v67h-36l-3-4-11-23-18-37z",
    fill: "#E5EBDF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(410,576)",
    d: "m0 0h1v10l-3 25-4 48-1 9v13l-4 46-3 52-3 32-1 14-2 15-2 34-2 21-1 10-2 22-5 43-2 12-1 14-2 7v9l-1 2-4 28-2 17-9 57-4 18-4 16-2 10-12 38-5 13-4 8-1 4-7 14-2-3 1-6 2-4 1-7h2l2-9 3-7 2-10 6-18 3-12h1l2-13 2-1 1-7 2-6v-6h2l2-20 1-5 2-11 2-14 2-5 1-11 4-22 3-22 1-7v-13l2-6 1-13 1-4 2-13v-12l1-2v-11l2-6 1-11 2-8v-9l1-6h-2l-4 5-1-7 1-6-3-2 4-7h4v2l2 1 1-2 3-47 4-46 3-25 2-21 2-6 1-8 3-44 4-47 6-54z",
    fill: "#9E2651"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,794)",
    d: "m0 0h1v17l-2 20h-2l-1 5v7l-2 1v9l-2 11-2 7-2 12-1 16-3 7-2 6-1 11-1 4-2 12-1 3v14l-2 5-1 15-2 12-1 3h-2l-2 9-2 5v11l-1 3h-2v6l-3 4-1 16-2 3h-2v8l-1 4v6l-4 5h-2l2 5-1 5-4 7-1 7-3 13-4 7-1 10-4 8-3 5-2 7-2 3-2 7-2 4h-2l-1 11-4 6-9 18-5 7-3 6-3 5-4 7-6 5h-2l-1 8-6 5-5 4h-2v2h-4v2h-3v2l-9 4-9 2h-5l-4-1h-55v2l22 1 18 2h50l-4 2-19 1-29-1-17-2-19-1-17-3-13-1-9-1 2-2h22l57 1 19-1 4-1v-2l-2-1 8-4h2l2-4h2l2-6 5-4 1-4 7-4 3-1 1-3 9-7h2l1-3 5-2 2-5 4-8 5-7 4-9h2l1-10 3-1 1-6 4-10 1-4h2l2-9 4-10 1-4h2l1-12h2v-5l3-7 2-4 5-21 2-5 3-14 2-7 1-1 2-15 5-18 3-16 1-5 2-6 4-23 2-11 1-10 2-4 2-13 3-15 1-8 3-13 1-7 3-23 1-9 2-4 2-19v-5l3-5 1-7 1-4-1-4 3-3z",
    fill: "#6F1136"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,1243)",
    d: "m0 0 3 1 5 12 2 7 3 3 5 9 3 3 9 3 33 2h27l-16-3-2-2 2-1-4-4 13 3 1 1h9l5 3 8 3h20l14-2h17l14 4 18 1 1 2-12 1v2h-60l-28-1-15 1h-34l-15-2-14-4h-19l-3 1-33 1-11 1-3 1-22 2-12 3h-9l-11-2-14-4-11-3-1-4 2-2h13l15 6 15 4 8-1v-3l2-10 2-4 7-4h13l4 3 6 2 17 9 3 1h17l14-1-1-2z",
    fill: "#E088A8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,1102)",
    d: "m0 0 5 1 3 6 6 9 4 9 4 5 6 15 4 11 10 28v2h2l4 10 7 14 2 3-1 4-4-7v-2h-2l-3-6-2-5-1-5-2-1-3-6-4-2-3-6-6 1-1 4-4 3 3 18 2 6 3 8 5 9 1 5 2 1-1 4-6-8v-3l-3-1-3-7-3-2-2-5-3-3v-6h-2l-4-9-3-5-1-7h-2v-4h-2l-3-7-3-9-2-7-4-32 2-5-1-3v-8l2-3z",
    fill: "#680523"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(214,814)",
    d: "m0 0h73l-1 4-9 17-8 16-9 19-8 15-3 1-8-17-9-17-11-23-7-13z",
    fill: "#456277"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(898,814)",
    d: "m0 0h72l-1 6-7 12-8 16-12 25-7 13h-2l-22-44-9-17-4-9z",
    fill: "#456277"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,814)",
    d: "m0 0h71l-3 9-19 39-11 23h-3l-10-19-25-50z",
    fill: "#456277"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(48,814)",
    d: "m0 0h70l-1 5-13 28-19 39-3-1-9-19-10-19-15-30z",
    fill: "#456277"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,129)",
    d: "m0 0h9l2 1v10l3 5 6 3-4 10-3 3-3 9h18l8-1 2 4-2 1-11 1-9 3-10 2-4 2-3 13 1 6-5 8-1 5-2 2-3 5 1 2-16-1-2-1h-26l2-3 11-6 5-6 3-7h2l1-12 3-13 3-3 15-2h6l-1-9-5-10-1-8 3-8 5-4z",
    fill: "#712346"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,560)",
    d: "m0 0h1l6 45 5 42 2 18 2 21 1-5h1l3 31 1 5 1 17 1 2 1 22 2 13 4 56 2 14 3 43 2 19 3 36 5 46 3 22 5 43 2 9 2 14 2 18 7 39 1 10-3-2-4-19-5-28-2-11-2-19-1-1-4-28-1-2-1-16-2-10-3-22-2-20-3-23-3-27-1-7-3-37-2-22-1-17-2-10-1-7-3-45-1-5-1-20-2-19-1-16-2-21-4-50-8-68z",
    fill: "#E693BA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,694)",
    d: "m0 0 5 1 3 15 1 9 3 3 1 7 1 12 3 16 2 7 3 27 2 6 1 9 3 11v7l-1 5h2l1 11 2 9 2 4v8l-2 2-1-7-3-9-2-7v-11l-4-2-2-7-2-1v-2l-4-2-4 1v9l-2 20 1 7v16l1 14-1 11h-1l-4-37-2-18v-33l-1-1-1-16 1-2h-2l1-7-2-5v-17l-2-3 2-9v-7l-1-3v-7l-1-4 3-15v-14z",
    fill: "#C23E70"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,477)",
    d: "m0 0 3 4 8 18 6 18 7 29 6 28 7 54 2 18 3 39 1 25 4 38 7 39v4l-3 1-3-9-4-26-3-19-2-17-1-36-1-11v28l-2 2-4-29-2-10-2-12-3-12-4-23-12-56-2-9 4 2 1-2-1-9-2-9v-8l3-3 3 10 3 4 3 7 6 28 6 42 2 13-6-48-2-13-12-52-7-19-7-16z",
    fill: "#F8CDDC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(803,814)",
    d: "m0 0h84v1h-5l-3 9-14 28-11 23-5 10-3-4-8-18-7-15-4-8-11-24-13-1z",
    fill: "#CC8CA2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,814)",
    d: "m0 0h85v1l-6 1-16 33-14 29-3 7-3-3-13-28-16-34-1-5h-13z",
    fill: "#CC8CA2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,874)",
    d: "m0 0 2 4-1 7h1l2 12 3 31 4 40 2 11 3 25 2 16 3 3 2 15v16h3l5 28 3 17 2 7 4 20 7 22 5 18v4h2l3 10 1 4 4 9 1 1v5h-4l-1-5-4 2-1 2 2 1 1 5 4 6-1 3v-2l-3-1v-2h-2l-3-8-7-15-3-8-3-12-2-7-5-22-4-16-5-29-2-18-3-21-1-2-5-43-4-33-6-55-1-16-2-19v-9z",
    fill: "#CE6C98"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(336,888)",
    d: "m0 0 3 4 1 2 2-1-1 10-6 36-6 33-7 32-4 17h-1l-2-8-13-25-7-13 2-6 34-68 3-10z",
    fill: "#EA827C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,468)",
    d: "m0 0h2l1 10 2 35 4 32 1 13 1 20 2 14v18l1 7v23l1 9 1 28 5 75 5 73 2 30 1 7v19h-3l-2-7-1-12-1-4-2-21-1-19-1-8-1-21-2-10-1-22-1-16-2-29-1-26-2-25-3-57-2-39-2-30-1-27z",
    fill: "#EEA0C5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,482)",
    d: "m0 0h2l3 6h2l5 11 2 5 5 8v3h2l2 6 2 1 5 10 6 18 6 25 5 23 7 37 3 16 2 8 2 14 2 9 2 17 1 3v-30l2 2 1 11 1 36 3 22 1 10-1-3h-2l-1-7h-1l-2-6-5-31-1-1-2-11-2-15-3-15-4-29-5-23-3-22-3-11v-10h-2l-3-8-3-3-2-6-3 1-2 1-1 5v11l-1 2h-2v28l-1 7 2 2-1 8 4 43 1 9v12h-1l-7-66-5-42-2-16-2-15-1-21-5-29z",
    fill: "#EFA4C7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(251,1054)",
    d: "m0 0h57l-2 12-2 10h-2l-1 10h-2l-2 13-4 13h-2l-2 12h-2v-3l-4 1h-65v-1l63-1-14-29-16-33z",
    fill: "#E4E9DE"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,787)",
    d: "m0 0 2 4h2l3 15v8h27v150h-1l-1-63-7 13-1 3v6l-2-3-5-26-6-38-5-28-5-32z",
    fill: "#EEC0C1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(113,1236)",
    d: "m0 0h14l7 1 1 1 13 2 16 2 19 2 23 1-1 2-11 1-1 1h-92l-6 1v2l-9 3h-4l2 5 4 1 54 3 28 1 1 4h10l9 2 1 3-7-2 2 4-14-1-2-1-11-1-4 1-10-1-1 1h-6l-4-1h-2l-1-3-3-2-12-1 5 1v2l-9-1 1-2-13-2-5 1h-28l4 3v2l-5-1v-2l-7-1-13-1-2-1v2l-14-1-17-5 2-4 5-2 7-1h42l10 1v-2l13-5 10-7 8-4z",
    fill: "#B8507D"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(353,814)",
    d: "m0 0h1l-1 13-7 50-3 16h-1v-7l-6 1-3-4-3-9-16-32-11-23-1-4z",
    fill: "#EC847C"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,537)",
    d: "m0 0h2l1 8-1 12-1 5 1 12-1 5 1 16-1 6-1 5v12l2 6-1 8-1 7-3 4-2 9h-2l-1 3-4-2 1-4-4-1-3 1-2-1v3l2 1-3 17v14l-1 5v30l-1 5v43l1 20v19l1 13-1 4-1 9 1 1 1 15 1 5-1 10-3 7-1-3-1-12v-10l1-10-1-4v-45l-1-11v-94l-1-19 1-9v-26l2-7 2-10h11l3-4h2l1-8 1-5 1-9 1-7z",
    fill: "#C14577"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(767,1055)",
    d: "m0 0 3 4 19 39 10 21v2h-64l9-19 16-33z",
    fill: "#456377"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(83,1055)",
    d: "m0 0 3 3 17 35 12 25 1 3h-64l2-6 9-19 8-16z",
    fill: "#456377"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(933,1055)",
    d: "m0 0 3 4 11 22 11 23 8 17h-64l2-6 19-39z",
    fill: "#A1D1C5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,1056)",
    d: "m0 0h2l26 53 5 12h-64l9-20 8-16z",
    fill: "#A1D1C5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(164,1057)",
    d: "m0 0h2l8 15 5 12 4 8 9 19 4 10h-61l4-10 5-12 5-10 5-11 6-12 3-7z",
    fill: "#CB8CA1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,1056)",
    d: "m0 0h2l5 12 3 5 4 10 5 9 4 10 4 7 4 10v2h-60l3-10 5-10 5-11 11-23 4-9z",
    fill: "#CB8CA1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,519)",
    d: "m0 0h1l3 19 1 14 1 3 3 30 2 17v16l1 10 3 33 2 24 1 21 1 5v12l1 5v26h2l3 46 2 10 3 39 2 18 2 21 1 12 3 33 5 38 2 12 3 24 1 3 2 19 2 11 4 33 2 6 2 13 3 13 2 12 5 23 1 7h2l1 9 4 17 2 11 4 12 3 4 6 18 1 4-4-4-7-16-4-12-5-17-5-22-3-13-2-7-2-12-3-16-3-12-2-12-1-3-1-7-5-38-2-12-4-29-3-24-3-19-2-22-1-3-1-16-2-19-1-16-2-20-1-17-1-2-2-16-1-14-2-8-1-25-1-6v-13l-2-16-2-36v-9l-1-6-1-20-1-3-2-29-4-44-1-19-1-15-3-27z",
    fill: "#CF6E9A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,863)",
    d: "m0 0 2 3 1 8 2 7 1 9 1 4 1 7 1 4 1 9 1 3 1 13 2 4 3 3 2 6 2 12 2 14 2 12 2 6 10 44 2 7v6l4 10 2 8 3 9-1 5 2 1 3 13 4 10 2 9v5l3 1 4 11 2 7 8 20v5l3 1 2 7h1l2 8 2 2v5l1 2h-6l-3-7-2-6-4-6-1-9-1-2-3-2v-4h-2l-1-8-3-4-1-4-3-7-1-7-3-7h-1l-2-7-2-1-1-5-2-12-2-1-4-20 1-2h-2l-2-6v-8h-2l-3-14-1-11-4-7-2-14-2-9v-13h-2v-2h-3l1-7-2-6-2-18-1-5-2-4v-7l-2-1-1-9-2-6v-9l-2-5-2-11-2-4v-20z",
    fill: "#C14577"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(558,339)",
    d: "m0 0h1l1 7 3 2 1 4-1 10-2 1-1 10-3 3v-2h-2l-2 15-2 8h-5l-3 2-5 1-2 5-5 1-2 8-2 3-1 13-2 4h-2l1 7-1 3-9 2 5 1v2l-5 2-5 4-4-1-1 5-1-2-3 1-1 31h-1l-1-37 3-4h4l-7-2 4-3 3-6 2-12 2-6 2-10h2l1-14 1-3 6-4 9-3 15-3h3l2-4 3-2h3l3-21z",
    fill: "#CF6E9A"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,1220)",
    d: "m0 0v3l-2 5-5 4-2 5-6 5-6 3v3l-4 2-19 1-67-1h-12l34 4 7 1 23 2v2l2 2-6-1-15-2v2h7l14 3 19 6 7 5-2 1h-3l10 3 17 2 27 2 41 1 13 2 4 1v-1h28l1 2 12 1v1h-16l-32-1-13-2-17-1h-35l-21-1-15-2-4-2h-7l-4-2-10 1-16-3-2-2 2-2 12 1 2 1 13 1-1-3 6 1v-2l-16-1-3-1-1-3-45-2-37-2-5-2-1-5 9-3h4v-2l6-2h92l1-1 11-1 9-9 8-7 4-5h2l2-4z",
    fill: "#9F2A55"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,626)",
    d: "m0 0h2l2 35 2 25 2 42 1 13 2 38 2 10 1 21 1 8 1 19 2 23 1 4 2 16 2 1 1-19h1l2 29 1 11 6 61 5 40 1 1 2 14v25l2 5v2l-1 8-1-3h-2l-1-11-2-4-2-12-1-14-1-3 1-2h-2l-3-25h-1l-2-18-3-20-1-15-1-6-4-43-2-23-1-14-1-2-1-20-1-11-2-20-1-20-1-7-4-78-2-34z",
    fill: "#D780AA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,224)",
    d: "m0 0h3l3 12 1 7 2 8v4l2 1-1 5 4 7 8 16v2h2v2l4 2 1 3 4 1 1 7 4 2v2h2l7 9 4 2 1 5 5 2 6 14 1 5v20l-3 9-2 9-3 2-3 9-2 5-1 4-6 3-2 2v-12l3-8 1 2 4-1 1-8h2l3-10 3-9 1-6v-10l-3-9-2-4-4-1-1-10-3 1v-3l-5-2-5-5-8-7-16-7-5-3-8-3-5-6-2-15v-7l3-13v-19l-1-2 1-3z",
    fill: "#E693BC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,1149)",
    d: "m0 0 2 2 2 6 1 2v7l3-1 2 12 2 2 3 9 4 6 1 3 3 3 3 7 4 6 2-2 3 9 1 5h3l2 4 3 2 3 6 3 2 4 8v2l4-1 3 3v4l2 1v2h2v-2l5 1 6 6v2l4 2 5 5 4 2 4 4 13 4v1l-6 1h-20l-12-5-11-9-10-10-10-13-12-20-6-12-3-5-3-9-6-16-8-29z",
    fill: "#9C244F"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,928)",
    d: "m0 0 2 3 13 26 6 13-1 6-3 7-11 22-6-4-7-7-7-14-2-9v-11l3-12 5-10z",
    fill: "#D4E8E2"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(103,930)",
    d: "m0 0h2l14 28 6 13-3 9-13 26-7-6-8-10-5-12-1-5v-16l4-13 6-9z",
    fill: "#D4E8E2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,832)",
    d: "m0 0h2l2 18-1 4 1 3h2l-1 7 2 1-1 9 5 1v-2h2l-2-9 3-5-3-1 2-4 2 1v-6h1v20l-2 19-2-4-1-4h-4l-1 4-1 3 2 2-1 6v5l5-4 2-4v8l-1 4v8l-3 14v7l-2 5v10l-1 6v8l-2 13-2 11v8l-2 4v13l-3-1 1-16-2-1 1-6v-8l-2-2v-13l-1-4 1-7-1-4h2v-6l-2-1v-17l4-68 1-12 1-7z",
    fill: "#851A41"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,973)",
    d: "m0 0h40l4 1-2 6-12 24-12 22-5 10-1 5-2-4-9-39-3-16z",
    fill: "#CB8AA0"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,1183)",
    d: "m0 0 5 2 3 13 1 3h2l2 10 4 15 2 13 2 4 2 17 1 13 2 8h-12l-5-3-3-10v-4l-3-1-1-7v-4l-4-2-1-17-1-8v-9l1-16 2-14z",
    fill: "#9D2550"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,815)",
    d: "m0 0h40l-7 16-10 19-18 36-3 1-2-2z",
    fill: "#ED867C"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(622,732)",
    d: "m0 0h2l3 14 1 10 2 10 2 11 5 28 4 24 1 13h2l1 14 5 24 3 19 2 9 1 8 2 7 1 13 2 4 3 22 4 14 2 9 3 1 1 12 2 1v7l1 3h2v7l2 2 1 7 3 9v5l-2 4 2 5v7l5 13 1 5 4 12 4 14 4 16 2 6-1 4-4-8-3-8-1-2h2l-3-8-3-7-2-11-2-1h2l-8-20v-7l-1-6h-3l-4-21-2-9-2-6-1-11-2-2-2-13-3-10-2-9-1-5-3-14-1-14-2-4-2-19-3-7-2-18-1-2-1-14-3-13-2-17-2-7-1-15-2-1-2-8v-8l-1-1-2-16-1-2-1-15-2-4-1-9-2-8z",
    fill: "#CF6E9A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(481,818)",
    d: "m0 0h1l1 13 2 36 3 55 2 27 5 65 2 13v12l4 38 2 15 1 12 3 14 2 11 2 9 5 12 3 4 1 5h2l3 7 2 7 3 5 2 6-1 4v-3h-2l-3-7-2-4v-4l-2-1-1-3-4 1v8l2 1 3 21-1 4-2-5-3-11-4-2-1 13-1 9-1 12v11l2 22 3 2 2 11 2 1 3 14 5 2 12 1v1h-17l-1-4-3-1-5-16-3-9-2-5 1-7h-2v-32h2l-1-5v-12-3-4l1-20 1-6-2-3v-17l-3-6-1-9-2-14-4-36-1-16-1-10-1-14-1-7-3-38-1-8-2-33-3-44-2-46-1-7z",
    fill: "#A63B67"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,1268)",
    d: "m0 0h11l9 4 36 3v-2h8l3 2 17 3 9-1 6 2 7 1 2 1 15 2 21 1h36l16 1 19 3 23 1 3 2-5 1h-14l-15-1h-14l-6-1-1 2-1-1-49-1h-15l-9-2-1-1h-13v1h-24l-5-1v-2l-26-3h-10l-25-3 1-2 6-1-10-2-11-2-3-2z",
    fill: "#600623"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,563)",
    d: "m0 0h1l1 8v11l1 3 1 24v21l-2 39-1 3 1 12-2 11v18l-2 23-2 52-2 18-1 24-1 16h-1l-1-10-1 14h-3l3-51 2-32v-14l1-20 1-37 1-9v-6l1-4v-10l1-11 1-19v-22l1-44 1-7z",
    fill: "#BA527F"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,973)",
    d: "m0 0h35l3 2-8 16-14 27-10 19-5 9h-1z",
    fill: "#CB8CA1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,417)",
    d: "m0 0 3 2 2-1-1 27-5 2v2l4 1-6 2-5 8-4 9 1 5 8 17 3 2 1-9h2v-13l2-3v3h2l1 9-2-3v21l-1 11-5 3-6-3-1-4-4-2-5-4-7-12-4-11-2-4 2-12 4-4 4-2 2-4h5l-2-3 5-1-1-3h2l1-9 1-4v-5l5-5z",
    fill: "#E693BC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,383)",
    d: "m0 0 2 2-3 21-1 6-1 21-2 14-1 5 1 9 5 12 4 11 4 4 3 7 7 12 3 8 3 5 3 9 2 8 1 6-2-2-3-6-3-7-1-3-1 2v8l3 12v6l-3 3-3-7-2-10-2-4-3-14-6-16-6-10-7-14-2-2-2-9-3-6-1-10 2-5h2l1-8 1-12 3-10 1-7h2v-8l3-14z",
    fill: "#F8D7E1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(406,964)",
    d: "m0 0h2l1 16-1 5v9l-1 10-1 11-2 2-2 12v6l-2 7-3 25-2 12-1 5-4 28h-2l1 3-3 9-1 5-2 2-1 9-3 9-4 11-2 8-5 9-1 10-4 1-3 1-1 5-6 5-3 5h-2l-2 6h-2l-1 5-1 2h-2l-1 4-3 2-1 4h-2l-2 4-4 2v-3l5-5 5-10 5-7 3-8 3-1 1-6 3-5h2l3-11 4-6 1-3h2l3-9 4-9 3-11 3-4 2-11 3-10 4-12 3-11v-7l2-5 1-7 1-18 1-11 3-7 1-9 2-6 2-19 1-10 1-13v-6l1-1z",
    fill: "#A83461"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(397,264)",
    d: "m0 0 3 2 2-2 1 4h2l3 5 9 12 10 13 6 9 4 11 3 19-1 6-5 5-4 2-3 12v10l-2 4v11l2 10 2 3v3l-4-2-2-6-4-15-2-6-2-10v-15l2-1v-5l3-2h4v-7l2-4 3-3 2-6-1-1v-6l-4-1h-7v-7l-3-1-1-4-4-2-2-5-2-6-2-3 1-6-6-7-3-4z",
    fill: "#7F274C"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,292)",
    d: "m0 0h17l7 3 1 3v9l-3 12-3 7-5 4-6 2-7-1-6-5-5-3-8-9 1-9 5-8 7-4z",
    fill: "#E693BC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(546,396)",
    d: "m0 0 5 1v9l-2 2-1-4-6 1-2 5-6 10-3 15-4 9-4 2 2 4-12 3-2 4-3 5 1 7h-2l1 7 3 1 4 8 2 8h2l2 9 4 2v6l5 2 1 4 10 6 3 1 5-2 2-3-1 10-4 4-6 4-4-2-7-8-4-10v-3l-5-2-2-5-1-4-4-1-2-6h-6l-2-3-1 9h-1l-1-33h-2v-10l2-2 3 1 1-3 5-1 5-4h4v-2l-7-1v-1l10-2 1-5v-4h2l2-12v-5l3-5 2-6 5-1 2-6 5-1z",
    fill: "#D67CA7"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,732)",
    d: "m0 0 2 1v11l-4 63-2 50-1 5-2 1-2 6 2 6-1 3h-2l1 5v14l-1 10-4 6v7l-3 3h-2l-2 10-2 8-4 19v4h-2v8l-2 16-4 16-2 1-2 13-3 6h-1v-5h2v-16l4-9 1-3h2l1-12 1-8 2-13 1-7v-9l3-12v-6l1-1 1-11 2-6 3-7 1-17 3-17 2-6 1-13 1-3h2l-1-10 2-5h1l2-17v-22l-1-5 1-7 2-2 1-4-3-1 3-8 1-26z",
    fill: "#670828"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(414,593)",
    d: "m0 0h3l1 4-2 43-2 67-1 26-1 34-2 8v11l-1 3-1 18-2 2-1 5-3-1-1-3 2-25-1-6 2-37 2-26 2-36 4-59 2-20z",
    fill: "#D882AC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,1208)",
    d: "m0 0h3l-1 9-2 2-2 6-6 12-5 6-4 8-2 2-1 3h7l2-1 2 1 2-4 5-2 2-2 11 4 3 4 2 6 2-1-2 6-2 3h-2l1 3-3 1-1-6h2l-1-5-8-4-4 1-4 2-5 1-5 3-12 6-5 2-7 2-14 1-1-5 11-8 11-11h2l2-5 5-5h2l1-4h2l1-4 3-5h2l2-4 4-7h2l2-6h2z",
    fill: "#A53B67"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,770)",
    d: "m0 0h2l1 2 3 36 2 19 2 14 3 43 2 19 3 36 5 46 3 22 5 43 2 9 2 14 2 18 7 39 1 10-3-2-4-19-5-28-2-11-2-19-1-1-4-28-1-2-1-10v-19l-3-21-2-19-1-4-2-23-3-24-3-37-2-20-2-18-3-35-2-23v-6z",
    fill: "#ED9FC4"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(470,1267)",
    d: "m0 0h13l4 3 6 2 17 9 3 2-3 1 23 1v1l-33 1-11 1-3 1-22 2-12 3h-9l-11-2-14-4-11-3-1-4 2-2h13l15 6 15 4 8-1v-3l2-10 2-4z",
    fill: "#CF6E9A"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,450)",
    d: "m0 0 4 1-4 9-4 1-1 6-2 10-1 2 2 5-3 5-1 12v11h-1v-8h-3l-1 27v31l-2 21-4 7-3-3-2-4-1-14-3-8-1-3h2v-16l1-13 4-4 1-8h3l1-17 2-5v-7l4-18h2v-4l5-5v-2h2l2-5h2z",
    fill: "#A63B67"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,815)",
    d: "m0 0h33l-2 6-10 21-10 19-10 20h-1z",
    fill: "#EE867C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,372)",
    d: "m0 0h1v6h2l5 5 3 9 8 8v2l5 2 3 2v9l1 5 3 1-1 2h-2l-1 6-4 4-2 1 2 6-1 4-3 1 2 3-11-2-1-4v-6l-2-4-6-27v-2h2l-3-6-2-10v-11z",
    fill: "#7B193E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,607)",
    d: "m0 0h1l2 23 2 17 1 27 2 24 1 25 1 6v17h2l-1-3v-19l2 1 7 100 2 30 1 7v19h-3l-2-7-1-12-1-4-2-21-1-19-1-8-1-21-2-10-1-22-1-16-2-29-1-26-2-25-2-35z",
    fill: "#E693BA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1040)",
    d: "m0 0 5 5 3 18 7 24 3 12 2 1 5 14 2 8 2 3 6 18 7 20 6 17 9 22 3 8 3 9 4 9 5 10 4 4-1 4-6-5-11-22-9-17-2-5-3-4-4-14-3-6-3-7-5-17-3-3-3-10-2-9-1-9-4-13-3-14-4-10-1-5-1-7-5-10-1-8-1-6-1-2z",
    fill: "#CE709A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(453,524)",
    d: "m0 0 3 4 4 15 3 16 1 2 2 22 1 3 1 32v32l-1 4 1 7h-2l-1 5-3-1-1-5v-7l-1-9 1-5h-2l-1-25-3-46-2-16-1-19v-8z",
    fill: "#CF6E9A"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 928)",
    d: "m0 0h1v90l-3-4-13-25-8-16 10-19z",
    fill: "#CC8CA1"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(900,1272)",
    d: "m0 0h13l11 2 2 1 3 5-1 3-4 3h-2v2l-10 3-48 4-1 1-37 4h-34v-1l30-1 31-3 13-3h9v-2l-8-1-3-5-7 1-4 4 2-5 2-2 10-3h12l20-6z",
    fill: "#BD5884"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,423)",
    d: "m0 0 3 1-1 6 1 8-1 10 3 1-6 2-7 7-4 8-4 1-3 10-3 5-1 10-3 6v5h-2l-2 9-2 6-1 5h-1v-7l-2 1-2 4 1 3-2 5-3 3-1 5-3 1-1-5-2-1 1-4h2l-2-5 2-1 7-20 1-5 3-3 1-5h2v-11l3-2 2-6 2-3 4-9h2v-2l2-1 1-5 9-1-1-2-3-2 5-2-1-6-1-4 6-2z",
    fill: "#7E274B"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,814)",
    d: "m0 0 27 1v63l-3-4-11-23-6-12 1 10 3 17v8l-2-4-6-38z",
    fill: "#EE867C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,493)",
    d: "m0 0h1v23l-2 2v-9h-2l-4 17-4 23-2 4-2 15-1 15-1 8v128h-3v-25l-1-60v-35l-1-8 1-10-1-19-1-8-1-15-2-2 1-7 2-2h4l1 2 8-7 3-8 3-16h3z",
    fill: "#A83461"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,567)",
    d: "m0 0h1l1 69 1 8v36l1 14v15l1 9v16l1 16v9l-1 3v12l2 32 1 28 1 11 2 50 3 32 1 22-2 2-3-18v-21l-2-17v-21l-1-4-1-29-1-9v-15l-2-20-2-43-1-16-1-58-1-3v-73l1-35z",
    fill: "#A83461"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(802,1278)",
    d: "m0 0 8 1 1 1 13 1h16l9-1-1 3-9 2-15 1v-2l-6 1-17-3 2 3v5h-2l-2-4-3-1-1 3v-3l-11 3-1 1-19 3-14 1-11 1-29 1-18-1h-16v-2l-34 1h-51l-16-1-2 5h-6l1-8-9-1-23-3v-1h19l14 4 15 2h34l23-1 27 1h35l11 1 24 1 1-2h10l9-3 18-4 4-2 11-2z",
    fill: "#BB5481"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,1104)",
    d: "m0 0 2 3 2 6 2 10 4 15 9 30 4 10 6 16 3 6v3h2l3 7 6 10 7 14v2h2v2h2l2 4v5l1 3 6 2 1 4-1 2 4 2 6 4-4 1-3-2h-3l-11-11v-2h-2l-3-5-5-5-4-6v-2l-3-1-5-10-4-5-8-14-1-6 2-2h3l1 5h4l-5-15-2-1-2-9v-4h-2l-4-15-5-17-5-15-1-10-2-4z",
    fill: "#BA5380"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(340,1024)",
    d: "m0 0 4 1-2 7v7l-2 4v9l-2 10-2 8-3 9-2 5-2 12-2 8-6 16-2 7-5 6-1 2h-3l-1-11 5-16 2-3h2l1-7v-9l2-7 1-3h2l4-16 1-9-1-4 2-8 5-8 2-6z",
    fill: "#5E0520"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,503)",
    d: "m0 0h1l4 20 4 24 3 15 2 30 1 17v34l1 18 1 19v16l-1 7 1 25 1 2-2 8h-1l-4-61-1-28-1-9v-26l-1-10v-12l-2-14-1-20-1-15-4-30z",
    fill: "#D883AD"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(13,1261)",
    d: "m0 0 11 2 6 2 14 2v-2l15 1 7 2 1 4 6 2 5 3v2l4 1 6-2 1 2 14 2v1h-13l-29-1-17-2-16-1-22-4-2-1 1-3 5-1z",
    fill: "#5F0521"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,1166)",
    d: "m0 0h2l9 24 7 14v4h2l3 3v2l3 1 4 6 5 8 1 3 5 5 4 7 5 5v2h2l7 8 7 6 4 3 5 1-4 2-8-2-11-7-1-3-4-2-6-6-5-3-12-12-8-11-4-13-6-16-6-24z",
    fill: "#E390B7"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,1246)",
    d: "m0 0 3 1 2 5 5 6 2 1v2h53l44 3 4 1v2l5 1 3 1 1 5-35-1-26-1-27-3-10-3-9-2-6-4-7-7z",
    fill: "#BD5784"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,948)",
    d: "m0 0h1l2 23 3 11 2 21 4 25 3 15 1 10 2 10 3 17 2 6 6 29 2 6 2 9 6 21 4 11 4 13 5 11 4 11v2l3 1 1 7h2v3h2l2 6 3 3 2 5 4 6v2l3 1 5 8 8 11 3 6 4 2 1 2 3 1v3l11-1h9l5 1-4 2h-11l-13 2h-5l-6-7h3 2l-7-5v-5l-6-3v-2l-2-1-1-9h-2v-2h-2l-6-12-10-17v-4h-2l-12-30-7-22-4-13-4-15-4-16-6-28-5-31-2-5-2-18-4-27-4-24-2-21z",
    fill: "#C14476"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,621)",
    d: "m0 0 2 3 5 31 2 13 4 23 2 14 2 7 4 25 2 14 3 17 2 14 2 10 3 14 2 13 1 10 4 18 1 9 2 8 2 16 1 5 4 21 2 8 1 17 3 1 1 15 1 1v7l2 1 1 8 2 11 1 1v9l-3-3-4-17-2-11-2-14-2-6-2-17-2-5v-7l-2-6-1-9-2-10-5-24-1-12 1-2h-2l-2-13-2-11-3-19-6-33-2-12-2-15-3-13-4-29-2-11-2-9-3-24-3-19z",
    fill: "#D77FAA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(100,1264)",
    d: "m0 0 14 2-1 2 8 2v-2h-5l-1-2 13 1 6 3-2 1v2l5-1 1 1h6l1-1h6l-4 1v2h-12l-24-2-9-4h-11l-7 1 9 3 10 1 5 2v1l-8 1 24 3h10l29 3-3 1v2l8 1v1h-10l-5-1-45-2-5-1-27-2v-1h22l-10-1v-2l-7 2-4-2v-2l-10-5 4-1v-2l-6-2 4-2h30z",
    fill: "#7B2A4D"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,1063)",
    d: "m0 0 3 4 26 52v2h-29z",
    fill: "#EE867C"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(761,1293)",
    d: "m0 0 10 1-4 2-4 1h-7v2l8-2h12l3 1 13 1v1l-94 3-50 1h-50l-22-1-87-1v-1l75-1 28 1h43l2-2 4-1 1-1h6 4l6 2h8l-1-2-6-1v-1h10l17 1v2l8 1 31-2h14l14-1z",
    fill: "#A95677"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,1243)",
    d: "m0 0 3 1 5 12 2 7 3 3 5 9 3 3 9 3 33 2 16 2-1 2-6 2h-35l-18-2-7-2h-49l4-2 34-2-1-2z",
    fill: "#EFA3C7"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,1282)",
    d: "m0 0 13 1 10 1v2h-2v6l22-1 9-2 4-5 7-1 3 5 8 2v2l-20 3-2 1-31 3h-43l-9-1-14 1v-2l15-3 2-1 11-1h20z",
    fill: "#712144"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,477)",
    d: "m0 0 3 4 8 18 6 18 7 29 6 28 7 54 2 18 3 39 1 25 4 38 7 39v4l-3 1-3-9-4-26-3-19-2-17-1-36-2-28v-8l1-1-2-1-1-4v-15l-6-48-2-13-12-52-7-19-7-16z",
    fill: "#E6E9E8"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(446,349)",
    d: "m0 0 2 1 2 6 5 5 2 6 5 5 8 15 3 9 2 7-2 5 1 4 2 4-1 12-4 6-4 10-2 3-4-1 3-8 2-6 1-2 1-11-3-9v-8l-5-9-6-9-2-2-5-17-3-12 1-3z",
    fill: "#A63B67"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(113,1236)",
    d: "m0 0h14l7 1 1 1 13 2 16 2 19 2 23 1-1 2-11 1-1 1h-92l-6 1v2l-9 2v-3l4-2 15-10z",
    fill: "#BA5380"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(792,1285)",
    d: "m0 0h7l2 5h2l1-2v4l-31 2h-12l-7 1-1 2-20 1h-10l-33 2-4-2v-2l-3 1-36-2h-20l-19 2h-17l-9-3-7-2v-1l16 1h85v2l17-1 22 1 30-1 5-1 21-2 12-2z",
    fill: "#9E2752"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,1220)",
    d: "m0 0v3l-2 5-5 4-2 5-6 5-6 3v3l-4 2-19 1-67-1h-12l34 4 7 1 23 2v2l2 2-6-1-15-2v2h7v1h-13l-29-2-22-1-14-2 4-2 5-2h4v-2l6-2h92l1-1 11-1 9-9 8-7 4-5h2l2-4z",
    fill: "#9F2B56"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(295,973)",
    d: "m0 0h32v7l-6 29-3 12h-1l-2-8-13-25-7-13z",
    fill: "#CA889F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,1227)",
    d: "m0 0 2 2h-2v2h2l1 2 7 1 2 6v9l1 4h5v2l7-3 2-5 1 3-3 6-4 2-23 1-5-1-15-9-3-2 6-4h2v-2l7-6h2v-3h2v-2l5-2z",
    fill: "#7A183D"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(305,1148)",
    d: "m0 0 4 1-1 6-1 5h-2l-1 8-4 6-3 7-1 1-1 7-5 3-2 1-3 12-2 3-6 3-9 11-5-2 1-2-2-1 2-4 5-2 3-4 2-4v-8l5-7 2-6 2-1 3-6 5-3 1-7 2-5 5-2h4v-8z",
    fill: "#5E0520"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,896)",
    d: "m0 0h2l1 8 2 13 1 8v16l3 3 2 12 2 20 1 5 2 12 1 1 1 14 2 3 1 12 3 20 3 18 3 14 3 21 8 35 2 11 5 16-1 4-4-13-3-9-1-7-3-9-4-16-1-10-2-10-1-8-3-9-4-25-3-19-1-2-1-9-2-7-5-31-2-10-1-9-2-7v-10l-1-16-1-2-2-24z",
    fill: "#A73461"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(589,1235)",
    d: "m0 0 6 4 6 12 5 7 8 6 11 11h-7-2l2 3-1 1 16 3 2 2h-29l-16-1-1-3h8v-6l-4-16-4-18z",
    fill: "#A12C57"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(533,1285)",
    d: "m0 0h12l19 3 4 1-1 8 2 1h-9l1-2h5v-3h-5l2-2-7-1v2l-4 2-26 3-1 1h-19l-26-1v-1l14-1 28-1 5-1v-2l-11 1-22 1h-37l3-2 12-2 14-1 3-1 11-1z",
    fill: "#9E2651"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(430,1067)",
    d: "m0 0 3 2 2 15 3 11 1 14 3 10 1 19 2 4-1 9 1 1 3 35 2 3v6l5 12 1 9 2 4-5-2-3-1 1-4h-2l-3-8-1-13-3-7-1-33-1-11-1-2-1-9-1-8-1-1v-10l-3-9-1-16-2-4-3 1-2 4v7h-2l-1 2v-8l3-11 2-1v-8z",
    fill: "#A83461"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,545)",
    d: "m0 0 3 1 3 9 3 18 4 6 5 36 1 8 1 30 2 12v6l-2-3-3-12-11-65-6-30-1-14z",
    fill: "#EFA4C7"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(149,979)",
    d: "m0 0 4 2 11 13 4 5-1 3-9 6-14 5-11-23-3-5 1-2 1 1h8l8-4z",
    fill: "#F2C3BE"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,979)",
    d: "m0 0h2l9 11 7 8-1 4-11 7-9 3-2 2-11-23-2-6 12-2z",
    fill: "#F2C3BE"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,533)",
    d: "m0 0 5 2 1 4h4l4 11 3 6 2 9-1 4-3-8-3-3-2-6-3 1-2 1-1 5v11l-1 2h-2v28l-1 7 2 2-1 8 4 43 1 9v12h-1l-7-66-3-27v-15l1-7-1-7 1-7 2-7z",
    fill: "#E796BE"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,980)",
    d: "m0 0 6 3h3l12 23 2 4-1 3h-13l-12-3-9-4 2-6z",
    fill: "#FEFEFE"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(805,980)",
    d: "m0 0 10 5 8 16 5 11-3 1h-11l-12-3-10-4 9-19z",
    fill: "#FEFEFE"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(153,1258)",
    d: "m0 0h9l10 2-2-2 16 2 1 3h-6v2l9 1 7 3 8 2 6 3 11 3-1-7 5 2 7 4 8 2 50 1-1 2 43 3v1l-19 1v1h-9l-7-2-8-1-41-1-37-3-15-3-5-3 4-1-1-1-4-3-17-5-21-4z",
    fill: "#B9517E"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,1290)",
    d: "m0 0 2 1-1 3-6 1-32 1 16 1 2 1 28 1 13 1v1h-94l-30-2v-2l-2-1h3l-1-3 11 1 8 2 8-1 10-3h32l22-1z",
    fill: "#772448"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,225)",
    d: "m0 0h2l1 7-3 13-5 13-2 3-2 7-5 3-1 2h-2v2h-2v2l-10 5-9 5h-2v2l-3 2-6 12-1 6 1 4v2h-2l-2-5 1-13 4-8 6-8 3-1 5-6 3-2h3l1-3 6-4h2l1-4 5-6 5-8 2-5 2-3 2-6 1-5z",
    fill: "#D67CA7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,1210)",
    d: "m0 0h2l4 9 4 13 5 7 6 16 7 13 3 3 1 5h2l1 3 14 2v1h-10l-9-3-6-7-3-6v-2l-4-2-2-8-4-10-2-1 1 5v31 3h-6l3-1-2-10-1-9v-9l-2-15-1-1-2-16 1-5h-2l1-5z",
    fill: "#CF6E9A"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,129)",
    d: "m0 0h9l2 1v10l3 5 6 3-4 10-3 3-2 9-1 2-2-1-4-7 1-3-3-1 1-3-1-5-5-2-1 6h-2l-4-9 1-9 4-6z",
    fill: "#6F2144"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,1224)",
    d: "m0 0h3l-1 4-3 1 1 5-5 3-1 3-5 2v2h-2v3l-9 4-9 2h-5l-4-1h-55v2l22 1 18 2h50l-4 2-19 1-29-1-17-2-19-1-17-3-13-1-9-1 2-2h22l57 1 19-1 4-1v-2l-2-1 8-4h2l2-4h2l1-5 6-1v-2l9-3z",
    fill: "#77173C"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,647)",
    d: "m0 0h1l4 85 4 77 3 42 2 24 1 9 4 43 2 18 2 23 1 5 1 14 1 5v9l-2-3-1-9-1-2-2-19-2-13-2-31-2-15-1-10-2-28-1-6-4-69-1-12-4-82-1-30z",
    fill: "#A63864"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(161,1276)",
    d: "m0 0 14 2 9-1 6 2 7 1 2 1 15 2 21 1h36l16 1 19 3 23 1 3 2-5 1h-14l-15-1h-14l-6-1-1 2-1-1-48-1-3-2v-2h-10l-4-1h-11l-4-1v-2h-15l-17-2z",
    fill: "#680929"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(406,719)",
    d: "m0 0h1l1 9v4l4-1 1 2-1 34-2 8v11l-1 3-1 18-2 2-1 5-3-1-1-3 2-25-1-6 2-37z",
    fill: "#D67CA7"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,519)",
    d: "m0 0h1l3 19 1 14 1 3 3 30 2 17v16l1 10 3 33 2 24 1 21 1 5v12l1 5v24l-2-2-2-16-2-36v-9l-1-6-1-20-1-3-2-29-4-44-1-19-1-15-3-27z",
    fill: "#D1729E"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,669)",
    d: "m0 0 2 2 1 5 1 21v18l1 4v11l1 2 1 26 4 37v14l-2-2-1-10-2-5-2-12-1-14-1-3-1-11-1-2v-13l-1-12v-9l-1-9 1-4v-15-2l-1-8z",
    fill: "#C14678"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(189,935)",
    d: "m0 0 4 2 1 1h29l-2 6-8 16-6 11h-2l-8-16-3-7-5-10z",
    fill: "#FDF5E7"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(873,935)",
    d: "m0 0 4 3 29 1-3 8-12 24-3-1-15-32z",
    fill: "#FDF5E7"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(471,1277)",
    d: "m0 0 9 1 4 3v4l-4 3-9 1-14 4-5 1h-9l-11-2-14-4-11-3-1-4 2-2h13l15 6 15 4 10-1v-2l2-1 3-7z",
    fill: "#ED9FC4"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 928)",
    d: "m0 0h1v45h-23l9-19z",
    fill: "#EE867C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,288)",
    d: "m0 0h4l1 2v8l-2 5v10l-4 7-6 1-4-3v-2l-4-1-1-2v-10l1-7h2l2-5 5-2z",
    fill: "#FEFEFE"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,178)",
    d: "m0 0h10l-8 4-3 13 1 6-5 8-1 5-2 2-3 5 1 2-16-1 2-3h3v-3l2-1 3-10 3-7v-7l4-8 3-2h3v-2z",
    fill: "#9B244F"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(586,551)",
    d: "m0 0 4 1 3 7 3 3 1 7h2l2 14 2 7 4 27-1 4-5-24-3-14-2-10-4-6h-2v-2h-2l-2 5-1 6-1 18-1 6 1 16-2 25h-1l-2-26 1-6-2-3 1-8v-24l1-2h2v-13z",
    fill: "#D882AC"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(363,861)",
    d: "m0 0 2 1v12l-3 51-3 25-3 4-4-1-2-2-1-9 5-20 1-5 1-6 3-4 1-10v-19h2v-2l-2-1 2-1-2-5 1-3z",
    fill: "#5E0520"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(481,818)",
    d: "m0 0h1l1 13 2 36 3 55 2 27 5 65 2 13v12l4 38 1 7-2 2-2-17-1-10-2-10-1-16-1-7-3-38-1-8-2-33-3-44-2-46-1-7z",
    fill: "#A73764"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,525)",
    d: "m0 0 2 3v23l-1 3v5l4 1v-5h2l-1-6v-7l3 1v19l-2 21-4 7-3-3-2-4-1-14-3-8-1-3h2v-16l1-13z",
    fill: "#A83461"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,1268)",
    d: "m0 0 15 1 17 2 52 2 9 1-1-4h2l1 5 13-1v1l-18 2-15 2-4-1-9 1-8-1h-8l-9-2h-18l-11-1-8-4z",
    fill: "#EE9FC3"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,1217)",
    d: "m0 0 3 1 4 12 3 2 5 9 6 9v2l7 1 3 2 2-4-2-14-3-12 1-4 6 18 1 7 2 3 2 17 1 6-1 5-2 1-1-9h-5l-6-2-2-3v-3h-2l-5-9-3-3-3-4-4-11-7-14z",
    fill: "#A73360"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,1208)",
    d: "m0 0h3l-1 9-2 2-2 6-6 12-5 6-4 8-2 2-1 3h5l-3 3h-2l-2 4-8 6-3-2 1-6h2l1-4 3-3h2l1-5 1-3-5 3-2-1 5-5h2l1-4h2l1-4 3-5h2l2-4 4-7h2l2-6h2z",
    fill: "#A83461"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(406,964)",
    d: "m0 0h2l1 16-1 5v9l-1 10-1 11-2 2-2 12v6l-2 7-3 25-2 12-2 1-1 10-4 11-1-4 2-9 1-5 2-11 1-18 1-11 3-7 1-9 2-6 2-19 1-10 1-13v-6l1-1z",
    fill: "#A73562"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(530,969)",
    d: "m0 0 3 1 1 2 1 14 2-5h2l3 22 1 1 2 14v25l2 5v2l-1 8-1-3h-2l-1-11-2-4-2-12-1-14-1-3 1-2h-2l-3-25h-1l-1-5z",
    fill: "#D378A3"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,199)",
    d: "m0 0 2 3 1 9 2 9 1 7 3 5 1 5h2l1 5h2l6 8 4 10 4 9 1 5 3 7v9h-2v2h2l3 14-1 3-2-1-3-14-3-9 1-4-4-4-4-12-2-2-2-8-2-7-3-1-1-5-3-1-3-6-2-7-2-3 1-1 1-9-1-3z",
    fill: "#EFC3C4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,567)",
    d: "m0 0h1l1 69 1 8v36l1 14v15l1 9v16l1 16v9l-2 2-1-20-1-11v-15l-1-12v-9l-2-5v-9l-1-3v-73l1-35z",
    fill: "#A73764"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,1267)",
    d: "m0 0h8l6 2 16 3 12 1v1l-6 1 9 2-1 2-9 1-2 1 3 2-9 3-14 3-6 2h-10l-1 1h-24v-1h7v-2l11-2v-1l18-2 20-4 1-1-19-6-5-3-5-2z",
    fill: "#DF86A7"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(496,493)",
    d: "m0 0h1v23l-2 2v-9h-2l-4 14-4 10-3 8-2 10v6h-2v9l-1 5v13l-2 2-1-24-1-8-1-15-2-2 1-7 2-2h4l1 2 8-7 3-8 3-16h3z",
    fill: "#A53A66"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,1253)",
    d: "m0 0 4 2 7 8 12 7 4 1v3h2l-1-5 5 1 2 2 1-2h2l2 3 3 1 4 4 13 4v1l-6 1h-20l-12-5-11-9-4-4-3-5-4-6z",
    fill: "#811C42"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,886)",
    d: "m0 0h251v1h-85l4 10 4 8v2h-17l1-5 5-10 1-4-164-1z",
    fill: "#F1C2BD"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(659,1212)",
    d: "m0 0h2l4 6 3 4v2h3l5 9 9 8 6 7v2h2l7 8 7 6 4 3 5 1-4 2-8-2-11-7-1-3-4-2-7-7-4-7-11-12-8-13-1-3z",
    fill: "#EEA1C6"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,560)",
    d: "m0 0h1l6 45 5 42 2 18 2 21 1-5h1l3 31 1 5v20l1 8v9l-1-2h-2l-4-39-5-57v-7h-2l-3-30-6-51z",
    fill: "#ED9FC5"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,626)",
    d: "m0 0h2l2 35 2 25 2 42 1 13 2 38 2 10 1 21 1 8 1 26-2-2-1-18-2-6-1-15-2-31-1-7-4-78-2-34z",
    fill: "#D780AA"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,1259)",
    d: "m0 0h2l-1 3h-2l-2 4-5 4-11 5h-3v2l-10 2h-40l-10-3-1-3h5l2-2 10 2h7l7 2 1-2 30-2 11-5 4-1 2-4z",
    fill: "#731337"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(466,971)",
    d: "m0 0h1l3 17 2 34 3 24v11l1 10 1 17-2 1v13l1 1 2 26-2 2-2-9 1-6-1-7-2-18v-23l-1-11-1-18-1-8-2-19-1-20-1-14z",
    fill: "#A63B67"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,635)",
    d: "m0 0 2 3 2 15 4 16 1 12 3 16 3 5v-30l2 2 1 11 1 36 3 22 1 10-1-3h-2l-1-7h-1l-2-6-5-31-1-1-2-11-2-15-3-15-3-23z",
    fill: "#EDA1C5"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(558,323)",
    d: "m0 0 2 1 1 5 3 1 4 6 2 7v10l-3 14-4 9-1 2h-2v6l-3 3-4-1 2-12 3 1 2-10 2-4 1-10-2-3-2-2-1-18-2 2-1-1v-5z",
    fill: "#D67CA7"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(577,1171)",
    d: "m0 0 3 1v3h2l3 5 3 4v3h2l1 5 4 2 3 6v3h2l2 7 3 3 1 4 3 2 3 7 2 1 5 9 5 5 10 12 3 3h-3v2h-2v-2l-3-1v-6h-6l-5-10-5-5-1-3-4-4v-2h-3l-2-5v-3l-2-1-1-2-4-3-4-7-1-6-3-1-3-7-3-4-3-8-2-3z",
    fill: "#7F193F"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,919)",
    d: "m0 0 9 4 6 4-5 9-10 15-11-6 2-6z",
    fill: "#F1C3BE"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,1268)",
    d: "m0 0h11l9 4 36 3v-2h8l1 2-8-1v3h-2v2l2 1h-18v2l-16-1-15-2 1-2 6-1-10-2-11-2-3-2z",
    fill: "#620624"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150,920)",
    d: "m0 0 9 3 5 3-1 4-11 17-4 4-6-4-4-2 9-20z",
    fill: "#F1C3BE"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(423,559)",
    d: "m0 0h1l1 8 1 5v5l1 4v8l3 21-1 8v67l-2 4-1 7-3-1 2-18v-71l-1-21-1-4z",
    fill: "#A73663"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(578,649)",
    d: "m0 0h1l3 29 4 43 2 21v10h2l-1-16 2-2 1 2 1 22 2 13 2 25v12h-1l-3-38-2 1v16l-2 1-1-5-1-16-1-5-1-20-2-19-1-16-2-21-2-28z",
    fill: "#E693BB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,1186)",
    d: "m0 0h1v7l-5 33-2 7-1 9-2 4-1 6-3-1-1 4-1-3h-2l-2-16v-3l4 1 1 3 2-8v-10l3-9 4-4 3-9z",
    fill: "#861B42"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(901,948)",
    d: "m0 0 5 1 1 7-3 3-1 19 4 2v6l-4 3h-6l-5-12-2-6 8-17z",
    fill: "#CAE3DD"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,612)",
    d: "m0 0h1l3 24 5 62 1 9v8l3 27 1 25v16l-2-2-1-15v-12h-2l-1-26-1-5v-13l-2-16-1-21-3-37-1-14-1-5z",
    fill: "#D77FAA"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,535)",
    d: "m0 0h1l3 51 1 18v24l2 41 4 75v21h-1l-1-7-1-26-1-11-5-106-2-49z",
    fill: "#CF6E9A"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(776,1262)",
    d: "m0 0h41l7 1v2l8 1v3h10 3l9 1v1h-42l-19-2-15-4z",
    fill: "#B9527F"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(218,947)",
    d: "m0 0 5 3 1 4-2 4-2 1v18l4 5-2 5-2 2-7-1-7-17 8-16z",
    fill: "#CAE3DD"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(515,301)",
    d: "m0 0 12 1 4 2 6 2 6 3v2l4 2 7 5 1 6-4-5-8-6-6-4-4-1v-2l-4 1-8-1-8 2-2-1-2 4-3 1v2l-3 2-2 4-2 2-2 6-3 5-2 1-2 4-10 5-5-1-7-4-5-6-3-2v-2l6 3v2l4 2 5 2h7l6-1 2-6 3-5 2-3h2l1-6 3-5 10-8z",
    fill: "#D67CA7"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(158,1025)",
    d: "m0 0h21l-9 19-5 9-3-4-9-20z",
    fill: "#EE867C"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(841,1025)",
    d: "m0 0h21l-2 6-11 22-2-1-10-21v-2z",
    fill: "#EE867C"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(113,1236)",
    d: "m0 0h14l7 1 1 1 13 2 16 2 19 2 23 1v1h-25l-25-1h-12l-6-1-8 1h-10l-4-1-10-1v-2l-2-1z",
    fill: "#D882AA"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(256,1225)",
    d: "m0 0 5 1 3 4-2 5h-2l-1 3-5 1-1 5h-2l-1 3-7 1-5 4-9 2h-3l-1 2-3-3 1-2 12-6h2l1-3 5-2 2-4h2l2-4z",
    fill: "#5E0520"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,863)",
    d: "m0 0 2 3 1 8 2 7 1 9 1 4 1 7 1 4 1 9 1 3 1 13 2 4 1 11 1 8 1 2 1 7 1 5 2 13h-2v-2h-3l1-7-2-6-2-18-1-5-2-4v-7l-2-1-1-9-2-6v-9l-2-5-2-11-2-4v-20z",
    fill: "#C13D6F"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(13,1261)",
    d: "m0 0 11 2 6 2v3 2l-4 1v-2h-7l2-5-5 2 1 5 4 1 1-2v2l5 1 2 1 1-2 11 3 7 1 7 3 8-1v2l12 1v1h-14l-17-2-16-1-22-4-2-1 1-3 5-1z",
    fill: "#7A294C"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,1279)",
    d: "m0 0h3v2l-18 4-15 5h-8v2l33-3 13-3v2l-10 3-48 4-1 1-37 4h-34v-1l30-1 31-3 13-3h9v-2l-8-1v-6l12 1h10l11-3 3-1z",
    fill: "#DD93AC"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,1121)",
    d: "m0 0h1l2 7v4l4 2h-3l2 7h4l1 1 1 11 5 15 2 1 3 9h-2v2l3-1 3 8 1 3 2 1-3 1-4-1-3-1-3-10-2-4-3-5-3-7-6-28-2-6z",
    fill: "#BA5380"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(672,898)",
    d: "m0 0h1v67l-2-3-4-23-3-16-1-6v-8l2 4z",
    fill: "#E48182"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,1014)",
    d: "m0 0 2 4 5 35 2-1 3 21 2 18 7 39 1 10-3-2-4-19-5-28-2-11-2-19-1-1-4-28-1-2-1-10z",
    fill: "#E390B7"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(487,180)",
    d: "m0 0h6l-4 3-2 1-3 7v7l-5 12-2 6h-2v3l-4 2-14-1 5-5 5-1v-2l2-1 3-6 2-2 2-9 1-4 2-5 4-4z",
    fill: "#7F274C"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,1294)",
    d: "m0 0 7 2h17l19-2h26l12 2 2 4h-12v-2h-5l-2 1v-2l-6 1-2 2h-22l-2-2-5 1-1 1h-13l-10-1h-16l4-4z",
    fill: "#7B1B40"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(792,1285)",
    d: "m0 0h7l2 5h2l1-2v4l-31 2h-12l-7 1-1 2-20 1h-8l-3-1-5-1-2-2 30-1 5-1 21-2 12-2z",
    fill: "#9F2A55"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,1060)",
    d: "m0 0 3 1 2 21 2 9 5 28 4 19 1 1 2-3 6 28 3 7-1 3-2-5v-3h-2l5 22 2 10-3-4-5-19-2-12-3-11 1-5h-2l-2-7-4-18-5-26-3-14 1-11h-2z",
    fill: "#D881AB"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(82,1256)",
    d: "m0 0 36 2 47 3 4 2v1h-22l-43-1-16-1-5-2z",
    fill: "#650A28"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,1102)",
    d: "m0 0 5 1 5 10h-3v-2h-2v-3l-2-1 1-2-7 2-2 3 1 9h-2v7l1 5 1 20 3 5 2 8 3 7 1 2h2l2 12 3 6-1 3-3-2-2-10h-2v-4h-2l-3-7-3-9-2-7-4-32 2-5-1-3v-8l2-3z",
    fill: "#680828"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,1275)",
    d: "m0 0 5 1 1 3 4 1-1 3-4 3-15 4-25 2h-8v-2l10-2 16-5 15-2v-2l-3 1-17-1 1-3 2 1h15z",
    fill: "#C2608B"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(778,1265)",
    d: "m0 0 8 1 3 2v3l7 3 11 1h19l9 2h9l4 2-5 1h-33l-8-1-15 2-13 1 3-3 9-1-11-3v-1l13-1-8-4z",
    fill: "#DF87A8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,1014)",
    d: "m0 0 2 4 3 17 3 21 4 19 3 21 8 35 2 11 5 16-1 4-4-13-3-9-1-7-3-9-4-16-1-10-2-10-1-8-3-9-4-25-3-19-1-7z",
    fill: "#A63865"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(307,1278)",
    d: "m0 0h34l10 3v2l5 1-1 2h-14l-24-2-27-2-1-2 7-1z",
    fill: "#CF6E9A"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,1273)",
    d: "m0 0h9l6 3 10 3 2 3 14 1v1l23 1v1l-33 1-11 1-3 1-17 1 2-2 9-1v-2l4-2-4-4-9-1-3 1-2-1-2 7-2 1v-8l4-4z",
    fill: "#D883AD"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,174)",
    d: "m0 0 4 1-6 2-1 14v32l-6 2-3-2 3-44h2l1-3z",
    fill: "#E390B6"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,1220)",
    d: "m0 0v3l-2 5-5 4-2 5-6 5-6 3v3l-4 2-19 1-67-1h-15v-2h88l1-1 11-1 9-9 8-7 4-5h2l2-4z",
    fill: "#9D2B56"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,545)",
    d: "m0 0 3 1 3 9 3 18 4 6 2 13v6l-3-1-1-3-2-2-2 4-7-35-1-14z",
    fill: "#EFA7C7"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(570,348)",
    d: "m0 0 2 1 1 3v10l-3 9-2 9-3 2-3 9-2 5-1 4-6 3-2 2v-12l3-8 1 2 4-1 1-8h2l3-10 3-9z",
    fill: "#E592B9"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(688,1228)",
    d: "m0 0 4 1 1 3 3 1 5 8 8 11 3 6 4 2 1 2 3 1v3l11-1h9l5 1-4 2h-11l-13 2h-5l-6-7h3 2l-7-5v-5l-6-3v-2l-2-1-1-9h-2v-2h-2l-3-6z",
    fill: "#C14476"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(352,959)",
    d: "m0 0 3 2v6l1 2-2 5 1 4v16l-2 4-8-4-1-6 1-3v-8l3-14z",
    fill: "#5E0520"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(410,576)",
    d: "m0 0h1v10l-3 25-4 48-1 9v13l-4 46-2 1v-19l5-62 5-48z",
    fill: "#A02D58"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,1284)",
    d: "m0 0h19l14 4 15 2h34l23-1 20 1 7 1v1l-26 1h-51l-16-1-2 5h-6l1-8-9-1-23-3z",
    fill: "#BA5380"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,1224)",
    d: "m0 0h3l-1 4-3 1 1 5-5 3-1 3-5 2v2h-2v3l-9 4h-11l2-3h3v-2l-2-1 8-4h2l2-4h2l1-5 6-1v-2l9-3z",
    fill: "#7A183D"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,874)",
    d: "m0 0 2 4-1 7h1l2 12 3 31 4 40v6l-2-2-4-32-2-1-3-36-2-19v-9z",
    fill: "#CF6F9B"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,1283)",
    d: "m0 0h5l3 5 8 2v2l-20 3-2 1-31 3h-16v-1l12-2 20-1v-2h-15v-1l21-1 9-2 4-5z",
    fill: "#7C1B40"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,1100)",
    d: "m0 0 2 4 4 10 2 8 2 3 6 18 7 20 6 17 9 22 3 8 1 5h-2l-4-9-3-7v-5h-2l-1-5h-3l-1-8-5-11-2-9-4-9-5-15v-7h-2l-4-11-4-13z",
    fill: "#E0A3B9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,877)",
    d: "m0 0h2l-1 31-2 21-1 14-2 19-2 21-3 14-2 3v-10l2-8v-10l2-12v-11l1-4 4-50z",
    fill: "#BF4A7A"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(985,815)",
    d: "m0 0h17v34l-3-4-14-29z",
    fill: "#ED867C"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,1260)",
    d: "m0 0 4 1-1 3h8l7 1h3l3 1-1 2h2v2h-8l-1 1h-16l-12-1-6-3-3-2v-2l2-1 14-1z",
    fill: "#BA5380"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1040)",
    d: "m0 0 5 5 3 18 7 24 3 12 2 7 7 22v2h2l2 10 3 7v5l-2-2-5-12-2-9-3-4-6-20-3-14-4-10-1-5-1-7-5-10-1-8-1-6-1-2z",
    fill: "#CC89A2"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,477)",
    d: "m0 0 3 4 8 18 6 18 7 29 6 28 7 54 1 7v9h-2l-1-7-1-2-1-15-5-40-2-13-12-52-7-19-7-16z",
    fill: "#D9E6E0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(184,978)",
    d: "m0 0h7l2 4h8l-3 7-7 13-3 7-2 2v-23l-4-2v-6z",
    fill: "#F1BBB6"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(868,978)",
    d: "m0 0h6l3 3 7 1-1 4-10 21-3 3-1-21-4-4 1-5z",
    fill: "#F1B8B2"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(678,998)",
    d: "m0 0 2 4 8 35 5 24 8 31 1 8-2-1-6-23-5-17-1-14-3-1-2-4 1-6-4-12-1-5-1-4 1-4h-2l-2-3v-6z",
    fill: "#E596BC"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(161,1276)",
    d: "m0 0 14 2 9-1 6 2 7 1 2 1 15 2 21 1h36l16 1 13 2v1l-36-1-35-1-18-1h-11l-4-1v-2h-15l-17-2z",
    fill: "#77183C"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(100,1264)",
    d: "m0 0 14 2-1 2 8 2v-2h-5l-1-2 13 1 6 3-2 1v2l5-1 1 1h6l1-1h6l-4 1v2h-12l-24-2-9-4-4-1h-27l-2 1-4-3 4-1h30z",
    fill: "#A33460"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,1123)",
    d: "m0 0h2l4 17 1 7h2l1 9 4 17 2 11 4 12 3 4 6 18 1 4-4-4-7-16-4-12-5-17-5-22-3-13-2-7z",
    fill: "#CF6E9A"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(371,1278)",
    d: "m0 0 7 2 12 1 8 4v4h-29l-4-2 1-4 4-2z",
    fill: "#E18AAC"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,814)",
    d: "m0 0h42v1h-41l1 70 2 3-2 4-1 88-1 2v7l-2-4-2-13 3 1z",
    fill: "#F1C3BE"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(294,1189)",
    d: "m0 0v3l-7 13-7 8-4 6-6 5-1 2h-2l-2 5-6-5-4 1-3 2 2-6 7-6 4 1 1 3h2l8-10 4-3 3-1 2-4 2-10z",
    fill: "#690523"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,915)",
    d: "m0 0h1l1 19 4 5-2 5-5 2-4-2-1-2h-7l2-5 8-15z",
    fill: "#CDE4DE"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,621)",
    d: "m0 0 2 3 5 31 2 13 4 23 2 14 2 7 3 18v7h-1l-3-10-1-1-4-29-2-11-2-9-3-24-3-19z",
    fill: "#D781AB"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,1292)",
    d: "m0 0h6l4 3h-9l-1 3h15l11 1h10l2-2 5 1 1 1 26 2v1h-62l-23-1h-7v-1l10-2 2-1 9-1z",
    fill: "#762447"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(658,1243)",
    d: "m0 0 3 3v3l5 5h3l2 1v2l2 1v3l3 1v2h5l2 3 3 1v2l3-1 7 5 6 3 1 3 9 1 6 1v2h-12l-6-2-14-1v-1l7-1-4-5-14-7-5-5v-2l-4-2-8-9-1-4z",
    fill: "#810D32"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,831)",
    d: "m0 0 3 2 2 30 2 11 2 25v12l-1-4-2-1-3-23v-10l-2-17-1-5-1-10z",
    fill: "#BF4A7A"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(871,933)",
    d: "m0 0 2 3 8 18-5 1-1 3-6 1-4-4 1-5 4-2-5-6 1-5z",
    fill: "#F1B5AF"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,329)",
    d: "m0 0h6l3 6-1 12-1 1h-7l-4-4-3-7 1-4 3-3z",
    fill: "#A63C68"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(761,1293)",
    d: "m0 0 10 1-4 2-4 1h-7v2l8-2h12l3 1 13 1v1l-88 1-10-1v-1l31-2h14l14-1z",
    fill: "#7F284C"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,1290)",
    d: "m0 0 2 1-1 3-6 1-32 1-12 1v1h-16l-2-1 1-3 7-1 46-2h8z",
    fill: "#7C1A3F"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(187,933)",
    d: "m0 0 2 3 8 15-1 4-4 2-2 2h-5l-3-3 1-7 2-1 1-3-4-2 1-7z",
    fill: "#F1B5AF"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,1226)",
    d: "m0 0 3 4 4 11 4 7 4 12 1 4-4-2-2-8-4-10-2-1 1 5v31 3h-6l4-2-1-3-2-33-1-12z",
    fill: "#D77FAA"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(234,916)",
    d: "m0 0h1l1 18 4 3v6l-4 3-5-1-3-3-6-1 8-16z",
    fill: "#CCE4DE"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,561)",
    d: "m0 0h2l4 27 10 93v10h-1l-2-14-2-22-5-39-3-25-3-24z",
    fill: "#F9CDDD"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(468,307)",
    d: "m0 0h5l5 4 1 4-2 5-8 2-5-1-1-3-4-1-1-6 2-3z",
    fill: "#F0A3C8"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,1221)",
    d: "m0 0 2 3 4 10 2 12 2 3 2 17 1 6-1 5-2 1-1-9h-5l-6-2-2-3v-3h-2l-2-3v-3l4 1 6 5 7 1-2-11v-3h-2l-3-13-2-10z",
    fill: "#A53965"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,719)",
    d: "m0 0h1l3 29 7 39v4l-3 1-3-9-4-26-1-14-1-11v-12z",
    fill: "#E9DADE"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(572,727)",
    d: "m0 0 3 4 1 27 4 37v14l-2-2-1-10-2-5v-12-4l-1-10-2-4v-19l-2-13z",
    fill: "#C14678"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(19,1264)",
    d: "m0 0h2l-1 4 10 2-2-4h12l4 1v-2l15 1 2 2-7 1v1h-6l1 3-2 1h-12l-5-1h-4l-9-2-2-6z",
    fill: "#690A2A"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(449,369)",
    d: "m0 0 5 3 6 7 3 8 2 1 2 13 2 1 1 6-1 11-2-1-2-8v-8l-5-9-6-9-2-2-3-9z",
    fill: "#A83461"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,899)",
    d: "m0 0h2l2 7 2 21 2 18 2 23 1 5 1 14 1 5v9l-2-3-1-9-1-2-2-19-2-13-2-31-2-15z",
    fill: "#A63864"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,899)",
    d: "m0 0 2 1 3 26v16l2 27v10l1 9-1 6h-1l-3-39-3-36z",
    fill: "#A73763"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(452,636)",
    d: "m0 0h1l1 8v36l1 14v15l1 9v16l1 16v9l-2 2-1-20-1-11v-15l-1-12v-9l-2-5 1-18v-33z",
    fill: "#A63B67"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,534)",
    d: "m0 0 4 2v3h4l4 11 3 6 2 9-1 4-3-8-3-3-2-6-3 1-2 1-1 5-2-1-1-10-1-1 1-8 1-1z",
    fill: "#E690AE"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(586,551)",
    d: "m0 0 4 1 3 7 3 3 1 7h2l2 14 2 7 4 27-1 4-5-24-3-14-2-10-3-9v-2h-2v-2h-3l-4 8-2-2v-7z",
    fill: "#D983AD"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1055)",
    d: "m0 0h2l5 13 1 5 4 12 4 14 4 16 2 6-1 4-4-8-3-8-1-2h2l-3-8-3-7-2-11-2-1h2l-8-20z",
    fill: "#CF6E9A"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,522)",
    d: "m0 0h1l3 23 1 13 1 20 2 14v18l1 7-1 17h-1l-4-56-1-24-2-22z",
    fill: "#E692B7"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(186,1260)",
    d: "m0 0 21 1 5 1h7l-2 1v2l4 2v1h-29l-11-3v-2l5-1z",
    fill: "#A63B67"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,681)",
    d: "m0 0h1l3 31 1 5v20l1 8v9l-1-2h-2l-3-31v-12l-1-18z",
    fill: "#F1B6CF"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,1282)",
    d: "m0 0 13 1 10 1v2h-2l1 6 15 1v2l-4 1-16 1-4 1-8-1v-2h7l1-5-1-3-5-2-3 1-2 2z",
    fill: "#701A3E"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,1290)",
    d: "m0 0h34l33 2-1 2-25 1-18-1h-16v-2h-8z",
    fill: "#BA5380"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(554,622)",
    d: "m0 0 2 1-1 9-1 7-3 4-2 9h-2l-1 3-4-2 1-4-4-1-3 1-2-1-2 4-1-8 4-3h5l3 2 5-1 2-6 2-9z",
    fill: "#C23E70"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,177)",
    d: "m0 0h2v2h-2v19l-2 25-1 1h-5l-1-3 3-12 1-16 1-10 1-4z",
    fill: "#CE6D99"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,1284)",
    d: "m0 0h17l13 2v1l-23 4h-34l-15-2-2-2h8l11 1h29l6-2-10-1z",
    fill: "#E792B0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(542,1232)",
    d: "m0 0 4 2 5 10 4 11 7 13 3 3 1 5h2l1 3 14 2v1h-10l-9-3-6-7-3-6-3-10-5-12-3-5z",
    fill: "#CF6F9B"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,641)",
    d: "m0 0h1l1 10v68h-3v-25l-1-50z",
    fill: "#A63763"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(742,1267)",
    d: "m0 0h8l6 2 16 3 12 1v1l-6 1 9 2-1 2-12 1-22-7-5-3-5-2z",
    fill: "#DF85A7"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,800)",
    d: "m0 0h1v8l3 1v13l2 13 2 19-1 5-2-1-3-20v-16l-3-1-2-20z",
    fill: "#A73562"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(493,149)",
    d: "m0 0 6 3 1 7-2 1 4 1v4l3 6 4 2-3 1-12 1-3-1 1-3h2v-8-3l-3-4 1-6z",
    fill: "#5E0520"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,371)",
    d: "m0 0 1 3-3 6-2 8-2 4-2 10-4 10-2 7h-2l1 6-2 13-3 6h2v2h-2v3l-4 1v-2l-2-1 4-1 3-19 3-12 2-7 5-14 5-15 2-7z",
    fill: "#EFC4C4"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,590)",
    d: "m0 0 2 3 2 19 2 9 3 24 4 20v6l-2-3-3-12-9-54v-11z",
    fill: "#E798BE"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,787)",
    d: "m0 0 2 4h2l3 15v9l7 42v6h-2l-3-17-5-32-2-10-2-11z",
    fill: "#EFC4C4"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(159,1265)",
    d: "m0 0h11l1 4h10l9 2 1 3-7-2 2 4-14-1-2-1-9-1-2-3-2-1v-2h2z",
    fill: "#AC436F"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,663)",
    d: "m0 0 1 4 1 17-2 11v18l-2 22h-2v-30l2-26v-10z",
    fill: "#BF4A7A"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,179)",
    d: "m0 0 3 1-4 2-3 13 1 6-5 8-1 5-2 2-3 5 1 2h-4v-2l-2-1h2l2-5h2l2-11v-7l3-2 1-7 2-7z",
    fill: "#A63B67"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,1102)",
    d: "m0 0h1v7l-5 16-1 8-2 3-2 9-2 1-5 13-9 19-4 6-1-4 6-12h2l3-9 4-9 3-11 3-4 2-11 3-10z",
    fill: "#A63C68"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(660,1162)",
    d: "m0 0h1l4 13 5 11 4 11v2l3 1 1 7h2v3h2l2 6 3 3 2 5 1 4-4-2-11-19v-4h-2l-14-35z",
    fill: "#C24274"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(499,535)",
    d: "m0 0h1l3 51 1 18v22l-2 2-1-13-2-49z",
    fill: "#D276A1"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387,860)",
    d: "m0 0h1v14l-2 21-1 10-2 22-4 34h-1v-21l3-26 1-3 3-36z",
    fill: "#A63965"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(476,586)",
    d: "m0 0 2 2 1 3v39l-1 11-2 1-1-5v-38l-1-8z",
    fill: "#A73562"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(396,1037)",
    d: "m0 0 2 4-2 15 2-1-2 20-1 4-2 1-1 10-4 11-1-4 2-9 1-5 2-11 1-18 1-11z",
    fill: "#A63461"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(165,889)",
    d: "m0 0 3 4 6 12v2h-17l1-5z",
    fill: "#EE867C"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,738)",
    d: "m0 0 3 3v9h2l2 7 2 13 3 16v5l-4-2-3-12-3-23-2-8z",
    fill: "#E897BF"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(517,669)",
    d: "m0 0h1l1 11v16l-1 7 1 25 1 2-2 8h-1l-2-32v-28h2l-1-6z",
    fill: "#D67CA7"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,615)",
    d: "m0 0 2 3 4 23 3 12 3 20 2 9 2 15h-3l-3-16-1-13-4-15-2-15-3-15z",
    fill: "#EFA6C7"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(186,1286)",
    d: "m0 0h16l4 1 7 3v2h-16l-20-1-9-1v-2l18-1z",
    fill: "#873759"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749,1238)",
    d: "m0 0 3 1 4 5 4 4 3 6 7 7 9 5 2 3 7 3 1 2-17-1v-1l8-1-7-4v-2l-6-2-6-5-5-7v-2h-2l-1-3-4-3z",
    fill: "#BD517F"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,985)",
    d: "m0 0h1l2 32 2 10v12l4 38 1 7-2 2-2-17-1-10-2-10-1-16-1-7-2-26z",
    fill: "#A73662"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,889)",
    d: "m0 0 3 3 7 15h-17l1-6z",
    fill: "#EE867C"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(322,1040)",
    d: "m0 0 3 3-1 9v9l-5 13-5 4-2-4v-3h2l1-3h2v-9l2-11h2z",
    fill: "#680929"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,482)",
    d: "m0 0h2l3 6h2l5 11 2 5 5 8v3h2l2 6 2 1 3 5v3h-2l-1-4-3-1-6-12-4-5-3-2-2-9h-3-1z",
    fill: "#EFC4C4"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1096)",
    d: "m0 0h1v25h-13l9-19z",
    fill: "#EE867C"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(213,958)",
    d: "m0 0 4 1v19l-4 4h-2l-5-11z",
    fill: "#A1D0C4"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,330)",
    d: "m0 0 2 1-4 9-4 13-4 19-2 1-2-4 1-6 3-9 1-2h-2l1-5 4-12h2l2-4z",
    fill: "#FEFEFE"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(36,1255)",
    d: "m0 0 25 1 1 2 10 1 2 2h-29l-13-2-3-2 4-1z",
    fill: "#97254F"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(692,1293)",
    d: "m0 0 18 1 7 1 5 1 2 1-1 1-33 2-4-2v-2l-3 1-1-2z",
    fill: "#9D244F"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,985)",
    d: "m0 0 2 2 1 11 2 1v7l1 3h2v7l2 2 1 7 3 9v5l-3 1-3-9-2-9-2-5-1-9-3-10z",
    fill: "#D581A8"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(346 1e3)",
    d: "m0 0 4 1v12l-5 7-4 1-3-5 1-5 4-9z",
    fill: "#5E0520"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,1273)",
    d: "m0 0 13 3 1 1h9l5 3 12 4 13 1v1h-15l-34-6-2-2 2-1z",
    fill: "#EB9BBD"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(799,1275)",
    d: "m0 0h27l9 2h9l4 2-5 1h-33l-8-1-6-1z",
    fill: "#E690AD"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,720)",
    d: "m0 0h2l1 26 1 32 1 38-2 2-3-80z",
    fill: "#A73763"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(197,954)",
    d: "m0 0h15l1 1-1 7-5 9h-2z",
    fill: "#FAF1E4"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,1152)",
    d: "m0 0h2l1 3 2 27v26l-2-2-1-8v-9l-1-9-2-7v-19z",
    fill: "#A63A66"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,1121)",
    d: "m0 0h2v2h2l4 20 2 5-1 2 3 1 1 5 1 10h-2l-1-7-2-3-1-5-3 1-5-23z",
    fill: "#871B43"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(193,1267)",
    d: "m0 0h23l7 2-2 1 1 7-7-1-9-3-3-2-9-2z",
    fill: "#99254F"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,1143)",
    d: "m0 0 2 2v4h2l3 15 3 7-1 3-2-5v-3h-2l5 22 2 10-3-4-5-19-2-12-3-11v-8z",
    fill: "#D781AB"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(577,1171)",
    d: "m0 0 3 1v3h2l3 5 3 4v3h2l2 5 2 9 3 5v2h2l1 6-4-3-4-7-1-6-3-1-3-7-3-4-3-8-2-3z",
    fill: "#831A41"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(897,957)",
    d: "m0 0 3 2v19l-5 4-5-9 2-6z",
    fill: "#A1D1C5"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(884,954)",
    d: "m0 0h11l2 2-1 5-5 10-3-1-6-13v-2z",
    fill: "#FAF2E5"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,1014)",
    d: "m0 0 2 4 3 17 3 21 2 9h-2l2 8v6h-1l-3-12-4-28-2-12-1-7z",
    fill: "#A73764"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,1215)",
    d: "m0 0 3 4 8 12 11 12 2 3v3l-4-2-12-12-8-11-2-8z",
    fill: "#E48EAF"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(377,961)",
    d: "m0 0h1v12l-2 9-1 14-2 7v9l-1 2-3 19h-1v-10l2-14 1-13 2-11 1-17z",
    fill: "#A63965"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(667,956)",
    d: "m0 0h2l2 9 3-1v8l-1 1 2 16h2l1 10-4-1-2-7v-5l-1-1-1-9-2-7-2-12z",
    fill: "#E495BB"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,635)",
    d: "m0 0 2 3 2 15 4 16 1 12 3 16 1 15h-1l-4-18-2-15-3-15-3-23z",
    fill: "#E693BA"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,1284)",
    d: "m0 0h19l14 4 15 2 26 1v1h-35l-2 5h-6l1-8-9-1-23-3z",
    fill: "#CB6A94"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,1018)",
    d: "m0 0h5l3 3h24l-2 6-1-2h-21l-2 4-3 1v-3h-2l-3-8z",
    fill: "#F1BBB5"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(284,1287)",
    d: "m0 0 45 2 3 2-5 1h-14l-15-1h-14l-6-1-1 2-1-3-3-1z",
    fill: "#670929"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(424,701)",
    d: "m0 0 2 1-1 33-1 22-1 1v5l-3-3 1-17 2-32v-9z",
    fill: "#A73663"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(521,354)",
    d: "m0 0 3 1v2l6 1 2 1h8l4-2 2 4-7 7-5-1-5-3-7-4z",
    fill: "#C24678"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(575,1291)",
    d: "m0 0 16 1h27l9 2v1l-19 2h-17l-9-3-7-2z",
    fill: "#85264C"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,1259)",
    d: "m0 0h2l-1 3h-2l-2 4-5 4-11 5h-3v2l-5 1v-2h-6l-2-3 2-1 12-1 11-5 4-1 2-4z",
    fill: "#7D193E"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,734)",
    d: "m0 0 2 2 1 22 2 13 2 25v12h-1l-3-38-3 1-1-2-1-17h2l-1-16z",
    fill: "#E796BC"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(827,1265)",
    d: "m0 0 5 1v3h10 3l9 1v1h-42l-5-2 4-3z",
    fill: "#A73C68"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(405,931)",
    d: "m0 0 1 2v23l-2 12-1 17-4 15h-1v-10l2-8v-10l2-12v-11l1-4 1-13z",
    fill: "#BE4B7B"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,754)",
    d: "m0 0h1l1 9-1 25-2 18v8l-1 2-1 12h-1v-17l1-9 2-46z",
    fill: "#BF4A7A"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(147,1018)",
    d: "m0 0h7l3 2v2h20l3 1-1 3h-21l-3 3-4-2-4-7z",
    fill: "#F1B7B2"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(289,1284)",
    d: "m0 0h9l9 2v-1h28l1 2 12 1v1h-16l-32-1-11-2z",
    fill: "#9D2A55"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,1060)",
    d: "m0 0h1l6 34 2 8 1 8 2 6 4 16 2 10v5l-2-3-5-18-4-21-3-12-3-20-1-3z",
    fill: "#A63966"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(513,779)",
    d: "m0 0h1l2 10 1 21 1 8 1 26-2-2-1-18-2-6-1-15z",
    fill: "#D883AD"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,179)",
    d: "m0 0h4v8l-2 18-1 18-4 1z",
    fill: "#D780AB"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(168,1262)",
    d: "m0 0 6 1 17 5v2h-17l-3-1-1-3-45-2v-1h43z",
    fill: "#97254F"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,516)",
    d: "m0 0h2v13l-2 14-2-4-2 2-4-1-1-3 4-8 2-1 1-5-1-3h2z",
    fill: "#722144"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(237,1281)",
    d: "m0 0 12 1 41 1-3 3-17-1h-35l-2-2z",
    fill: "#99254F"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,1220)",
    d: "m0 0v3l-2 5-5 4-2 5-6 5-6 3v3l-4 2h-6l3-3 8-6 7-8 8-8h2l2-4z",
    fill: "#873658"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,1042)",
    d: "m0 0 2 2 4 19 8 31 6 18 4 9-4 2-3-11-4-12-9-35-4-17z",
    fill: "#CA869F"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,1246)",
    d: "m0 0 3 1 2 5 5 6 2 1v2h53l26 2v1l-33-1h-40l1 2-6-2-8-7-4-5z",
    fill: "#DA88AB"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,573)",
    d: "m0 0 2 4 1 9h2l3 12 2 12 2 18 1 5-2 2-5-23-3-22-3-11z",
    fill: "#EA9DC0"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,220)",
    d: "m0 0h24l-2 4-12 2h-15l-1-2 5-2z",
    fill: "#A63C68"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(327,1279)",
    d: "m0 0h13l11 2v2l5 1-1 2h-14l-10-2-4-4z",
    fill: "#E28CAB"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(637,808)",
    d: "m0 0 2 4 3 9 2 10 2 12 1 4 1 15 1 12h-1l-4-18-1-12 1-2h-2l-2-13-2-11z",
    fill: "#D780AB"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(800,956)",
    d: "m0 0 2 1 6 13-1 6-2 3h-2l-4-7-1-10z",
    fill: "#A1D1C5"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,718)",
    d: "m0 0h1l1 7 1 2-1 5 2 12v18l3 9v5l-2 3 2 1-2 4-1-4-1-14-1-3-1-11-1-2v-13l-1-12z",
    fill: "#BA5380"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,1282)",
    d: "m0 0h5l3 2h14l27 1v1l-33 1-11 1-3 1-17 1 2-2 9-1v-2z",
    fill: "#DB81A5"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,956)",
    d: "m0 0 2 2 6 13-2 6-1 2-4-2-3-7v-10z",
    fill: "#A1D1C5"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,468)",
    d: "m0 0h2l1 10 1 23v12l-3 1-1-6z",
    fill: "#EC9EC4"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,863)",
    d: "m0 0 2 1 1 31-1 5h-2l-2-9v-16z",
    fill: "#BB507E"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(86,1254)",
    d: "m0 0h3v2l4-1h12l10 1 4-1 4 2 37 3v1h-13l-29-2-22-1-14-2z",
    fill: "#8F224B"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,1281)",
    d: "m0 0 19 1 8 1v2l-5 1h-31l-3-2h7v-2z",
    fill: "#8F1C43"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(147,1273)",
    d: "m0 0h8l1 2-8-1v3h-2v2l2 1-20-1-3 1-11-2 1-2 12 2v-3l-2-1h10l12 1z",
    fill: "#731439"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,921)",
    d: "m0 0h2l1 23 3 23-1 9-2 1v-6h-2l-1-10 1-15z",
    fill: "#A63965"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(232,903)",
    d: "m0 0h5l3 2-1 7-3 4h-2l-1 2-2-5-5-3-10-1v-1l11-1z",
    fill: "#FAFAF7"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(417,1291)",
    d: "m0 0 8 1 1 4-1 3h19v1h-30l-16-1v-1l17-1v-4h2z",
    fill: "#994567"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(355,1184)",
    d: "m0 0h1l-1 7-3 2-2 6-3 1-3 9-3 7h-2l-2 6-2 5h-2l-2 4-4 2v-3l5-5 5-10 5-7 3-8 3-1 1-6 3-5h2z",
    fill: "#A63C68"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(509,1138)",
    d: "m0 0h2l5 12 3 4 1 5h2l3 7 2 7 3 5 2 6-1 4v-3h-2l-3-7-2-4v-4l-2-1v-5l-3-3-1-5h-3l-1-6h-3l-1-4-1-2z",
    fill: "#A83461"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,274)",
    d: "m0 0 4 2v2h2v2h2v2h2l4 6v2l5 2 6 12v5l-4-5-4-6-10-13-7-9z",
    fill: "#A63C68"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(95,1253)",
    d: "m0 0h24l9 1 1 1 8 1 1 2h-15l-4-2-8 1-6-1h-14l1-2z",
    fill: "#BA5380"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(466,971)",
    d: "m0 0h1l3 17 1 19-1 3v10l1 6-2-1-2-16-1-21-1-14z",
    fill: "#A73764"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(425,1293)",
    d: "m0 0 11 1 8 2 9-1 2 2-2 3-28-1v-2l-2-1h3z",
    fill: "#752346"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,1294)",
    d: "m0 0 7 2 21 1-2 3h-13l-10-1h-16l4-4z",
    fill: "#6F1135"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(916,903)",
    d: "m0 0 6 1 2 5-2 4-5 4-1-3-3-2v-2l-14-1v-1l11-1z",
    fill: "#FBFBF7"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,129)",
    d: "m0 0 5 1v10l3 5 6 3-4 10h-2l-1-6-1-4-4-2-2-10-1-4z",
    fill: "#B35C81"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(306,1288)",
    d: "m0 0h26l21 1v4h-20l-6-1 2-2-23-1z",
    fill: "#73153A"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(810,1280)",
    d: "m0 0 16 1h14l9-1-1 3-9 2-15 1v-2l-6 1-10-2 2-1z",
    fill: "#BA5380"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(900,1272)",
    d: "m0 0h13l11 2 2 1 2 5h-5l2-1-3-3-4 1-3 1h-16l3-3-3-2z",
    fill: "#E18DAA"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(574,1292)",
    d: "m0 0h6l4 3h-9l-1 3h15l2 1v2l-9 1-23-1h-7v-1l10-2 2-1 9-1z",
    fill: "#762245"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(470,1280)",
    d: "m0 0 12 3 2 2-4 3-9 1-2 1h-8l5-6 1-3z",
    fill: "#EFA2C7"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,893)",
    d: "m0 0h1v87l-1 2v7l-2-4-2-13 3 1z",
    fill: "#F1C3BE"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(877,984)",
    d: "m0 0h6l-2 6-8 15h-1v-16z",
    fill: "#EE867C"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(784,1292)",
    d: "m0 0h11v1h-6v2l5 1v1h-13l-5 1h-12l-8 1v-2l15-3 2-1z",
    fill: "#7A193E"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,647)",
    d: "m0 0 2 1 4 13v7l-1 10h-2v11h-1l-1-12z",
    fill: "#D883AD"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(410,576)",
    d: "m0 0h1v10l-3 25-4 47h-1l-1-11 5-48z",
    fill: "#A1305B"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,1287)",
    d: "m0 0 10 1 12 4 8 1h14l-3 2-5 2-11-1-13-3-9-2z",
    fill: "#C05B87"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(687,1041)",
    d: "m0 0 2 2 5 22 7 27 1 8-2-1-6-23-5-17z",
    fill: "#E79CBE"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(371,1278)",
    d: "m0 0 7 2 12 1v1l-14 2v3l2 2h-9l-4-2 1-4 4-2z",
    fill: "#DF88AA"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,1184)",
    d: "m0 0 1 4-3 13-4 9-2 7h-2v7l-6 14-2 1 4-16 3-7h2v-7l6-16z",
    fill: "#7D2145"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,998)",
    d: "m0 0h1l3 27 3 25v8h-1l-2-10-4-30-1-4v-10z",
    fill: "#ED9FC4"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,770)",
    d: "m0 0h2l1 2 2 25v6l-3 1-1-6-2-21v-6z",
    fill: "#F0A6C9"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,1192)",
    d: "m0 0 4 3 2 5v3h2l2 7 3 3 1 4 3 2 3 7 2 1v2l-4-2-6-8v-3h-2l-3-6v-2h-2l-3-5-2-5z",
    fill: "#7C1338"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(556,1290)",
    d: "m0 0h8l-1 2 3 1v3l-5 1h-22l-1-2 2-1 12-1 4-1z",
    fill: "#821A41"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(259,1246)",
    d: "m0 0h7l6 6 7 4v2l3-1 2 2h-9l-14-8-4-4z",
    fill: "#7F284C"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,761)",
    d: "m0 0 1 4h2l1-3 5 25v4l-3 1-3-9-3-17z",
    fill: "#F2C9CF"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(259,1264)",
    d: "m0 0 16 1-3 6-8 1h-16v-1h6l1-2h6l2 1v-2h-2l-1-2z",
    fill: "#A53B67"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(743,1215)",
    d: "m0 0 4 5 4 10 4 8 4 4-1 4-6-5-7-14-2-6z",
    fill: "#DB85AB"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597,866)",
    d: "m0 0 2 1 2 20 1 11v11l-2 3-1-7-3-37z",
    fill: "#E693B9"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,1290)",
    d: "m0 0 2 1-1 3-6 1h-28v-3l22-1z",
    fill: "#841A41"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(193,984)",
    d: "m0 0h6l-1 5-8 15h-1v-16z",
    fill: "#EE867C"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(603,313)",
    d: "m0 0 4 1h4l-2 7-8 7-3-4 1-5z",
    fill: "#F9CDDD"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(823,1292)",
    d: "m0 0h19v2l11 1v1l-31 3h-16v-1l12-2 20-1v-2h-15z",
    fill: "#A4406A"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,329)",
    d: "m0 0 4 1 4 6 2 7v10l-1 6h-1l-1-11-2-3-2-8h-3z",
    fill: "#D984AE"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(354,1283)",
    d: "m0 0h5v3l6-1 1 2 3 2h-21l-13-1v-3h20z",
    fill: "#C6638F"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(109,1238)",
    d: "m0 0h6l3 3 3 1h18l-1 2-8 1h-10l-4-1-10-1v-2l-2-1z",
    fill: "#D0719C"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,1268)",
    d: "m0 0h11l4 2v2l-3 2h-10l-11-3 2-2z",
    fill: "#600622"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(153,1258)",
    d: "m0 0h9l10 2-2-2 16 2 1 3-11 2-5-2-18-3z",
    fill: "#AC436F"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,129)",
    d: "m0 0 5 2 3 5v13l-5 7-1-2 3-5-6-4-3-5 1-9 2 1 2 9 4 4v2h2l-2-12z",
    fill: "#E8D4DA"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(911,1286)",
    d: "m0 0h7v2l-9 2-25 2h-8v-2l23-3z",
    fill: "#A23661"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,522)",
    d: "m0 0h1l3 23 1 13v28h-1l-1-8-1-24-2-22z",
    fill: "#E693BB"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,847)",
    d: "m0 0 2 3 1 4 3 24-1 15h-1l-4-37z",
    fill: "#C24476"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,1070)",
    d: "m0 0 2 3 1 16v9l1 1 2 26-2 2-2-9 1-6-1-7-2-18z",
    fill: "#A83461"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(139,1242)",
    d: "m0 0h12l55 3v1h-25l-25-1h-12l-5-1z",
    fill: "#D889A9"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(659,1295)",
    d: "m0 0h10l17 1v2l4 2h-23l-2-3-6-1z",
    fill: "#7F284C"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(115,1266)",
    d: "m0 0 13 1 6 3-2 1v2l5-1 1 1h6l1-1h6l-4 1v2h-12l-10-1v-4h-4v-2h-5z",
    fill: "#A63B67"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(44,1265)",
    d: "m0 0 15 1v1l-8 1v1h-7l-6-1 6 2v2h-10l-4-1-2-5h12l4 1z",
    fill: "#6F1135"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(577,1185)",
    d: "m0 0 2 1v4h2l3 7 4 10 7 17 2 3-1 3-4-7-6-11-3-10-4-9z",
    fill: "#A63865"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(363,890)",
    d: "m0 0 4 4v13l-3 13h-2v-12z",
    fill: "#79183D"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(377,779)",
    d: "m0 0 5 2-1 13-3 3h-5l1-8 2-2z",
    fill: "#851A41"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(471,1277)",
    d: "m0 0 9 1 4 3v2l-11-1-3-1-3 1-1 4-4 3 2 2-8-1 3-2h2v-2l2-1 3-7z",
    fill: "#E591B6"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1040)",
    d: "m0 0 5 5 4 24-3-1-5-13v-7l-2-5z",
    fill: "#D984AD"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(610,895)",
    d: "m0 0h1l4 26 1 10 2 10v7h-1l-2-11-3-16-1-9-2-1z",
    fill: "#C14476"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(792,1285)",
    d: "m0 0h7l2 5h2l1-2v3l-20-1-7 1h-6v-1l12-2z",
    fill: "#A9406C"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,732)",
    d: "m0 0 2 1v11l-2 30-2 1v-4l-3-1 3-8 1-26z",
    fill: "#6A0B2D"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(234,1284)",
    d: "m0 0h37l16 1 13 2v1l-36-1-32-1z",
    fill: "#76163B"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(17,1256)",
    d: "m0 0 10 2 8 2v2l-8-1 1 3-8-1-7-2 2-4z",
    fill: "#BC5A84"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(701,1110)",
    d: "m0 0 2 1v2h2l5 15v2h2l2 10 3 7v5l-2-2-5-12-2-9-3-4-4-13z",
    fill: "#D183A4"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,621)",
    d: "m0 0 2 3 5 31 2 24-2-2-3-24-3-19z",
    fill: "#D780AA"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(784,1289)",
    d: "m0 0 20 2v1l-31 2h-11l-1-2 3-1 18-1z",
    fill: "#982650"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(108,1249)",
    d: "m0 0h22l18 1v1l-13 1v1h-14l-15-2z",
    fill: "#821137"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,814)",
    d: "m0 0 3 1 2 16 2 7 1 11 3 17v8l-2-4-6-38z",
    fill: "#CE8DA4"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(629,686)",
    d: "m0 0h1l1 20v13l2 1v12l1 11h-2l-3-22z",
    fill: "#FAE6ED"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(801,1282)",
    d: "m0 0 13 1 10 1v2h-2l-1 4v-3h-3l1 4-4 1-2-2v-3l-5-2-3 1-2 2z",
    fill: "#861E45"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,129)",
    d: "m0 0 5 1 5 5 1 5v7h-2l-5-6-2-9z",
    fill: "#FEFEFE"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(507,1217)",
    d: "m0 0h2v11l2 22 1 4-2 2-3-9 1-7h-2z",
    fill: "#A63C68"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(629,671)",
    d: "m0 0 2 4 1 10 1 34h-2l-2-33z",
    fill: "#D9E5DF"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,633)",
    d: "m0 0h3l3 13v13l-2 1v-6h-2l-1-2z",
    fill: "#C24678"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,1197)",
    d: "m0 0 3 1-1 7-1 3-1 8 2 5-4 2-1 6h-1v-15l1-2h2l-2-9 1-3h2z",
    fill: "#861B42"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,1217)",
    d: "m0 0 3 1 4 12 3 2 3 9 2 3v3h2l2 4-1 3-4-5-3-4-4-11-7-14z",
    fill: "#A53B67"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(556,1164)",
    d: "m0 0 2 4 3 9 7 25 2 6v6h-1l-3-10-4-13-2-9-4-13z",
    fill: "#A63966"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(916,920)",
    d: "m0 0h1v14l-5 5h-5l2-5z",
    fill: "#A1D1C5"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,835)",
    d: "m0 0h1v22l-1 17-2 1-1-2 1-23 1-14z",
    fill: "#C14779"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,663)",
    d: "m0 0 1 4 1 17-2 11v13l-2-4v-35z",
    fill: "#BE4B7B"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(414,593)",
    d: "m0 0h3l1 4-1 22-1 8h-1v-14l-1 8h-1v-13l1-11z",
    fill: "#D67CA7"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(404,1283)",
    d: "m0 0 1 4 9 1 3 3v2h-6v-2l-4 2-1 2h-2v-2h-6l3-1 1-6z",
    fill: "#821F45"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,1269)",
    d: "m0 0 5 1 2 2 1-2h2l2 3 3 1v2l-10 3-6-4 2-1z",
    fill: "#851A41"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(273,1195)",
    d: "m0 0 2 1v7l-5 8-2 2-4-1 2-7h2v-2h2l2-7z",
    fill: "#690523"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,973)",
    d: "m0 0 2 1 4 27v13l-2-3-4-29z",
    fill: "#E693BA"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,938)",
    d: "m0 0 2 1 2 14 1 2 1 7 1 5 2 13h-2v-2h-3l1-7-2-6-2-18-1-5z",
    fill: "#C23E70"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,787)",
    d: "m0 0 2 4h2l3 15v8l-2 2-2-5-2-15z",
    fill: "#EFC5C9"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,594)",
    d: "m0 0 4 4 1 3 1 17-4-1-2-12z",
    fill: "#EEA2C6"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(764,1297)",
    d: "m0 0h12l3 1 13 1v1h-44l-2-2h15z",
    fill: "#852E54"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,1283)",
    d: "m0 0h5l3 5 8 2v2l-16 2-1-5h7l-3-3-1 2-5-2z",
    fill: "#A02D58"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(211,1284)",
    d: "m0 0 14 2v2h2v2h-15l-9-2-1-3z",
    fill: "#5E0520"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(543,1243)",
    d: "m0 0 3 1 1 6-1 1v27l3 3-5-1-1-1z",
    fill: "#E694BC"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(189,935)",
    d: "m0 0 4 2 1 1h29l-2 5-1-2-28 1-3-4z",
    fill: "#FDFCFC"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,630)",
    d: "m0 0h1l1 17 3 1-2 1 1 8v15l-1 6h-1v-13l-2-12z",
    fill: "#F2C8CC"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,1014)",
    d: "m0 0 2 4 5 35v5l-2-3-1-2-3-21-1-2-1-10z",
    fill: "#E692B6"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(478,688)",
    d: "m0 0h1v31h-3v-26z",
    fill: "#A4335F"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,635)",
    d: "m0 0 2 1v38l-1 6-2-3v-41z",
    fill: "#A83461"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,934)",
    d: "m0 0h1l5 38v11h-1l-1-8-1-1-3-26z",
    fill: "#C35F8C"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(610,969)",
    d: "m0 0h2l3 22v13l-2-3-3-21z",
    fill: "#EEA0C6"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(481,818)",
    d: "m0 0h1l1 13 1 16v13l-2-1-1-10z",
    fill: "#A63662"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,1281)",
    d: "m0 0h7l-2 2-12 3-1 1-14 2h-6l4-2 12-4z",
    fill: "#BF5986"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(232,921)",
    d: "m0 0h1v14l-4 4h-6l8-16z",
    fill: "#A1D1C5"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,672)",
    d: "m0 0 2 2 1 11v25l-3-1z",
    fill: "#EEB1C8"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(567,359)",
    d: "m0 0 1 4-4 12-2 3h-2v6l-3 3-4-1 1-7h2v2h2l2-5 2-3 2-9z",
    fill: "#D984AE"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(606,1268)",
    d: "m0 0 16 6-4 1h-2l2 3-1 1 5 1-1 2-10-3-3-2 3-1-5-5z",
    fill: "#BA5380"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,1175)",
    d: "m0 0 4 1 1 4h2l1 12-2-4-1-3-4-2-1 13-2-4 1-16z",
    fill: "#A83461"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(558,1101)",
    d: "m0 0 3 2 2 8v3h2v9l-1-2-3 3-3-14z",
    fill: "#9C244E"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(873,935)",
    d: "m0 0 4 3 29 1-2 3h-24l-4 1-3-5z",
    fill: "#FEFDFD"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(515,694)",
    d: "m0 0h1v9h2l1 25 1 2-2 8h-1l-2-32z",
    fill: "#D77FA9"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(457,499)",
    d: "m0 0 4 1v6l4 4v5l-4 2v-4l-3-1-2-5v-3z",
    fill: "#A63C68"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(70,1267)",
    d: "m0 0h28v1l-14 2 4 3-7-1-5 1v-2l-5-2z",
    fill: "#711236"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,1178)",
    d: "m0 0 5 5 3 7 2 9h-3l-5-10v-4h-2z",
    fill: "#861B42"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,1271)",
    d: "m0 0 6 1 3 2 13 1 5 2v2l-6-1-7 3-4-2v-2l-10-5z",
    fill: "#711B3F"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,1185)",
    d: "m0 0 1 2h2l6 15 3 8 1 5h-2l-4-9-3-7v-5h-2l-2-5z",
    fill: "#E9B0C2"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(655,980)",
    d: "m0 0h1l1 11 2 9v3h2l1 16-3-3-2-14-2-9z",
    fill: "#C23E70"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(360,936)",
    d: "m0 0h1l1 6h2v7l-2 3h1l-1 8-2 3h-2z",
    fill: "#7A183D"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(516,824)",
    d: "m0 0h1l1 20h2l1 18v11l-2 2-2-30-1-2z",
    fill: "#D77EA9"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(840,904)",
    d: "m0 0 1 3h18l1 3-19 1-3 3-2-1z",
    fill: "#F1C3C0"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,305)",
    d: "m0 0h1l-1 10-7 8-8 6-4 5-3 6-1-3 4-8 9-8 7-5z",
    fill: "#DCE9E2"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(158,1272)",
    d: "m0 0 12 1 8 3v2l-4 1-16-3-2-2z",
    fill: "#9A244F"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,1253)",
    d: "m0 0 2 4-1 2-6-2-11-1-36-1v-1h42l10 1z",
    fill: "#DD9FB5"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(567,1142)",
    d: "m0 0 4 2 1 4-1 2 3 1 1 5 1 10h-2l-1-7-2-3-1-5-3 1-1-8z",
    fill: "#821A41"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,1076)",
    d: "m0 0 4 1 3 14 2 8 1 5-4-2-1-5-2-12-2-1z",
    fill: "#C23E70"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(161,1276)",
    d: "m0 0 14 2 9-1 4 2-2 2h-15l-7-1z",
    fill: "#7C1E42"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(236,1271)",
    d: "m0 0 11 2h7l3 2-10 2-9-1-2-1v2l-5-1-1-3h5z",
    fill: "#821B41"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(662,1211)",
    d: "m0 0h2v2l3 1 4 6 5 8 1 3 5 5-1 2-6-5-5-9-6-8z",
    fill: "#D377A2"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,1205)",
    d: "m0 0 3 2 1 6h2l4 7 4 8-1 3-2-5h-2l-6-10-3-6z",
    fill: "#C04879"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(156,905)",
    d: "m0 0 1 2 18-1 1 4h-19l-1 3h-2l1-5z",
    fill: "#F1C3BF"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,718)",
    d: "m0 0h2l1 19h2l1 8v9l-1-2h-2l-3-31z",
    fill: "#F3B1CF"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(113,1236)",
    d: "m0 0h14l7 1 1 1 13 2v1h-17l-1-3h-20z",
    fill: "#EBABC4"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,549)",
    d: "m0 0 2 3 2 10 1 17-4-5v-12l-1-2z",
    fill: "#D67CA7"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,1266)",
    d: "m0 0 2 1-2 2 5 1-1 2h-2l-2 4-1 1h-6l-1-5z",
    fill: "#A3335E"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,887)",
    d: "m0 0 1 4 2 5 1 9 1 3-1 4-1 13h-1l-2-25-1-12z",
    fill: "#D77FA9"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,582)",
    d: "m0 0 2 1 2 7 4 27-1 4-5-24-3-14z",
    fill: "#D880AA"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,1240)",
    d: "m0 0 4 2 9 8 5 6h-3v2h-2v-2l-3-1v-6h-6l-3-6z",
    fill: "#841A41"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(406,964)",
    d: "m0 0h2l1 16-4 10h-1v-17l1-1z",
    fill: "#A73763"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,899)",
    d: "m0 0 2 1 1 6v26l-2-3-1-10z",
    fill: "#A63864"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,839)",
    d: "m0 0h1v21l-1 7-2 1-1-7 1-10 1-11z",
    fill: "#A73562"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(304,1289)",
    d: "m0 0h25l3 2-5 1h-14l-9-1z",
    fill: "#640826"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(236,1275)",
    d: "m0 0 14 1v1l31 1v1h-40l-5-2z",
    fill: "#79163C"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,1043)",
    d: "m0 0h2l6 41v6h-1l-4-21-2-17-1-2z",
    fill: "#BD5784"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(511,865)",
    d: "m0 0h1l2 17 1 13v10h-1l-2-7-1-16z",
    fill: "#A63A66"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(919,1275)",
    d: "m0 0 5 1 1 3-8 2v-2l-3 1-17-1 1-3 2 1h15z",
    fill: "#C4608D"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(366,1044)",
    d: "m0 0h1v9l-4 26-1 6h-1v-10l2-14 1-11z",
    fill: "#A63A66"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(530,1282)",
    d: "m0 0h8l-2 3h-30l4-2z",
    fill: "#EA99BB"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(221,1268)",
    d: "m0 0 25 3-1 2-8-1-4 2-4 1-6-4v-2z",
    fill: "#9E2853"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,1269)",
    d: "m0 0h9l9 2 1 3-7-2 2 4-10-1v-2l-4-2z",
    fill: "#BA5380"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313,1259)",
    d: "m0 0h2l-1 3h-2l-2 4-5 4-9 2-4-1 11-5 4-1 2-4z",
    fill: "#851A41"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(143,1255)",
    d: "m0 0 21 1 8 1v2l2 2-6-1-21-2-4-1z",
    fill: "#9B2752"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(739,1218)",
    d: "m0 0 4 2 4 9 4 8-1 2-2 1v-3h-2l-4-11-3-6z",
    fill: "#BA517F"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(717,1152)",
    d: "m0 0 2 2 3 7 3 11 4 9-1 3-3-3-4-13-3-9z",
    fill: "#D683A9"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(536,1284)",
    d: "m0 0h19l14 4 4 2v1h-5v-2l-9-1-23-3z",
    fill: "#C35F8B"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(731,1265)",
    d: "m0 0h9l5 1-4 2h-11l-13 2h-5l-1-3z",
    fill: "#C15684"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,1249)",
    d: "m0 0 7 2 2 3v2l4 1 6 5v3l-5-2-4-3v-2l-4-2z",
    fill: "#E692B7"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,1188)",
    d: "m0 0 3 4 5 13 6 10-1 4-4-7v-2h-2l-3-6-2-5-2-6z",
    fill: "#760C2E"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(594,968)",
    d: "m0 0h1l1 8 1 5 2 12 1 1 1 13-2 1-4-24-1-5z",
    fill: "#A63C68"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(524,916)",
    d: "m0 0h1l4 30v11l-2-3-2-23-1-6z",
    fill: "#D67CA7"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(421,763)",
    d: "m0 0 2 2-1 12v17l-2-3-1-13 1-13z",
    fill: "#A73461"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(629,721)",
    d: "m0 0h1l3 22 1 10-1-3h-2l-1-7h-1l-1-8v-5h2z",
    fill: "#EFB1C6"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,681)",
    d: "m0 0h1l2 21v9h-2l-1-2-1-18z",
    fill: "#F3B5D0"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,603)",
    d: "m0 0h1l1 13-2 25h-1l-1-11v-9l1-3v-12z",
    fill: "#D67DA7"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(133,1253)",
    d: "m0 0 9 1 1 3 10 1v2l-17-1 1-2-8-1-2-1z",
    fill: "#A53662"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(316,1237)",
    d: "m0 0 1 4-2 5h2v-3l5-3-2 5-3 3h-2l-1 4-5 4h-2l8-16z",
    fill: "#A63C68"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,639)",
    d: "m0 0h2l2 12 2 10 1 10-2-3-3-12-2-12z",
    fill: "#E89BC0"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(242,1257)",
    d: "m0 0h6l1 2-2 3 2 2h-8l-1-3-10 1 1-2 7-2z",
    fill: "#A63C68"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(542,1243)",
    d: "m0 0 2 4v32 3h-6l4-2-1-32z",
    fill: "#D983AD"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,494)",
    d: "m0 0h1l1 14v23h-2l-1-15z",
    fill: "#C25E8A"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,888)",
    d: "m0 0h2l4 21 1 14-2-3-5-26z",
    fill: "#EEC3C3"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(515,617)",
    d: "m0 0h1l1 26 1 15-2-1-3-10 1-1z",
    fill: "#D67CA7"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(170,1251)",
    d: "m0 0 9 2 1 2h-6l-1 2-11-2-2-2z",
    fill: "#600522"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,1166)",
    d: "m0 0 3 1 7 17-1 3-1 2h-2l-1-8-5-11z",
    fill: "#E09EB6"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,985)",
    d: "m0 0 2 2 1 11 2 1v18h-1l-1-9-3-10z",
    fill: "#D67EA9"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(423,738)",
    d: "m0 0h1v19l-1 1v5l-3-3 1-17z",
    fill: "#A73461"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,558)",
    d: "m0 0 1 2h2v2h2l1 6-4-1v-2h-2l-2 5-2 2-1-4z",
    fill: "#D67CA7"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,1279)",
    d: "m0 0h30l-4 2-4 1h-22l-7-1v-1z",
    fill: "#CF6E9A"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,1277)",
    d: "m0 0h12l7 2v2l2 1-1 2-7-2-4-2-12-1z",
    fill: "#D1739F"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539,1237)",
    d: "m0 0 2 1 1 1v38h-1l-2-33z",
    fill: "#D67CA7"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(341,1211)",
    d: "m0 0 1 3-1 2h-2l-2 6-2 5h-2l-2 4-4 2v-3l5-5 5-10z",
    fill: "#A63B67"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,1198)",
    d: "m0 0 3 2 6 18 1 4-4-4-4-8z",
    fill: "#D479A4"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(808,973)",
    d: "m0 0h2l5 10-1 2-7-3-1-1 1-7z",
    fill: "#F9ECE2"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,1265)",
    d: "m0 0h29l6 2-4 1h-27l-2 1-4-3z",
    fill: "#90264F"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,1249)",
    d: "m0 0 7 6 9 8 7 4v1h-5l-3-3-9-6-4-6z",
    fill: "#C35E8B"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(466,954)",
    d: "m0 0h2l2 13-1 9-2 1-1-6z",
    fill: "#A63C68"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(899,948)",
    d: "m0 0h2l-2 6-1 2-3-1h-14v-3l15-1z",
    fill: "#FCFCFB"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,573)",
    d: "m0 0 3 2 2 4 2 13v6l-3-1v-7l-2-5h2v-2h-2l-2-6z",
    fill: "#F0C6C9"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(502,503)",
    d: "m0 0h1l4 20 1 10-2-3-3-8-1-9z",
    fill: "#D67DA8"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,417)",
    d: "m0 0 4 3-1 2-5 4-2 9h-2l1 4-2 1v-6l1-4v-5l5-5z",
    fill: "#E690AD"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,1292)",
    d: "m0 0h6l9 2v1l-23 2-6-1v-1l11-1z",
    fill: "#9C2550"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,1250)",
    d: "m0 0 10 10 7 6h-3l-9-5-4-6z",
    fill: "#A63865"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(216,948)",
    d: "m0 0 2 1-4 8-2-2h-13l-2-1v-2h16l1-3z",
    fill: "#FDFDFD"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(526,862)",
    d: "m0 0h1v19h-3l-2-7 1-4h3z",
    fill: "#E38DAD"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(544,1297)",
    d: "m0 0h16l2 2-13 2-8-2z",
    fill: "#83274C"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(775,1274)",
    d: "m0 0h11l3 1-1 3-13-3zm11 4m-9 1h9l-2 2-10 1z",
    fill: "#EA98B9"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(716,1144)",
    d: "m0 0 3 3 7 20-2 2-4-9-4-13z",
    fill: "#E9B5BE"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,719)",
    d: "m0 0h1l2 22v7l-2-1-2-15v-12z",
    fill: "#D8E8E1"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,502)",
    d: "m0 0 5 2 1 3h6l4-4v6l-5 3-6-3-1-4-4-2z",
    fill: "#E690AD"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(652,1295)",
    d: "m0 0 13 1 2 4h-12v-2h-4z",
    fill: "#7B193E"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(71,1269)",
    d: "m0 0 5 2v2h4l1-2 13 4v1h-12l-7-2-5-2z",
    fill: "#82274C"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,657)",
    d: "m0 0 3 4 1 14h-1l-1 10h-1l-1-11z",
    fill: "#E9E5E3"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,603)",
    d: "m0 0h1l3 11 2 14 1 5-2 2-5-23z",
    fill: "#E692B8"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,1277)",
    d: "m0 0h5l5 2 2 3 14 1v1l-19 1v-4l-5-1v-2z",
    fill: "#D67EA8"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,792)",
    d: "m0 0h1l3 14 2 15-2-1-4-17z",
    fill: "#D883AD"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,648)",
    d: "m0 0h1l1 13-3 23h-1v-12z",
    fill: "#9E2752"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,556)",
    d: "m0 0 2 4 2 16v9h-2l-2-16z",
    fill: "#D1739F"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,169)",
    d: "m0 0h5l2 4-2 1-12 1-1-2z",
    fill: "#702E4F"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(530,969)",
    d: "m0 0 3 1 1 2 1 12-2 2-2-2-1-5z",
    fill: "#D57BA6"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(414,870)",
    d: "m0 0h2l-1 26-2-4-1-4 1-17z",
    fill: "#A73663"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,590)",
    d: "m0 0 2 3 1 19-3-4-1-6v-11z",
    fill: "#E897BF"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(452,1278)",
    d: "m0 0h2l3 11-1 1h-5v-11z",
    fill: "#A43561"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,1173)",
    d: "m0 0 6 3v2h2v4h2l2 10-2-2v-3h-2l-4-7-2-2v-3h-2z",
    fill: "#791035"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(855,1286)",
    d: "m0 0 2 4-7 2v1l5 1v1h-13l-3-2 10-3 5-2z",
    fill: "#892950"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(597 1e3)",
    d: "m0 0h2v5h2l2 3 1 8-2-1-2 2-3-11z",
    fill: "#A5315D"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,855)",
    d: "m0 0h1l1 30 2 3-3 5h-1z",
    fill: "#F2C7C5"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,599)",
    d: "m0 0 3 1v7l2 2-1 6h-3l-1-7z",
    fill: "#E997BE"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(11,1265)",
    d: "m0 0h1v5l-1 1 5 3v2l-10-1-2-1 1-3 5-1z",
    fill: "#B65C7F"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(703,1101)",
    d: "m0 0h2l5 13 3 7-4 2-3-11-3-8z",
    fill: "#D1798C"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(161,1022)",
    d: "m0 0h16l3 1-1 3-17-1z",
    fill: "#F1C3BE"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,973)",
    d: "m0 0h3v27h-1l-2-20z",
    fill: "#A63965"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,1292)",
    d: "m0 0h32l-1 3-31-2z",
    fill: "#A63C68"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(405,931)",
    d: "m0 0 1 2v23h-2l-1 4-1-11 1-4 1-13z",
    fill: "#C04879"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,555)",
    d: "m0 0h2v31h-1l-1-8-1-21z",
    fill: "#E694BD"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(501,139)",
    d: "m0 0h2l1 7 5 2 1 7-3-1-2-5-4-3v-3l-2-1z",
    fill: "#7F284C"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(425,1293)",
    d: "m0 0 11 1 8 2v1h-21l3-1z",
    fill: "#8A284F"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(878,1276)",
    d: "m0 0h10l-3 2-6 2h-15l1-2z",
    fill: "#E690AD"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(46,1256)",
    d: "m0 0h15l1 3h-17z",
    fill: "#A02C57"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,1046)",
    d: "m0 0 2 3-1 7-2 7-3-1 2-11z",
    fill: "#851A41"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,998)",
    d: "m0 0h1l2 23h-2l-2-7v-10z",
    fill: "#EC9DC2"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(678,998)",
    d: "m0 0 2 4 1 10-1-3h-3l-2-3v-6z",
    fill: "#E79BBE"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(125,975)",
    d: "m0 0 3 1 2 4-1 4-6-2-1-5z",
    fill: "#FBF0E3"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(620,606)",
    d: "m0 0h1l2 17v5l-3-1-2-9 2-1z",
    fill: "#F1B6CC"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(513,579)",
    d: "m0 0 2 2 1 15v12h-1l-2-11v-12l1-2-2-1z",
    fill: "#D67CA7"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,140)",
    d: "m0 0 4 5 6 3-4 10h-2l-1-11-3-2z",
    fill: "#C8829C"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,1279)",
    d: "m0 0 1 3 10 3 4 3-9-1-8-3 1-4z",
    fill: "#E18AAB"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,1268)",
    d: "m0 0 5 1 6 1v1h-33l4-2h17z",
    fill: "#A12D59"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,1143)",
    d: "m0 0 2 2v4h2l1 11-3-1-3-12z",
    fill: "#E28EB6"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(413,686)",
    d: "m0 0h1v21l-1 16h-1l-1-18 1-3z",
    fill: "#D67CA7"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(323,1278)",
    d: "m0 0h18l3 2h-16l1 3-7-1z",
    fill: "#D478A3"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(900,1272)",
    d: "m0 0h13l11 2 2 1 2 5h-5l2-1-3-3-10-1-1-1-11-1z",
    fill: "#F0B9CA"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(615,1253)",
    d: "m0 0 4 2 7 8-1 5-3-2-3-5-4-6z",
    fill: "#881B43"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(709,1129)",
    d: "m0 0 3 1 2 10 3 7v5l-2-2-5-12z",
    fill: "#D387A7"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(593,979)",
    d: "m0 0h2l3 17v7l-2-2z",
    fill: "#A83461"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,899)",
    d: "m0 0h2l2 7v18h-1l-2-15z",
    fill: "#A73562"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,836)",
    d: "m0 0h1v21h-2l-1 3 1-22z",
    fill: "#610623"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(815,1292)",
    d: "m0 0 5 1 2 3-8 2-8-1v-2h7z",
    fill: "#7A183D"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,1267)",
    d: "m0 0 4 1 11 6 3 3v2l2 1-5-1v-2l-4-2-11-7z",
    fill: "#680523"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(44,1265)",
    d: "m0 0 15 1v1l-8 1v1h-7l-14-2v-1h10l4 1z",
    fill: "#872149"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(187,1250)",
    d: "m0 0h21l2 2-5 1-7-1h-13z",
    fill: "#75153A"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,1133)",
    d: "m0 0h1v20l-3 5h-1l1-11z",
    fill: "#A73763"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(647,859)",
    d: "m0 0 2 1 3 20 1 5-2 1-2-6z",
    fill: "#D882AD"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,578)",
    d: "m0 0h1l2 14v6l-2 2-2-6z",
    fill: "#E691B3"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(383,1282)",
    d: "m0 0h2v2l-2 2 2 2h-10l1-4-2-1z",
    fill: "#E693BB"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(106,1271)",
    d: "m0 0 5 1 14 1v1h-17l3 2v2l-4-1-4-2 1-3z",
    fill: "#711337"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(776,1265)",
    d: "m0 0 3 1 2 3 7 3 1 2-17-1v-1l8-1-4-4z",
    fill: "#BD5783"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,1099)",
    d: "m0 0 3 1 2 8v10l-2-3-3-14z",
    fill: "#A73663"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(379,934)",
    d: "m0 0h2l-1 20-1 7h-1v-21z",
    fill: "#A63B67"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(646,814)",
    d: "m0 0 3 1 2 16 2 7-1 2h-2z",
    fill: "#D088A4"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,468)",
    d: "m0 0h2l1 10v15h-1v-11h-2z",
    fill: "#E694BD"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(452,1293)",
    d: "m0 0h5l-3 2-5 2-11-1-2-2z",
    fill: "#B14976"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,1215)",
    d: "m0 0 3 4 2 9v3l-5-7-2-8z",
    fill: "#DC82A6"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,1025)",
    d: "m0 0h1l4 20v3h-2l-3-14z",
    fill: "#C23E70"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,926)",
    d: "m0 0 3 1v13l-1 2h-2z",
    fill: "#A73461"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(343,876)",
    d: "m0 0h1v11l-1 6h-1v-7l-4-1z",
    fill: "#E39975"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(367,775)",
    d: "m0 0h1l-1 17-2-3-1-5 1-7z",
    fill: "#701237"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(550,476)",
    d: "m0 0 2 1v3h2v6l-3 7h-1z",
    fill: "#DA84AE"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(371,1278)",
    d: "m0 0 7 2 12 1v1l-23 1 3-2z",
    fill: "#CF6E9A"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(127,1275)",
    d: "m0 0h7v3l-4 1-5 1-11-2 1-2 12 2z",
    fill: "#6E1035"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(522,1169)",
    d: "m0 0h3l3 5 4 10-1 4v-3h-2l-3-7-2-4v-4z",
    fill: "#A63966"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(458,1096)",
    d: "m0 0 3 2 1 4-2 7-3-1v-7z",
    fill: "#861B42"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(396,1037)",
    d: "m0 0 2 4-2 14-3 1 1-13z",
    fill: "#9D244F"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,1027)",
    d: "m0 0h1l2 14v5l-3 1-1-8z",
    fill: "#C5628E"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(401,982)",
    d: "m0 0 2 1-3 14-2 3v-10l2-7z",
    fill: "#C14678"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,898)",
    d: "m0 0h2v9l-4 4-1-9 2-1z",
    fill: "#690523"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(645,851)",
    d: "m0 0 2 2 1 9 1 12h-1l-4-18z",
    fill: "#D57CA7"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,675)",
    d: "m0 0h1l3 22h-3l-2-15z",
    fill: "#EFADC6"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,246)",
    d: "m0 0 3 2-1 6-4 2v-2h-2l1-2v-3-2z",
    fill: "#CD6C98"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(472,1289)",
    d: "m0 0h5l-1 2-6 2h-13l3-2z",
    fill: "#B54E7A"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,1279)",
    d: "m0 0h3v2l-8 2h-9v-2l3-1z",
    fill: "#E894B3"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,1278)",
    d: "m0 0 12 1 4-1v4l-16-1z",
    fill: "#630725"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,1273)",
    d: "m0 0 13 3-4 1 2 4-9-2 2-2z",
    fill: "#D1739E"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(153,1258)",
    d: "m0 0h9l8 2 1 2-11-1-7-1z",
    fill: "#B9527F"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(759,1246)",
    d: "m0 0 3 1 2 5 5 6 2 1v2l3 1-2 1-8-7-4-5z",
    fill: "#DB85AC"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,1184)",
    d: "m0 0 1 4-3 13-2 4h-2l1-6z",
    fill: "#7C1D42"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(391,1079)",
    d: "m0 0h1v11l-4 11-1-4 2-9 1-5z",
    fill: "#A63C68"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(614,1014)",
    d: "m0 0 2 4 1 6v9l-3-3-1-10z",
    fill: "#E693BA"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,721)",
    d: "m0 0h2l1 19-2 2-2-19z",
    fill: "#E692B8"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,1292)",
    d: "m0 0h25l4 1v2l-27-1z",
    fill: "#A02D59"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,971)",
    d: "m0 0h1v9l-1 2v7l-2-4-2-13 3 1z",
    fill: "#EEC2C3"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(414,816)",
    d: "m0 0h1v14l-1 16h-1l-1-17 1-1z",
    fill: "#BC4E7D"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(363,1289)",
    d: "m0 0h15l12 1v3h-3v-2l-7 1-4-1-13-1z",
    fill: "#8E2850"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(721,1289)",
    d: "m0 0 14 1 3 2h-24v-1h7z",
    fill: "#CF6E9A"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(22,1264)",
    d: "m0 0 8 1v3 2l-4 1v-2h-7l3-3v-1z",
    fill: "#7B1A3F"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(19,1264)",
    d: "m0 0h2l-1 4 6 1-2 3-7-1-2-6z",
    fill: "#6F1136"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(558,1101)",
    d: "m0 0 3 2 1 2v7l-2 3-2-5z",
    fill: "#8A1D45"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(588,887)",
    d: "m0 0 2 2 1 10v12l-1-4-2-1v-12l-1-6z",
    fill: "#C14678"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,486)",
    d: "m0 0 2 1 1 8-3 1-1 2-1-9z",
    fill: "#CF6F9B"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(745,1269)",
    d: "m0 0 6 2 7 3 4 2-5 2-5-3-7-5z",
    fill: "#BD4776"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(134,1272)",
    d: "m0 0 10 1 1-1h6l-4 1v2h-12l-10-1v-1z",
    fill: "#952851"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(552,1263)",
    d: "m0 0 3 1 4 8 5 6 3 2-6-1-6-9-3-5z",
    fill: "#E592B9"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,1252)",
    d: "m0 0h2l2 11 2 1 1 5-2 1-3-6-3-10z",
    fill: "#A83461"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(97,1244)",
    d: "m0 0 2 1-4 5v2l-9 2v-3l4-2z",
    fill: "#BF6389"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(664,1230)",
    d: "m0 0 2 1v2l4 2 5 7-1 2-9-9-2-4z",
    fill: "#D479A4"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(545,1217)",
    d: "m0 0 3 1 4 12 3 2-1 2-3-1-6-13z",
    fill: "#A73764"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(480,1159)",
    d: "m0 0h1v11l1 1 1 10-3-3-1-11z",
    fill: "#A83461"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,1100)",
    d: "m0 0 2 4 4 10v6l-2-1-4-13z",
    fill: "#E493BB"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(667,969)",
    d: "m0 0h2l2 7v9l-3-3z",
    fill: "#D882AC"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,958)",
    d: "m0 0h1l2 14v11h-1l-1-8-1-1z",
    fill: "#BE5986"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(377,961)",
    d: "m0 0h1v9h-2l-1 10h-1v-12z",
    fill: "#A73561"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(586,786)",
    d: "m0 0h1l2 12v12l-2-4-1-6z",
    fill: "#D67CA7"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,711)",
    d: "m0 0 1 4h2l1 8h-2v5h-1l-1-5z",
    fill: "#D77FAA"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625,626)",
    d: "m0 0 2 2 1 7v9h-2l-1-7-1-2z",
    fill: "#E1DAD6"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,516)",
    d: "m0 0h2v11l-2 1-3-7 2-1z",
    fill: "#781A3F"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(564,1289)",
    d: "m0 0h4l-1 8 2 1h-9l1-2h5v-3h-5z",
    fill: "#9E2753"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(796,1285)",
    d: "m0 0 4 1 1 4h2l1-2v3h-8l-3-2 3-1z",
    fill: "#A3345F"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(237,1281)",
    d: "m0 0 8 1 1 3h-11l-2-2z",
    fill: "#94254E"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(19,1258)",
    d: "m0 0h8l8 2v2l-11-1h-3z",
    fill: "#CF6E9A"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749,1228)",
    d: "m0 0 4 5 2 5 4 4-1 4-3-5-3-3-3-7z",
    fill: "#E69BBC"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(691,1069)",
    d: "m0 0h2l2 7v9l-3-4-2-10z",
    fill: "#D184A4"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,983)",
    d: "m0 0h1v6h2l1 7v8h-1v-5h-2z",
    fill: "#D780AB"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(632,782)",
    d: "m0 0h3l2 8-1 9h-1z",
    fill: "#D67DA8"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(404,633)",
    d: "m0 0h1v15l-1 10h-1l-1-11z",
    fill: "#A3345F"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(549,468)",
    d: "m0 0 1 3h2l1 9-2-3-1 5-2-3v-8z",
    fill: "#E796BE"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(818,1296)",
    d: "m0 0h12v1h-8v2h-16v-1z",
    fill: "#96365E"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(289,1284)",
    d: "m0 0h9l7 2v1h-12l-4-1z",
    fill: "#9F2A56"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(161,1276)",
    d: "m0 0 13 2 4 3h-7l-7-1z",
    fill: "#74173B"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(100,1277)",
    d: "m0 0h12l6 2v1h-12l-7-1z",
    fill: "#5F0521"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(101,1255)",
    d: "m0 0 14 1 4-1 4 3h-15l-7-2z",
    fill: "#A43763"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(601,1216)",
    d: "m0 0h3l4 7 4 5 2 1-1 3-5-5v-2h-3l-2-5v-3z",
    fill: "#861B42"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(567,1142)",
    d: "m0 0 4 2 1 4-3 4h-2l-1-8z",
    fill: "#801C42"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,1106)",
    d: "m0 0 2 4 2 9 1 5-3-1-2-10z",
    fill: "#C24375"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(370,732)",
    d: "m0 0 2 1v11l-1 1-1 8h-1v-17z",
    fill: "#6F1136"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(532,669)",
    d: "m0 0h1v14l-1 5v7l-2-1v-12z",
    fill: "#C23E70"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,313)",
    d: "m0 0 4 2 2 8-2 5h-1z",
    fill: "#A53B67"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(404,1283)",
    d: "m0 0 1 4 5 1-3 3-5 1-1-3z",
    fill: "#9E2853"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(469,1273)",
    d: "m0 0h9l4 3h-9l-3-1-6 2v-2z",
    fill: "#D67CA7"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(707,1120)",
    d: "m0 0h2l3 5 2 9-2-1v-3h-2l-3-8z",
    fill: "#E8ABBE"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(685,1049)",
    d: "m0 0 2 1 2 11-2 1-3-7z",
    fill: "#D67CA7"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(676,1007)",
    d: "m0 0 1 2h2v7l2 2-2 4v-3l-3-1z",
    fill: "#D984AE"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(294,938)",
    d: "m0 0h2l-1 10-3-1-1-5z",
    fill: "#F2C3BE"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(337,886)",
    d: "m0 0h5v7l-2 2-3-5z",
    fill: "#F6E1D8"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(623,719)",
    d: "m0 0 2 1 2 10v7h-1l-3-10z",
    fill: "#D984AE"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,1281)",
    d: "m0 0h7l-2 2-12 3-3-1 5-3z",
    fill: "#AB3E6A"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,1281)",
    d: "m0 0 10 3 13 1v1h-15l-6-1z",
    fill: "#E796BB"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,1279)",
    d: "m0 0 5 1 11 2v1h-15z",
    fill: "#9F2B56"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(115,1270)",
    d: "m0 0h10v3h-14z",
    fill: "#9D244F"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(20,1255)",
    d: "m0 0h16l-1 2h-5l-1 1-9-1z",
    fill: "#AB436E"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(577,1171)",
    d: "m0 0 3 1v3h2l3 5v2l-4-2-4-5z",
    fill: "#8E1E46"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(504,1111)",
    d: "m0 0 2 2 3 16-1 4-2-5-2-12z",
    fill: "#A83461"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(495,1036)",
    d: "m0 0 2 2 1 8-1 11h-1l-1-10z",
    fill: "#A63A66"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(608,973)",
    d: "m0 0 2 1 1 6v9h-2l-1-7z",
    fill: "#E692B5"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,942)",
    d: "m0 0 2 2 2 12v7l-2-3-1-9-1-2z",
    fill: "#A53B67"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,919)",
    d: "m0 0h2l1 11-1 8-2-3z",
    fill: "#A83461"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,896)",
    d: "m0 0 1 2h2v11l-2 3-1-7z",
    fill: "#E692B7"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,738)",
    d: "m0 0 3 3v9h2v3h-3l-2-7z",
    fill: "#E795BE"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,545)",
    d: "m0 0 3 1 1 6-3 1-1 2-1-1v-7z",
    fill: "#EFC4C4"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(439,329)",
    d: "m0 0 2 3 2-1 1 7-2 2-1 2-2-5z",
    fill: "#A53864"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,210)",
    d: "m0 0h1v13l-4 1 1-5 1-8z",
    fill: "#D883AD"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(575,1291)",
    d: "m0 0 16 1v3l-9-1-7-2z",
    fill: "#9D2752"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,1291)",
    d: "m0 0h3v2l5 1-1 2h-8v-4z",
    fill: "#6E1034"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(423,1288)",
    d: "m0 0 13 2 7 2v1h-8l-12-4z",
    fill: "#E690AD"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,1276)",
    d: "m0 0 9 2 3 2-7 1-6-2z",
    fill: "#B9507D"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,1275)",
    d: "m0 0 5 1 4 1v2l-6-1-5 2-2-3z",
    fill: "#681434"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,1272)",
    d: "m0 0h8l1 3-1 1h-8l-2-3z",
    fill: "#851A41"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(798,1264)",
    d: "m0 0 3 2v2h-12v-2l-2-1 11 1z",
    fill: "#A83966"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(629,1249)",
    d: "m0 0 3 1 5 6h-3v2h-2v-2l-3-1z",
    fill: "#861B42"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,1221)",
    d: "m0 0 2 3 4 10v5l-4-4-2-10z",
    fill: "#A63B67"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(592,1201)",
    d: "m0 0 3 1 2 6h2l1 6-4-3-4-7z",
    fill: "#861B42"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,1195)",
    d: "m0 0 4 3 3 13-3-2v-6h-2l-2-4z",
    fill: "#680929"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(607,1059)",
    d: "m0 0 2 3v2l2 1h-2l2 8v6h-1l-3-12z",
    fill: "#A73461"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(686,1032)",
    d: "m0 0h1l1 9-2 4-3-5 1-4z",
    fill: "#E395BA"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(639,765)",
    d: "m0 0h1l2 11v5l-1-2h-2l-1-12z",
    fill: "#D9E5DF"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,703)",
    d: "m0 0h1l1 18-2-2-1-4v-8z",
    fill: "#E694BD"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,651)",
    d: "m0 0 2 1-3 16-2-4 1-10z",
    fill: "#C23E70"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(579,601)",
    d: "m0 0h1l2 6v11l-2 3-1-6 1-6-2-3z",
    fill: "#DC87AD"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(245,1282)",
    d: "m0 0 15 1-1 2h-13z",
    fill: "#9F2A56"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(893,1281)",
    d: "m0 0 4 1-3 2h-10l-7-1v-1z",
    fill: "#A83B67"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(555,1264)",
    d: "m0 0 3 1 3 7 4 5-1 2-6-7-3-6z",
    fill: "#D77FAA"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(75,1267)",
    d: "m0 0h23v1l-16 2-7-2z",
    fill: "#78183D"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(604,1217)",
    d: "m0 0 5 2 3 7 2 1v2l-4-2-6-8z",
    fill: "#78163B"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(874,944)",
    d: "m0 0 3 1 3 7h-4l-4-6z",
    fill: "#EE867C"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(191,944)",
    d: "m0 0h2l3 6v2l-4-1v-2l-3-1v-3z",
    fill: "#EE867C"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(406,929)",
    d: "m0 0 2 3-2 17h-1v-16z",
    fill: "#BA5380"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,857)",
    d: "m0 0h1v17l-2 1-1-2v-6l1-1z",
    fill: "#BE4B7B"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,781)",
    d: "m0 0h3l1 10-3 1z",
    fill: "#E9D7D9"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,698)",
    d: "m0 0h2l1 9-1 8h-1l-1-10z",
    fill: "#D883AD"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(825,1293)",
    d: "m0 0h13v2l-4 1h-7z",
    fill: "#762346"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(540,1294)",
    d: "m0 0h6l7 1 1 2h-15l-1-2z",
    fill: "#7B193E"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(462,1292)",
    d: "m0 0 6 1v1l-9 1v2l-6-1 1-2z",
    fill: "#9E2854"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(807,1284)",
    d: "m0 0 4 2-1 4h-5l-1-5 3 1z",
    fill: "#6D0F33"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(23,1270)",
    d: "m0 0h7l7 2v2l-7-1h-4z",
    fill: "#660827"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(13,1261)",
    d: "m0 0 11 2v3l2 2-4-1-1-3-4 1h-4l-1-2z",
    fill: "#892950"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(671,1225)",
    d: "m0 0 5 3 1 3 5 5-1 2-6-5-4-6z",
    fill: "#DE88B0"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(864,1021)",
    d: "m0 0v3l-2 3v-2h-7l-1-2z",
    fill: "#F1C3BF"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(659,931)",
    d: "m0 0 4 1v14h-1l-2-10z",
    fill: "#D984AE"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(573,800)",
    d: "m0 0h1v8l3 1v7l-2 1-2-6-1-10z",
    fill: "#A63B67"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,127)",
    d: "m0 0h10l2 2-5 1h-9l-3 1v-2z",
    fill: "#D8D5D2"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(520,1278)",
    d: "m0 0 4 1 2 1 12 1v1h-17z",
    fill: "#A93E6A"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(632,1277)",
    d: "m0 0 5 1 4 3-2 1-12-3v-1z",
    fill: "#E18BAC"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(705,1264)",
    d: "m0 0 5 2 6 2-4 2-8-2z",
    fill: "#E28AA9"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,1249)",
    d: "m0 0 7 2 2 3 1 4-4-2z",
    fill: "#E690AE"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(669,1192)",
    d: "m0 0h3l4 9-1 3-2-1-4-9z",
    fill: "#C24476"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,1158)",
    d: "m0 0h1l2 7 2 9-2-2-1-6h-2l-1 2v-8z",
    fill: "#DC84AD"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(340,1152)",
    d: "m0 0 1 2-1 8-2 1-2 4 1-10z",
    fill: "#7D2045"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,1113)",
    d: "m0 0h1l3 14-1 4-3-7z",
    fill: "#A63966"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(392,1042)",
    d: "m0 0 1 3h2l-1 9-3 2z",
    fill: "#BF4A7A"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(147,1020)",
    d: "m0 0 4 4 1 5-4-1-2-5z",
    fill: "#FCFAF9"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(870,992)",
    d: "m0 0h1l2 15-3 3z",
    fill: "#F0C3C1"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(581,560)",
    d: "m0 0h1l1 10-1 2h-2l-1 2 1-10z",
    fill: "#E690AD"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(284,1287)",
    d: "m0 0h3v2l-9 1-1 2-1-3-3-1z",
    fill: "#630724"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(84,1251)",
    d: "m0 0h5l-3 4h-4l-1 3-1-5z",
    fill: "#A7406A"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(627,1188)",
    d: "m0 0 3 4 3 7-1 4v-2h-2l-3-8z",
    fill: "#7B0B2E"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,1172)",
    d: "m0 0h2l4 9-1 3-3-3z",
    fill: "#CE86A3"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(978,938)",
    d: "m0 0h1v7l-1 2-3-1 1-7z",
    fill: "#F2C3BE"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,805)",
    d: "m0 0h1v5h2l-1 7 1 6h-2l-1-11z",
    fill: "#D67EA9"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(423,559)",
    d: "m0 0h1l1 8 1 5-1 5h-1l-1-6z",
    fill: "#A73764"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,540)",
    d: "m0 0h2l2 9v5l-2-1-2-8z",
    fill: "#FEFEFE"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(498,460)",
    d: "m0 0h2l1 6v12h-1v-10h-2z",
    fill: "#D984AE"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(335,1285)",
    d: "m0 0 9 1 4 2h-13z",
    fill: "#B54D7A"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,1283)",
    d: "m0 0h5l2 4-4-1-1 2-5-2z",
    fill: "#A02954"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,1273)",
    d: "m0 0h5l4 4-8 1v-3z",
    fill: "#CA6995"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,1250)",
    d: "m0 0 5 5 2 5h-3l-4-8z",
    fill: "#A63A66"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(128,1242)",
    d: "m0 0h11l-1 2-8 1-3-2z",
    fill: "#CF6E9A"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(748,1231)",
    d: "m0 0h2l3 9 3 1 1 4-5-4-4-8z",
    fill: "#CF6F9B"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,839)",
    d: "m0 0 3 1 2 7-2 4-2-4 1-5h-2z",
    fill: "#D77FA9"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(418,736)",
    d: "m0 0h2l-1 8-1 7h-1l-1-6z",
    fill: "#C04879"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,701)",
    d: "m0 0 3 1v9h-2l-1-2z",
    fill: "#F4BCD3"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,573)",
    d: "m0 0 3 2 2 4v5l-3-1-2-6z",
    fill: "#F0C5C6"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(856,1286)",
    d: "m0 0 5 1h4v2l-7 1-2-1z",
    fill: "#820D32"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(206,1245)",
    d: "m0 0 4 1v2l-4 2h-6l3-3z",
    fill: "#80284D"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(333,1224)",
    d: "m0 0h2v3h-2l-2 4-4 2v-3l5-5z",
    fill: "#A73864"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,1059)",
    d: "m0 0 2 4v8h2v6l-2-1-2-12z",
    fill: "#D67CA7"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(687,1041)",
    d: "m0 0 2 2 2 11-2 4z",
    fill: "#E9A5C0"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1022)",
    d: "m0 0 2 1 1 13-2-2-1-4z",
    fill: "#E7ABBD"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365 1e3)",
    d: "m0 0h2v10l-3-1v-7z",
    fill: "#861B42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg-2.5a817310e6cfd31a6e9611b2da08b93f.svg";
export { ForwardRef as ReactComponent };